import { openBlock as W, createElementBlock as re, createElementVNode as te, defineComponent as Q, createVNode as se, unref as j, normalizeClass as Ee, createBlock as ve, renderSlot as dt, cloneVNode as Vo, h as Te, Fragment as rt, inject as lt, provide as et, ref as z, onMounted as Ie, watchEffect as Xe, nextTick as ze, computed as k, toRaw as Fe, watch as Je, onUnmounted as ht, Teleport as Hy, reactive as Gy, shallowRef as xa, resolveDirective as No, withDirectives as _a, createCommentVNode as Oe, toDisplayString as De, isRef as qn, withCtx as le, createTextVNode as vt, renderList as rn, mergeProps as tn, vModelText as jy, Transition as Uo, resolveDynamicComponent as Pc, getCurrentScope as Ky, onScopeDispose as qy, shallowReadonly as pr, toRef as Vf, onBeforeUnmount as Yy, withModifiers as Zy } from "vue";
const Jy = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, Xy = /* @__PURE__ */ te("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M12 3a9 9 0 1 0 9 9"
}, null, -1), Qy = [
  Xy
];
function eb(t, i) {
  return W(), re("svg", Jy, Qy);
}
const tb = { name: "tune-spinner", render: eb }, nb = { class: "flex items-center" }, Lc = /* @__PURE__ */ Q({
  __name: "TuneLoadingSpinner",
  setup(t) {
    return (i, r) => (W(), re("div", nb, [
      se(j(tb), { class: "h-[22px] animate-spin" })
    ]));
  }
}), rb = ["type", "disabled"], Sa = /* @__PURE__ */ Q({
  __name: "TuneButton",
  props: {
    type: { default: "button" },
    primary: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (i, r) => (W(), re("button", {
      type: t.type,
      class: Ee([
        "tune-button",
        {
          primary: t.primary,
          disabled: t.disabled
        }
      ]),
      disabled: t.disabled || t.loading
    }, [
      t.loading ? (W(), ve(Lc, { key: 0 })) : dt(i.$slots, "default", { key: 1 })
    ], 10, rb));
  }
});
function Ce(t, i, ...r) {
  if (t in i) {
    let l = i[t];
    return typeof l == "function" ? l(...r) : l;
  }
  let u = new Error(`Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(i).map((l) => `"${l}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(u, Ce), u;
}
var pt = ((t) => (t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static", t))(pt || {}), In = ((t) => (t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))(In || {});
function $e({ visible: t = !0, features: i = 0, ourProps: r, theirProps: u, ...l }) {
  var o;
  let f = Dc(u, r), c = Object.assign(l, { props: f });
  if (t || i & 2 && f.static)
    return oo(c);
  if (i & 1) {
    let v = (o = f.unmount) == null || o ? 0 : 1;
    return Ce(v, { [0]() {
      return null;
    }, [1]() {
      return oo({ ...l, props: { ...f, hidden: !0, style: { display: "none" } } });
    } });
  }
  return oo(c);
}
function oo({ props: t, attrs: i, slots: r, slot: u, name: l }) {
  var o, f;
  let { as: c, ...v } = yr(t, ["unmount", "static"]), d = (o = r.default) == null ? void 0 : o.call(r, u), h = {};
  if (u) {
    let m = !1, y = [];
    for (let [w, x] of Object.entries(u))
      typeof x == "boolean" && (m = !0), x === !0 && y.push(w);
    m && (h["data-headlessui-state"] = y.join(" "));
  }
  if (c === "template") {
    if (d = Rc(d ?? []), Object.keys(v).length > 0 || Object.keys(i).length > 0) {
      let [m, ...y] = d ?? [];
      if (!ib(m) || y.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${l} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(v).concat(Object.keys(i)).map((S) => S.trim()).filter((S, _, A) => A.indexOf(S) === _).sort((S, _) => S.localeCompare(_)).map((S) => `  - ${S}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((S) => `  - ${S}`).join(`
`)].join(`
`));
      let w = Dc((f = m.props) != null ? f : {}, v), x = Vo(m, w);
      for (let S in w)
        S.startsWith("on") && (x.props || (x.props = {}), x.props[S] = w[S]);
      return x;
    }
    return Array.isArray(d) && d.length === 1 ? d[0] : d;
  }
  return Te(c, Object.assign({}, v, h), { default: () => d });
}
function Rc(t) {
  return t.flatMap((i) => i.type === rt ? Rc(i.children) : [i]);
}
function Dc(...t) {
  if (t.length === 0)
    return {};
  if (t.length === 1)
    return t[0];
  let i = {}, r = {};
  for (let u of t)
    for (let l in u)
      l.startsWith("on") && typeof u[l] == "function" ? (r[l] != null || (r[l] = []), r[l].push(u[l])) : i[l] = u[l];
  if (i.disabled || i["aria-disabled"])
    return Object.assign(i, Object.fromEntries(Object.keys(r).map((u) => [u, void 0])));
  for (let u in r)
    Object.assign(i, { [u](l, ...o) {
      let f = r[u];
      for (let c of f) {
        if (l instanceof Event && l.defaultPrevented)
          return;
        c(l, ...o);
      }
    } });
  return i;
}
function zo(t) {
  let i = Object.assign({}, t);
  for (let r in i)
    i[r] === void 0 && delete i[r];
  return i;
}
function yr(t, i = []) {
  let r = Object.assign({}, t);
  for (let u of i)
    u in r && delete r[u];
  return r;
}
function ib(t) {
  return t == null ? !1 : typeof t.type == "string" || typeof t.type == "object" || typeof t.type == "function";
}
let ab = 0;
function lb() {
  return ++ab;
}
function ke() {
  return lb();
}
var ae = ((t) => (t.Space = " ", t.Enter = "Enter", t.Escape = "Escape", t.Backspace = "Backspace", t.Delete = "Delete", t.ArrowLeft = "ArrowLeft", t.ArrowUp = "ArrowUp", t.ArrowRight = "ArrowRight", t.ArrowDown = "ArrowDown", t.Home = "Home", t.End = "End", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Tab = "Tab", t))(ae || {});
function ob(t) {
  throw new Error("Unexpected object: " + t);
}
var me = ((t) => (t[t.First = 0] = "First", t[t.Previous = 1] = "Previous", t[t.Next = 2] = "Next", t[t.Last = 3] = "Last", t[t.Specific = 4] = "Specific", t[t.Nothing = 5] = "Nothing", t))(me || {});
function Wo(t, i) {
  let r = i.resolveItems();
  if (r.length <= 0)
    return null;
  let u = i.resolveActiveIndex(), l = u ?? -1, o = (() => {
    switch (t.focus) {
      case 0:
        return r.findIndex((f) => !i.resolveDisabled(f));
      case 1: {
        let f = r.slice().reverse().findIndex((c, v, d) => l !== -1 && d.length - v - 1 >= l ? !1 : !i.resolveDisabled(c));
        return f === -1 ? f : r.length - 1 - f;
      }
      case 2:
        return r.findIndex((f, c) => c <= l ? !1 : !i.resolveDisabled(f));
      case 3: {
        let f = r.slice().reverse().findIndex((c) => !i.resolveDisabled(c));
        return f === -1 ? f : r.length - 1 - f;
      }
      case 4:
        return r.findIndex((f) => i.resolveId(f) === t.id);
      case 5:
        return null;
      default:
        ob(t);
    }
  })();
  return o === -1 ? u : o;
}
function U(t) {
  var i;
  return t == null || t.value == null ? null : (i = t.value.$el) != null ? i : t.value;
}
let Mc = Symbol("Context");
var Le = ((t) => (t[t.Open = 1] = "Open", t[t.Closed = 2] = "Closed", t[t.Closing = 4] = "Closing", t[t.Opening = 8] = "Opening", t))(Le || {});
function ub() {
  return Rn() !== null;
}
function Rn() {
  return lt(Mc, null);
}
function ai(t) {
  et(Mc, t);
}
function Nf(t, i) {
  if (t)
    return t;
  let r = i ?? "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function li(t, i) {
  let r = z(Nf(t.value.type, t.value.as));
  return Ie(() => {
    r.value = Nf(t.value.type, t.value.as);
  }), Xe(() => {
    var u;
    r.value || U(i) && U(i) instanceof HTMLButtonElement && !((u = U(i)) != null && u.hasAttribute("type")) && (r.value = "button");
  }), r;
}
var sb = Object.defineProperty, fb = (t, i, r) => i in t ? sb(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, Uf = (t, i, r) => (fb(t, typeof i != "symbol" ? i + "" : i, r), r);
let cb = class {
  constructor() {
    Uf(this, "current", this.detect()), Uf(this, "currentId", 0);
  }
  set(i) {
    this.current !== i && (this.currentId = 0, this.current = i);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, oi = new cb();
function Zt(t) {
  if (oi.isServer)
    return null;
  if (t instanceof Node)
    return t.ownerDocument;
  if (t != null && t.hasOwnProperty("value")) {
    let i = U(t);
    if (i)
      return i.ownerDocument;
  }
  return document;
}
function Bc({ container: t, accept: i, walk: r, enabled: u }) {
  Xe(() => {
    let l = t.value;
    if (!l || u !== void 0 && !u.value)
      return;
    let o = Zt(t);
    if (!o)
      return;
    let f = Object.assign((v) => i(v), { acceptNode: i }), c = o.createTreeWalker(l, NodeFilter.SHOW_ELEMENT, f, !1);
    for (; c.nextNode(); )
      r(c.currentNode);
  });
}
let xo = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((t) => `${t}:not([tabindex='-1'])`).join(",");
var at = ((t) => (t[t.First = 1] = "First", t[t.Previous = 2] = "Previous", t[t.Next = 4] = "Next", t[t.Last = 8] = "Last", t[t.WrapAround = 16] = "WrapAround", t[t.NoScroll = 32] = "NoScroll", t))(at || {}), ti = ((t) => (t[t.Error = 0] = "Error", t[t.Overflow = 1] = "Overflow", t[t.Success = 2] = "Success", t[t.Underflow = 3] = "Underflow", t))(ti || {}), db = ((t) => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(db || {});
function ui(t = document.body) {
  return t == null ? [] : Array.from(t.querySelectorAll(xo)).sort((i, r) => Math.sign((i.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var si = ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(si || {});
function fi(t, i = 0) {
  var r;
  return t === ((r = Zt(t)) == null ? void 0 : r.body) ? !1 : Ce(i, { [0]() {
    return t.matches(xo);
  }, [1]() {
    let u = t;
    for (; u !== null; ) {
      if (u.matches(xo))
        return !0;
      u = u.parentElement;
    }
    return !1;
  } });
}
function kc(t) {
  let i = Zt(t);
  ze(() => {
    i && !fi(i.activeElement, 0) && Fn(t);
  });
}
function Fn(t) {
  t == null || t.focus({ preventScroll: !0 });
}
let vb = ["textarea", "input"].join(",");
function pb(t) {
  var i, r;
  return (r = (i = t == null ? void 0 : t.matches) == null ? void 0 : i.call(t, vb)) != null ? r : !1;
}
function $a(t, i = (r) => r) {
  return t.slice().sort((r, u) => {
    let l = i(r), o = i(u);
    if (l === null || o === null)
      return 0;
    let f = l.compareDocumentPosition(o);
    return f & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : f & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function hb(t, i) {
  return Nt(ui(), i, { relativeTo: t });
}
function Nt(t, i, { sorted: r = !0, relativeTo: u = null, skipElements: l = [] } = {}) {
  var o;
  let f = (o = Array.isArray(t) ? t.length > 0 ? t[0].ownerDocument : document : t == null ? void 0 : t.ownerDocument) != null ? o : document, c = Array.isArray(t) ? r ? $a(t) : t : ui(t);
  l.length > 0 && c.length > 1 && (c = c.filter((x) => !l.includes(x))), u = u ?? f.activeElement;
  let v = (() => {
    if (i & 5)
      return 1;
    if (i & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = (() => {
    if (i & 1)
      return 0;
    if (i & 2)
      return Math.max(0, c.indexOf(u)) - 1;
    if (i & 4)
      return Math.max(0, c.indexOf(u)) + 1;
    if (i & 8)
      return c.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), h = i & 32 ? { preventScroll: !0 } : {}, m = 0, y = c.length, w;
  do {
    if (m >= y || m + y <= 0)
      return 0;
    let x = d + m;
    if (i & 16)
      x = (x + y) % y;
    else {
      if (x < 0)
        return 3;
      if (x >= y)
        return 1;
    }
    w = c[x], w == null || w.focus(h), m += v;
  } while (w !== f.activeElement);
  return i & 6 && pb(w) && w.select(), w.hasAttribute("tabindex") || w.setAttribute("tabindex", "0"), 2;
}
function uo(t, i, r) {
  oi.isServer || Xe((u) => {
    document.addEventListener(t, i, r), u(() => document.removeEventListener(t, i, r));
  });
}
function ci(t, i, r = k(() => !0)) {
  function u(o, f) {
    if (!r.value || o.defaultPrevented)
      return;
    let c = f(o);
    if (c === null || !c.getRootNode().contains(c))
      return;
    let v = function d(h) {
      return typeof h == "function" ? d(h()) : Array.isArray(h) || h instanceof Set ? h : [h];
    }(t);
    for (let d of v) {
      if (d === null)
        continue;
      let h = d instanceof HTMLElement ? d : U(d);
      if (h != null && h.contains(c) || o.composed && o.composedPath().includes(h))
        return;
    }
    return !fi(c, si.Loose) && c.tabIndex !== -1 && o.preventDefault(), i(o, c);
  }
  let l = z(null);
  uo("mousedown", (o) => {
    var f, c;
    r.value && (l.value = ((c = (f = o.composedPath) == null ? void 0 : f.call(o)) == null ? void 0 : c[0]) || o.target);
  }, !0), uo("click", (o) => {
    l.value && (u(o, () => l.value), l.value = null);
  }, !0), uo("blur", (o) => u(o, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var an = ((t) => (t[t.None = 1] = "None", t[t.Focusable = 2] = "Focusable", t[t.Hidden = 4] = "Hidden", t))(an || {});
let yn = Q({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(t, { slots: i, attrs: r }) {
  return () => {
    let { features: u, ...l } = t, o = { "aria-hidden": (u & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(u & 4) === 4 && (u & 2) !== 2 && { display: "none" } } };
    return $e({ ourProps: o, theirProps: l, slot: {}, attrs: r, slots: i, name: "Hidden" });
  };
} });
function Ho(t = {}, i = null, r = []) {
  for (let [u, l] of Object.entries(t))
    Nc(r, Vc(i, u), l);
  return r;
}
function Vc(t, i) {
  return t ? t + "[" + i + "]" : i;
}
function Nc(t, i, r) {
  if (Array.isArray(r))
    for (let [u, l] of r.entries())
      Nc(t, Vc(i, u.toString()), l);
  else
    r instanceof Date ? t.push([i, r.toISOString()]) : typeof r == "boolean" ? t.push([i, r ? "1" : "0"]) : typeof r == "string" ? t.push([i, r]) : typeof r == "number" ? t.push([i, `${r}`]) : r == null ? t.push([i, ""]) : Ho(r, i, t);
}
function mb(t) {
  var i;
  let r = (i = t == null ? void 0 : t.form) != null ? i : t.closest("form");
  if (r) {
    for (let u of r.elements)
      if (u.tagName === "INPUT" && u.type === "submit" || u.tagName === "BUTTON" && u.type === "submit" || u.nodeName === "INPUT" && u.type === "image") {
        u.click();
        return;
      }
  }
}
function Go(t, i, r) {
  let u = z(r == null ? void 0 : r.value), l = k(() => t.value !== void 0);
  return [k(() => l.value ? t.value : u.value), function(o) {
    return l.value || (u.value = o), i == null ? void 0 : i(o);
  }];
}
function zf(t) {
  return [t.screenX, t.screenY];
}
function jo() {
  let t = z([-1, -1]);
  return { wasMoved(i) {
    let r = zf(i);
    return t.value[0] === r[0] && t.value[1] === r[1] ? !1 : (t.value = r, !0);
  }, update(i) {
    t.value = zf(i);
  } };
}
function Uc() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function gb() {
  return /Android/gi.test(window.navigator.userAgent);
}
function yb() {
  return Uc() || gb();
}
function bb(t, i) {
  return t === i;
}
var wb = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(wb || {}), xb = ((t) => (t[t.Single = 0] = "Single", t[t.Multi = 1] = "Multi", t))(xb || {}), _b = ((t) => (t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))(_b || {});
let zc = Symbol("ComboboxContext");
function br(t) {
  let i = lt(zc, null);
  if (i === null) {
    let r = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, br), r;
  }
  return i;
}
let Wc = Q({ name: "Combobox", emits: { "update:modelValue": (t) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => bb }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, name: { type: String }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(t, { slots: i, attrs: r, emit: u }) {
  let l = z(1), o = z(null), f = z(null), c = z(null), v = z(null), d = z({ static: !1, hold: !1 }), h = z([]), m = z(null), y = z(1), w = z(!1);
  function x(R = (V) => V) {
    let V = m.value !== null ? h.value[m.value] : null, M = $a(R(h.value.slice()), (K) => U(K.dataRef.domRef)), H = V ? M.indexOf(V) : null;
    return H === -1 && (H = null), { options: M, activeOptionIndex: H };
  }
  let S = k(() => t.multiple ? 1 : 0), _ = k(() => t.nullable), [A, T] = Go(k(() => t.modelValue === void 0 ? Ce(S.value, { [1]: [], [0]: void 0 }) : t.modelValue), (R) => u("update:modelValue", R), k(() => t.defaultValue)), E = { comboboxState: l, value: A, mode: S, compare(R, V) {
    if (typeof t.by == "string") {
      let M = t.by;
      return (R == null ? void 0 : R[M]) === (V == null ? void 0 : V[M]);
    }
    return t.by(R, V);
  }, defaultValue: k(() => t.defaultValue), nullable: _, inputRef: f, labelRef: o, buttonRef: c, optionsRef: v, disabled: k(() => t.disabled), options: h, change(R) {
    T(R);
  }, activeOptionIndex: k(() => {
    if (w.value && m.value === null && h.value.length > 0) {
      let R = h.value.findIndex((V) => !V.dataRef.disabled);
      if (R !== -1)
        return R;
    }
    return m.value;
  }), activationTrigger: y, optionsPropsRef: d, closeCombobox() {
    w.value = !1, !t.disabled && l.value !== 1 && (l.value = 1, m.value = null);
  }, openCombobox() {
    if (w.value = !0, t.disabled || l.value === 0)
      return;
    let R = h.value.findIndex((V) => {
      let M = Fe(V.dataRef.value);
      return Ce(S.value, { [0]: () => E.compare(Fe(E.value.value), Fe(M)), [1]: () => Fe(E.value.value).some((H) => E.compare(Fe(H), Fe(M))) });
    });
    R !== -1 && (m.value = R), l.value = 0;
  }, goToOption(R, V, M) {
    if (w.value = !1, t.disabled || v.value && !d.value.static && l.value === 1)
      return;
    let H = x();
    if (H.activeOptionIndex === null) {
      let Y = H.options.findIndex((ee) => !ee.dataRef.disabled);
      Y !== -1 && (H.activeOptionIndex = Y);
    }
    let K = Wo(R === me.Specific ? { focus: me.Specific, id: V } : { focus: R }, { resolveItems: () => H.options, resolveActiveIndex: () => H.activeOptionIndex, resolveId: (Y) => Y.id, resolveDisabled: (Y) => Y.dataRef.disabled });
    m.value = K, y.value = M ?? 1, h.value = H.options;
  }, selectOption(R) {
    let V = h.value.find((H) => H.id === R);
    if (!V)
      return;
    let { dataRef: M } = V;
    T(Ce(S.value, { [0]: () => M.value, [1]: () => {
      let H = Fe(E.value.value).slice(), K = Fe(M.value), Y = H.findIndex((ee) => E.compare(K, Fe(ee)));
      return Y === -1 ? H.push(K) : H.splice(Y, 1), H;
    } }));
  }, selectActiveOption() {
    if (E.activeOptionIndex.value === null)
      return;
    let { dataRef: R, id: V } = h.value[E.activeOptionIndex.value];
    T(Ce(S.value, { [0]: () => R.value, [1]: () => {
      let M = Fe(E.value.value).slice(), H = Fe(R.value), K = M.findIndex((Y) => E.compare(H, Fe(Y)));
      return K === -1 ? M.push(H) : M.splice(K, 1), M;
    } })), E.goToOption(me.Specific, V);
  }, registerOption(R, V) {
    let M = { id: R, dataRef: V }, H = x((K) => [...K, M]);
    if (m.value === null) {
      let K = V.value.value;
      Ce(S.value, { [0]: () => E.compare(Fe(E.value.value), Fe(K)), [1]: () => Fe(E.value.value).some((Y) => E.compare(Fe(Y), Fe(K))) }) && (H.activeOptionIndex = H.options.indexOf(M));
    }
    h.value = H.options, m.value = H.activeOptionIndex, y.value = 1;
  }, unregisterOption(R) {
    var V;
    E.activeOptionIndex.value !== null && ((V = E.options.value[E.activeOptionIndex.value]) == null ? void 0 : V.id) === R && (w.value = !0);
    let M = x((H) => {
      let K = H.findIndex((Y) => Y.id === R);
      return K !== -1 && H.splice(K, 1), H;
    });
    h.value = M.options, m.value = M.activeOptionIndex, y.value = 1;
  } };
  ci([f, c, v], () => E.closeCombobox(), k(() => l.value === 0)), et(zc, E), ai(k(() => Ce(l.value, { [0]: Le.Open, [1]: Le.Closed })));
  let F = k(() => E.activeOptionIndex.value === null ? null : h.value[E.activeOptionIndex.value].dataRef.value), P = k(() => {
    var R;
    return (R = U(f)) == null ? void 0 : R.closest("form");
  });
  return Ie(() => {
    Je([P], () => {
      if (!P.value || t.defaultValue === void 0)
        return;
      function R() {
        E.change(t.defaultValue);
      }
      return P.value.addEventListener("reset", R), () => {
        var V;
        (V = P.value) == null || V.removeEventListener("reset", R);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: R, disabled: V, ...M } = t, H = { open: l.value === 0, disabled: V, activeIndex: E.activeOptionIndex.value, activeOption: F.value, value: A.value };
    return Te(rt, [...R != null && A.value != null ? Ho({ [R]: A.value }).map(([K, Y]) => Te(yn, zo({ features: an.Hidden, key: K, as: "input", type: "hidden", hidden: !0, readOnly: !0, name: K, value: Y }))) : [], $e({ theirProps: { ...r, ...yr(M, ["modelValue", "defaultValue", "nullable", "multiple", "onUpdate:modelValue", "by"]) }, ourProps: {}, slot: H, slots: i, attrs: r, name: "Combobox" })]);
  };
} }), Hc = Q({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-combobox-label-${ke()}` } }, setup(t, { attrs: i, slots: r }) {
  let u = br("ComboboxLabel");
  function l() {
    var o;
    (o = U(u.inputRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: u.comboboxState.value === 0, disabled: u.disabled.value }, { id: f, ...c } = t, v = { id: f, ref: u.labelRef, onClick: l };
    return $e({ ourProps: v, theirProps: c, slot: o, attrs: i, slots: r, name: "ComboboxLabel" });
  };
} }), va = Q({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-combobox-button-${ke()}` } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = br("ComboboxButton");
  u({ el: l.buttonRef, $el: l.buttonRef });
  function o(v) {
    l.disabled.value || (l.comboboxState.value === 0 ? l.closeCombobox() : (v.preventDefault(), l.openCombobox()), ze(() => {
      var d;
      return (d = U(l.inputRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    }));
  }
  function f(v) {
    switch (v.key) {
      case ae.ArrowDown:
        v.preventDefault(), v.stopPropagation(), l.comboboxState.value === 1 && l.openCombobox(), ze(() => {
          var d;
          return (d = l.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
      case ae.ArrowUp:
        v.preventDefault(), v.stopPropagation(), l.comboboxState.value === 1 && (l.openCombobox(), ze(() => {
          l.value.value || l.goToOption(me.Last);
        })), ze(() => {
          var d;
          return (d = l.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
      case ae.Escape:
        if (l.comboboxState.value !== 0)
          return;
        v.preventDefault(), l.optionsRef.value && !l.optionsPropsRef.value.static && v.stopPropagation(), l.closeCombobox(), ze(() => {
          var d;
          return (d = l.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let c = li(k(() => ({ as: t.as, type: i.type })), l.buttonRef);
  return () => {
    var v, d;
    let h = { open: l.comboboxState.value === 0, disabled: l.disabled.value, value: l.value.value }, { id: m, ...y } = t, w = { ref: l.buttonRef, id: m, type: c.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (v = U(l.optionsRef)) == null ? void 0 : v.id, "aria-expanded": l.disabled.value ? void 0 : l.comboboxState.value === 0, "aria-labelledby": l.labelRef.value ? [(d = U(l.labelRef)) == null ? void 0 : d.id, m].join(" ") : void 0, disabled: l.disabled.value === !0 ? !0 : void 0, onKeydown: f, onClick: o };
    return $e({ ourProps: w, theirProps: y, slot: h, attrs: i, slots: r, name: "ComboboxButton" });
  };
} }), Gc = Q({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: () => `headlessui-combobox-input-${ke()}` } }, emits: { change: (t) => !0 }, setup(t, { emit: i, attrs: r, slots: u, expose: l }) {
  let o = br("ComboboxInput"), f = { value: !1 };
  l({ el: o.inputRef, $el: o.inputRef });
  let c = k(() => {
    var S;
    let _ = o.value.value;
    return U(o.inputRef) ? typeof t.displayValue < "u" && _ !== void 0 ? (S = t.displayValue(_)) != null ? S : "" : typeof _ == "string" ? _ : "" : "";
  });
  Ie(() => {
    Je([c, o.comboboxState], ([S, _], [A, T]) => {
      if (f.value)
        return;
      let E = U(o.inputRef);
      E && (T === 0 && _ === 1 || S !== A) && (E.value = S);
    }, { immediate: !0 }), Je([o.comboboxState], ([S], [_]) => {
      if (S === 0 && _ === 1) {
        let A = U(o.inputRef);
        if (!A)
          return;
        let T = A.value, { selectionStart: E, selectionEnd: F, selectionDirection: P } = A;
        A.value = "", A.value = T, P !== null ? A.setSelectionRange(E, F, P) : A.setSelectionRange(E, F);
      }
    });
  });
  let v = z(!1);
  function d() {
    v.value = !0;
  }
  function h() {
    setTimeout(() => {
      v.value = !1;
    });
  }
  function m(S) {
    switch (f.value = !0, S.key) {
      case ae.Backspace:
      case ae.Delete:
        if (o.mode.value !== 0 || !o.nullable.value)
          return;
        let _ = S.currentTarget;
        requestAnimationFrame(() => {
          if (_.value === "") {
            o.change(null);
            let A = U(o.optionsRef);
            A && (A.scrollTop = 0), o.goToOption(me.Nothing);
          }
        });
        break;
      case ae.Enter:
        if (f.value = !1, o.comboboxState.value !== 0 || v.value)
          return;
        if (S.preventDefault(), S.stopPropagation(), o.activeOptionIndex.value === null) {
          o.closeCombobox();
          return;
        }
        o.selectActiveOption(), o.mode.value === 0 && o.closeCombobox();
        break;
      case ae.ArrowDown:
        return f.value = !1, S.preventDefault(), S.stopPropagation(), Ce(o.comboboxState.value, { [0]: () => o.goToOption(me.Next), [1]: () => o.openCombobox() });
      case ae.ArrowUp:
        return f.value = !1, S.preventDefault(), S.stopPropagation(), Ce(o.comboboxState.value, { [0]: () => o.goToOption(me.Previous), [1]: () => {
          o.openCombobox(), ze(() => {
            o.value.value || o.goToOption(me.Last);
          });
        } });
      case ae.Home:
        if (S.shiftKey)
          break;
        return f.value = !1, S.preventDefault(), S.stopPropagation(), o.goToOption(me.First);
      case ae.PageUp:
        return f.value = !1, S.preventDefault(), S.stopPropagation(), o.goToOption(me.First);
      case ae.End:
        if (S.shiftKey)
          break;
        return f.value = !1, S.preventDefault(), S.stopPropagation(), o.goToOption(me.Last);
      case ae.PageDown:
        return f.value = !1, S.preventDefault(), S.stopPropagation(), o.goToOption(me.Last);
      case ae.Escape:
        if (f.value = !1, o.comboboxState.value !== 0)
          return;
        S.preventDefault(), o.optionsRef.value && !o.optionsPropsRef.value.static && S.stopPropagation(), o.closeCombobox();
        break;
      case ae.Tab:
        if (f.value = !1, o.comboboxState.value !== 0)
          return;
        o.mode.value === 0 && o.selectActiveOption(), o.closeCombobox();
        break;
    }
  }
  function y(S) {
    o.openCombobox(), i("change", S);
  }
  function w() {
    f.value = !1;
  }
  let x = k(() => {
    var S, _, A, T;
    return (T = (A = (_ = t.defaultValue) != null ? _ : o.defaultValue.value !== void 0 ? (S = t.displayValue) == null ? void 0 : S.call(t, o.defaultValue.value) : null) != null ? A : o.defaultValue.value) != null ? T : "";
  });
  return () => {
    var S, _, A, T, E, F;
    let P = { open: o.comboboxState.value === 0 }, { id: R, displayValue: V, onChange: M, ...H } = t, K = { "aria-controls": (S = o.optionsRef.value) == null ? void 0 : S.id, "aria-expanded": o.disabled.value ? void 0 : o.comboboxState.value === 0, "aria-activedescendant": o.activeOptionIndex.value === null || (_ = o.options.value[o.activeOptionIndex.value]) == null ? void 0 : _.id, "aria-labelledby": (E = (A = U(o.labelRef)) == null ? void 0 : A.id) != null ? E : (T = U(o.buttonRef)) == null ? void 0 : T.id, "aria-autocomplete": "list", id: R, onCompositionstart: d, onCompositionend: h, onKeydown: m, onInput: y, onBlur: w, role: "combobox", type: (F = r.type) != null ? F : "text", tabIndex: 0, ref: o.inputRef, defaultValue: x.value };
    return $e({ ourProps: K, theirProps: H, slot: P, attrs: r, slots: u, features: pt.RenderStrategy | pt.Static, name: "ComboboxInput" });
  };
} }), jc = Q({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = br("ComboboxOptions"), o = `headlessui-combobox-options-${ke()}`;
  u({ el: l.optionsRef, $el: l.optionsRef }), Xe(() => {
    l.optionsPropsRef.value.static = t.static;
  }), Xe(() => {
    l.optionsPropsRef.value.hold = t.hold;
  });
  let f = Rn(), c = k(() => f !== null ? (f.value & Le.Open) === Le.Open : l.comboboxState.value === 0);
  return Bc({ container: k(() => U(l.optionsRef)), enabled: k(() => l.comboboxState.value === 0), accept(v) {
    return v.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : v.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(v) {
    v.setAttribute("role", "none");
  } }), () => {
    var v, d, h;
    let m = { open: l.comboboxState.value === 0 }, y = { "aria-labelledby": (h = (v = U(l.labelRef)) == null ? void 0 : v.id) != null ? h : (d = U(l.buttonRef)) == null ? void 0 : d.id, id: o, ref: l.optionsRef, role: "listbox", "aria-multiselectable": l.mode.value === 1 ? !0 : void 0 }, w = yr(t, ["hold"]);
    return $e({ ourProps: y, theirProps: w, slot: m, attrs: i, slots: r, features: pt.RenderStrategy | pt.Static, visible: c.value, name: "ComboboxOptions" });
  };
} }), Kc = Q({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 } }, setup(t, { slots: i, attrs: r, expose: u }) {
  let l = br("ComboboxOption"), o = `headlessui-combobox-option-${ke()}`, f = z(null);
  u({ el: f, $el: f });
  let c = k(() => l.activeOptionIndex.value !== null ? l.options.value[l.activeOptionIndex.value].id === o : !1), v = k(() => Ce(l.mode.value, { [0]: () => l.compare(Fe(l.value.value), Fe(t.value)), [1]: () => Fe(l.value.value).some((_) => l.compare(Fe(_), Fe(t.value))) })), d = k(() => ({ disabled: t.disabled, value: t.value, domRef: f }));
  Ie(() => l.registerOption(o, d)), ht(() => l.unregisterOption(o)), Xe(() => {
    l.comboboxState.value === 0 && c.value && l.activationTrigger.value !== 0 && ze(() => {
      var _, A;
      return (A = (_ = U(f)) == null ? void 0 : _.scrollIntoView) == null ? void 0 : A.call(_, { block: "nearest" });
    });
  });
  function h(_) {
    if (t.disabled)
      return _.preventDefault();
    l.selectOption(o), l.mode.value === 0 && l.closeCombobox(), yb() || requestAnimationFrame(() => {
      var A;
      return (A = U(l.inputRef)) == null ? void 0 : A.focus();
    });
  }
  function m() {
    if (t.disabled)
      return l.goToOption(me.Nothing);
    l.goToOption(me.Specific, o);
  }
  let y = jo();
  function w(_) {
    y.update(_);
  }
  function x(_) {
    y.wasMoved(_) && (t.disabled || c.value || l.goToOption(me.Specific, o, 0));
  }
  function S(_) {
    y.wasMoved(_) && (t.disabled || c.value && (l.optionsPropsRef.value.hold || l.goToOption(me.Nothing)));
  }
  return () => {
    let { disabled: _ } = t, A = { active: c.value, selected: v.value, disabled: _ }, T = { id: o, ref: f, role: "option", tabIndex: _ === !0 ? void 0 : -1, "aria-disabled": _ === !0 ? !0 : void 0, "aria-selected": v.value, disabled: void 0, onClick: h, onFocus: m, onPointerenter: w, onMouseenter: w, onPointermove: x, onMousemove: x, onPointerleave: S, onMouseleave: S };
    return $e({ ourProps: T, theirProps: t, slot: A, attrs: r, slots: i, name: "ComboboxOption" });
  };
} });
function Sb(t, i, r) {
  oi.isServer || Xe((u) => {
    window.addEventListener(t, i, r), u(() => window.removeEventListener(t, i, r));
  });
}
var It = ((t) => (t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))(It || {});
function Ko() {
  let t = z(0);
  return Sb("keydown", (i) => {
    i.key === "Tab" && (t.value = i.shiftKey ? 1 : 0);
  }), t;
}
function qo(t, i, r, u) {
  oi.isServer || Xe((l) => {
    t = t ?? window, t.addEventListener(i, r, u), l(() => t.removeEventListener(i, r, u));
  });
}
function qc(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((i) => setTimeout(() => {
    throw i;
  }));
}
function Yc(t) {
  if (!t)
    return /* @__PURE__ */ new Set();
  if (typeof t == "function")
    return new Set(t());
  let i = /* @__PURE__ */ new Set();
  for (let r of t.value) {
    let u = U(r);
    u instanceof HTMLElement && i.add(u);
  }
  return i;
}
var Zc = ((t) => (t[t.None = 1] = "None", t[t.InitialFocus = 2] = "InitialFocus", t[t.TabLock = 4] = "TabLock", t[t.FocusLock = 8] = "FocusLock", t[t.RestoreFocus = 16] = "RestoreFocus", t[t.All = 30] = "All", t))(Zc || {});
let Yr = Object.assign(Q({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: z(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = z(null);
  u({ el: l, $el: l });
  let o = k(() => Zt(l)), f = z(!1);
  Ie(() => f.value = !0), ht(() => f.value = !1), Ab({ ownerDocument: o }, k(() => f.value && !!(t.features & 16)));
  let c = Tb({ ownerDocument: o, container: l, initialFocus: k(() => t.initialFocus) }, k(() => f.value && !!(t.features & 2)));
  Cb({ ownerDocument: o, container: l, containers: t.containers, previousActiveElement: c }, k(() => f.value && !!(t.features & 8)));
  let v = Ko();
  function d(w) {
    let x = U(l);
    x && ((S) => S())(() => {
      Ce(v.value, { [It.Forwards]: () => {
        Nt(x, at.First, { skipElements: [w.relatedTarget] });
      }, [It.Backwards]: () => {
        Nt(x, at.Last, { skipElements: [w.relatedTarget] });
      } });
    });
  }
  let h = z(!1);
  function m(w) {
    w.key === "Tab" && (h.value = !0, requestAnimationFrame(() => {
      h.value = !1;
    }));
  }
  function y(w) {
    if (!f.value)
      return;
    let x = Yc(t.containers);
    U(l) instanceof HTMLElement && x.add(U(l));
    let S = w.relatedTarget;
    S instanceof HTMLElement && S.dataset.headlessuiFocusGuard !== "true" && (Jc(x, S) || (h.value ? Nt(U(l), Ce(v.value, { [It.Forwards]: () => at.Next, [It.Backwards]: () => at.Previous }) | at.WrapAround, { relativeTo: w.target }) : w.target instanceof HTMLElement && Fn(w.target)));
  }
  return () => {
    let w = {}, x = { ref: l, onKeydown: m, onFocusout: y }, { features: S, initialFocus: _, containers: A, ...T } = t;
    return Te(rt, [!!(S & 4) && Te(yn, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: d, features: an.Focusable }), $e({ ourProps: x, theirProps: { ...i, ...T }, slot: w, attrs: i, slots: r, name: "FocusTrap" }), !!(S & 4) && Te(yn, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: d, features: an.Focusable })]);
  };
} }), { features: Zc }), jn = [];
if (typeof window < "u" && typeof document < "u") {
  let t = function(i) {
    i.target instanceof HTMLElement && i.target !== document.body && jn[0] !== i.target && (jn.unshift(i.target), jn = jn.filter((r) => r != null && r.isConnected), jn.splice(10));
  };
  window.addEventListener("click", t, { capture: !0 }), window.addEventListener("mousedown", t, { capture: !0 }), window.addEventListener("focus", t, { capture: !0 }), document.body.addEventListener("click", t, { capture: !0 }), document.body.addEventListener("mousedown", t, { capture: !0 }), document.body.addEventListener("focus", t, { capture: !0 });
}
function $b(t) {
  let i = z(jn.slice());
  return Je([t], ([r], [u]) => {
    u === !0 && r === !1 ? qc(() => {
      i.value.splice(0);
    }) : u === !1 && r === !0 && (i.value = jn.slice());
  }, { flush: "post" }), () => {
    var r;
    return (r = i.value.find((u) => u != null && u.isConnected)) != null ? r : null;
  };
}
function Ab({ ownerDocument: t }, i) {
  let r = $b(i);
  Ie(() => {
    Xe(() => {
      var u, l;
      i.value || ((u = t.value) == null ? void 0 : u.activeElement) === ((l = t.value) == null ? void 0 : l.body) && Fn(r());
    }, { flush: "post" });
  }), ht(() => {
    Fn(r());
  });
}
function Tb({ ownerDocument: t, container: i, initialFocus: r }, u) {
  let l = z(null), o = z(!1);
  return Ie(() => o.value = !0), ht(() => o.value = !1), Ie(() => {
    Je([i, r, u], (f, c) => {
      if (f.every((d, h) => (c == null ? void 0 : c[h]) === d) || !u.value)
        return;
      let v = U(i);
      v && qc(() => {
        var d, h;
        if (!o.value)
          return;
        let m = U(r), y = (d = t.value) == null ? void 0 : d.activeElement;
        if (m) {
          if (m === y) {
            l.value = y;
            return;
          }
        } else if (v.contains(y)) {
          l.value = y;
          return;
        }
        m ? Fn(m) : Nt(v, at.First | at.NoScroll) === ti.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), l.value = (h = t.value) == null ? void 0 : h.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), l;
}
function Cb({ ownerDocument: t, container: i, containers: r, previousActiveElement: u }, l) {
  var o;
  qo((o = t.value) == null ? void 0 : o.defaultView, "focus", (f) => {
    if (!l.value)
      return;
    let c = Yc(r);
    U(i) instanceof HTMLElement && c.add(U(i));
    let v = u.value;
    if (!v)
      return;
    let d = f.target;
    d && d instanceof HTMLElement ? Jc(c, d) ? (u.value = d, Fn(d)) : (f.preventDefault(), f.stopPropagation(), Fn(v)) : Fn(u.value);
  }, !0);
}
function Jc(t, i) {
  for (let r of t)
    if (r.contains(i))
      return !0;
  return !1;
}
let so = /* @__PURE__ */ new Map(), Zr = /* @__PURE__ */ new Map();
function Wf(t, i = z(!0)) {
  Xe((r) => {
    var u;
    if (!i.value)
      return;
    let l = U(t);
    if (!l)
      return;
    r(function() {
      var f;
      if (!l)
        return;
      let c = (f = Zr.get(l)) != null ? f : 1;
      if (c === 1 ? Zr.delete(l) : Zr.set(l, c - 1), c !== 1)
        return;
      let v = so.get(l);
      v && (v["aria-hidden"] === null ? l.removeAttribute("aria-hidden") : l.setAttribute("aria-hidden", v["aria-hidden"]), l.inert = v.inert, so.delete(l));
    });
    let o = (u = Zr.get(l)) != null ? u : 0;
    Zr.set(l, o + 1), o === 0 && (so.set(l, { "aria-hidden": l.getAttribute("aria-hidden"), inert: l.inert }), l.setAttribute("aria-hidden", "true"), l.inert = !0);
  });
}
let Xc = Symbol("ForcePortalRootContext");
function Eb() {
  return lt(Xc, !1);
}
let _o = Q({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(t, { slots: i, attrs: r }) {
  return et(Xc, t.force), () => {
    let { force: u, ...l } = t;
    return $e({ theirProps: l, ourProps: {}, slot: {}, slots: i, attrs: r, name: "ForcePortalRoot" });
  };
} });
function Ob(t) {
  let i = Zt(t);
  if (!i) {
    if (t === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${t}`);
  }
  let r = i.getElementById("headlessui-portal-root");
  if (r)
    return r;
  let u = i.createElement("div");
  return u.setAttribute("id", "headlessui-portal-root"), i.body.appendChild(u);
}
let Yo = Q({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(t, { slots: i, attrs: r }) {
  let u = z(null), l = k(() => Zt(u)), o = Eb(), f = lt(Qc, null), c = z(o === !0 || f == null ? Ob(u.value) : f.resolveTarget());
  return Xe(() => {
    o || f != null && (c.value = f.resolveTarget());
  }), ht(() => {
    var v, d;
    let h = (v = l.value) == null ? void 0 : v.getElementById("headlessui-portal-root");
    h && c.value === h && c.value.children.length <= 0 && ((d = c.value.parentElement) == null || d.removeChild(c.value));
  }), () => {
    if (c.value === null)
      return null;
    let v = { ref: u, "data-headlessui-portal": "" };
    return Te(Hy, { to: c.value }, $e({ ourProps: v, theirProps: t, slot: {}, attrs: r, slots: i, name: "Portal" }));
  };
} }), Qc = Symbol("PortalGroupContext"), Ib = Q({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(t, { attrs: i, slots: r }) {
  let u = Gy({ resolveTarget() {
    return t.target;
  } });
  return et(Qc, u), () => {
    let { target: l, ...o } = t;
    return $e({ theirProps: o, ourProps: {}, slot: {}, attrs: i, slots: r, name: "PortalGroup" });
  };
} }), ed = Symbol("StackContext");
var So = ((t) => (t[t.Add = 0] = "Add", t[t.Remove = 1] = "Remove", t))(So || {});
function Fb() {
  return lt(ed, () => {
  });
}
function Pb({ type: t, enabled: i, element: r, onUpdate: u }) {
  let l = Fb();
  function o(...f) {
    u == null || u(...f), l(...f);
  }
  Ie(() => {
    Je(i, (f, c) => {
      f ? o(0, t, r) : c === !0 && o(1, t, r);
    }, { immediate: !0, flush: "sync" });
  }), ht(() => {
    i.value && o(1, t, r);
  }), et(ed, o);
}
let td = Symbol("DescriptionContext");
function Lb() {
  let t = lt(td, null);
  if (t === null)
    throw new Error("Missing parent");
  return t;
}
function nd({ slot: t = z({}), name: i = "Description", props: r = {} } = {}) {
  let u = z([]);
  function l(o) {
    return u.value.push(o), () => {
      let f = u.value.indexOf(o);
      f !== -1 && u.value.splice(f, 1);
    };
  }
  return et(td, { register: l, slot: t, name: i, props: r }), k(() => u.value.length > 0 ? u.value.join(" ") : void 0);
}
Q({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: () => `headlessui-description-${ke()}` } }, setup(t, { attrs: i, slots: r }) {
  let u = Lb();
  return Ie(() => ht(u.register(t.id))), () => {
    let { name: l = "Description", slot: o = z({}), props: f = {} } = u, { id: c, ...v } = t, d = { ...Object.entries(f).reduce((h, [m, y]) => Object.assign(h, { [m]: j(y) }), {}), id: c };
    return $e({ ourProps: d, theirProps: v, slot: o.value, attrs: i, slots: r, name: l });
  };
} });
function Rb(t) {
  let i = xa(t.getSnapshot());
  return ht(t.subscribe(() => {
    i.value = t.getSnapshot();
  })), i;
}
function Aa() {
  let t = [], i = { addEventListener(r, u, l, o) {
    return r.addEventListener(u, l, o), i.add(() => r.removeEventListener(u, l, o));
  }, requestAnimationFrame(...r) {
    let u = requestAnimationFrame(...r);
    i.add(() => cancelAnimationFrame(u));
  }, nextFrame(...r) {
    i.requestAnimationFrame(() => {
      i.requestAnimationFrame(...r);
    });
  }, setTimeout(...r) {
    let u = setTimeout(...r);
    i.add(() => clearTimeout(u));
  }, style(r, u, l) {
    let o = r.style.getPropertyValue(u);
    return Object.assign(r.style, { [u]: l }), this.add(() => {
      Object.assign(r.style, { [u]: o });
    });
  }, group(r) {
    let u = Aa();
    return r(u), this.add(() => u.dispose());
  }, add(r) {
    return t.push(r), () => {
      let u = t.indexOf(r);
      if (u >= 0)
        for (let l of t.splice(u, 1))
          l();
    };
  }, dispose() {
    for (let r of t.splice(0))
      r();
  } };
  return i;
}
function Db(t, i) {
  let r = t(), u = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(l) {
    return u.add(l), () => u.delete(l);
  }, dispatch(l, ...o) {
    let f = i[l].call(r, ...o);
    f && (r = f, u.forEach((c) => c()));
  } };
}
function Mb() {
  let t;
  return { before({ doc: i }) {
    var r;
    let u = i.documentElement;
    t = ((r = i.defaultView) != null ? r : window).innerWidth - u.clientWidth;
  }, after({ doc: i, d: r }) {
    let u = i.documentElement, l = u.clientWidth - u.offsetWidth, o = t - l;
    r.style(u, "paddingRight", `${o}px`);
  } };
}
function Bb() {
  if (!Uc())
    return {};
  let t;
  return { before() {
    t = window.pageYOffset;
  }, after({ doc: i, d: r, meta: u }) {
    function l(f) {
      return u.containers.flatMap((c) => c()).some((c) => c.contains(f));
    }
    r.style(i.body, "marginTop", `-${t}px`), window.scrollTo(0, 0);
    let o = null;
    r.addEventListener(i, "click", (f) => {
      if (f.target instanceof HTMLElement)
        try {
          let c = f.target.closest("a");
          if (!c)
            return;
          let { hash: v } = new URL(c.href), d = i.querySelector(v);
          d && !l(d) && (o = d);
        } catch {
        }
    }, !0), r.addEventListener(i, "touchmove", (f) => {
      f.target instanceof HTMLElement && !l(f.target) && f.preventDefault();
    }, { passive: !1 }), r.add(() => {
      window.scrollTo(0, window.pageYOffset + t), o && o.isConnected && (o.scrollIntoView({ block: "nearest" }), o = null);
    });
  } };
}
function kb() {
  return { before({ doc: t, d: i }) {
    i.style(t.documentElement, "overflow", "hidden");
  } };
}
function Vb(t) {
  let i = {};
  for (let r of t)
    Object.assign(i, r(i));
  return i;
}
let Kn = Db(() => /* @__PURE__ */ new Map(), { PUSH(t, i) {
  var r;
  let u = (r = this.get(t)) != null ? r : { doc: t, count: 0, d: Aa(), meta: /* @__PURE__ */ new Set() };
  return u.count++, u.meta.add(i), this.set(t, u), this;
}, POP(t, i) {
  let r = this.get(t);
  return r && (r.count--, r.meta.delete(i)), this;
}, SCROLL_PREVENT({ doc: t, d: i, meta: r }) {
  let u = { doc: t, d: i, meta: Vb(r) }, l = [Bb(), Mb(), kb()];
  l.forEach(({ before: o }) => o == null ? void 0 : o(u)), l.forEach(({ after: o }) => o == null ? void 0 : o(u));
}, SCROLL_ALLOW({ d: t }) {
  t.dispose();
}, TEARDOWN({ doc: t }) {
  this.delete(t);
} });
Kn.subscribe(() => {
  let t = Kn.getSnapshot(), i = /* @__PURE__ */ new Map();
  for (let [r] of t)
    i.set(r, r.documentElement.style.overflow);
  for (let r of t.values()) {
    let u = i.get(r.doc) === "hidden", l = r.count !== 0;
    (l && !u || !l && u) && Kn.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && Kn.dispatch("TEARDOWN", r);
  }
});
function Nb(t, i, r) {
  let u = Rb(Kn), l = k(() => {
    let o = t.value ? u.value.get(t.value) : void 0;
    return o ? o.count > 0 : !1;
  });
  return Je([t, i], ([o, f], [c], v) => {
    if (!o || !f)
      return;
    Kn.dispatch("PUSH", o, r);
    let d = !1;
    v(() => {
      d || (Kn.dispatch("POP", c ?? o, r), d = !0);
    });
  }, { immediate: !0 }), l;
}
var Ub = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(Ub || {});
let $o = Symbol("DialogContext");
function di(t) {
  let i = lt($o, null);
  if (i === null) {
    let r = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, di), r;
  }
  return i;
}
let oa = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", zb = Q({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: oa }, initialFocus: { type: Object, default: null }, id: { type: String, default: () => `headlessui-dialog-${ke()}` } }, emits: { close: (t) => !0 }, setup(t, { emit: i, attrs: r, slots: u, expose: l }) {
  var o;
  let f = z(!1);
  Ie(() => {
    f.value = !0;
  });
  let c = z(0), v = Rn(), d = k(() => t.open === oa && v !== null ? (v.value & Le.Open) === Le.Open : t.open), h = z(null), m = z(null), y = k(() => Zt(h));
  if (l({ el: h, $el: h }), !(t.open !== oa || v !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof d.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${d.value === oa ? void 0 : t.open}`);
  let w = k(() => f.value && d.value ? 0 : 1), x = k(() => w.value === 0), S = k(() => c.value > 1), _ = lt($o, null) !== null, A = k(() => S.value ? "parent" : "leaf"), T = k(() => v !== null ? (v.value & Le.Closing) === Le.Closing : !1), E = k(() => _ || T.value ? !1 : x.value), F = k(() => {
    var J, oe, de;
    return (de = Array.from((oe = (J = y.value) == null ? void 0 : J.querySelectorAll("body > *")) != null ? oe : []).find((ye) => ye.id === "headlessui-portal-root" ? !1 : ye.contains(U(m)) && ye instanceof HTMLElement)) != null ? de : null;
  });
  Wf(F, E);
  let P = k(() => S.value ? !0 : x.value), R = k(() => {
    var J, oe, de;
    return (de = Array.from((oe = (J = y.value) == null ? void 0 : J.querySelectorAll("[data-headlessui-portal]")) != null ? oe : []).find((ye) => ye.contains(U(m)) && ye instanceof HTMLElement)) != null ? de : null;
  });
  Wf(R, P), Pb({ type: "Dialog", enabled: k(() => w.value === 0), element: h, onUpdate: (J, oe) => {
    if (oe === "Dialog")
      return Ce(J, { [So.Add]: () => c.value += 1, [So.Remove]: () => c.value -= 1 });
  } });
  let V = nd({ name: "DialogDescription", slot: k(() => ({ open: d.value })) }), M = z(null), H = { titleId: M, panelRef: z(null), dialogState: w, setTitleId(J) {
    M.value !== J && (M.value = J);
  }, close() {
    i("close", !1);
  } };
  et($o, H);
  function K() {
    var J, oe, de;
    return [...Array.from((oe = (J = y.value) == null ? void 0 : J.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) != null ? oe : []).filter((ye) => !(ye === document.body || ye === document.head || !(ye instanceof HTMLElement) || ye.contains(U(m)) || H.panelRef.value && ye.contains(H.panelRef.value))), (de = H.panelRef.value) != null ? de : h.value];
  }
  let Y = k(() => !(!x.value || S.value));
  ci(() => K(), (J, oe) => {
    H.close(), ze(() => oe == null ? void 0 : oe.focus());
  }, Y);
  let ee = k(() => !(S.value || w.value !== 0));
  qo((o = y.value) == null ? void 0 : o.defaultView, "keydown", (J) => {
    ee.value && (J.defaultPrevented || J.key === ae.Escape && (J.preventDefault(), J.stopPropagation(), H.close()));
  });
  let ne = k(() => !(T.value || w.value !== 0 || _));
  return Nb(y, ne, (J) => {
    var oe;
    return { containers: [...(oe = J.containers) != null ? oe : [], K] };
  }), Xe((J) => {
    if (w.value !== 0)
      return;
    let oe = U(h);
    if (!oe)
      return;
    let de = new ResizeObserver((ye) => {
      for (let We of ye) {
        let qe = We.target.getBoundingClientRect();
        qe.x === 0 && qe.y === 0 && qe.width === 0 && qe.height === 0 && H.close();
      }
    });
    de.observe(oe), J(() => de.disconnect());
  }), () => {
    let { id: J, open: oe, initialFocus: de, ...ye } = t, We = { ...r, ref: h, id: J, role: "dialog", "aria-modal": w.value === 0 ? !0 : void 0, "aria-labelledby": M.value, "aria-describedby": V.value }, qe = { open: w.value === 0 };
    return Te(_o, { force: !0 }, () => [Te(Yo, () => Te(Ib, { target: h.value }, () => Te(_o, { force: !1 }, () => Te(Yr, { initialFocus: de, containers: K, features: x.value ? Ce(A.value, { parent: Yr.features.RestoreFocus, leaf: Yr.features.All & ~Yr.features.FocusLock }) : Yr.features.None }, () => $e({ ourProps: We, theirProps: ye, slot: qe, attrs: r, slots: u, visible: w.value === 0, features: pt.RenderStrategy | pt.Static, name: "Dialog" }))))), Te(yn, { features: an.Hidden, ref: m })]);
  };
} });
Q({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-overlay-${ke()}` } }, setup(t, { attrs: i, slots: r }) {
  let u = di("DialogOverlay");
  function l(o) {
    o.target === o.currentTarget && (o.preventDefault(), o.stopPropagation(), u.close());
  }
  return () => {
    let { id: o, ...f } = t;
    return $e({ ourProps: { id: o, "aria-hidden": !0, onClick: l }, theirProps: f, slot: { open: u.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogOverlay" });
  };
} });
Q({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-backdrop-${ke()}` } }, inheritAttrs: !1, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = di("DialogBackdrop"), o = z(null);
  return u({ el: o, $el: o }), Ie(() => {
    if (l.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { id: f, ...c } = t, v = { id: f, ref: o, "aria-hidden": !0 };
    return Te(_o, { force: !0 }, () => Te(Yo, () => $e({ ourProps: v, theirProps: { ...i, ...c }, slot: { open: l.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogBackdrop" })));
  };
} });
let Wb = Q({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: () => `headlessui-dialog-panel-${ke()}` } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = di("DialogPanel");
  u({ el: l.panelRef, $el: l.panelRef });
  function o(f) {
    f.stopPropagation();
  }
  return () => {
    let { id: f, ...c } = t, v = { id: f, ref: l.panelRef, onClick: o };
    return $e({ ourProps: v, theirProps: c, slot: { open: l.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogPanel" });
  };
} }), Hb = Q({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: () => `headlessui-dialog-title-${ke()}` } }, setup(t, { attrs: i, slots: r }) {
  let u = di("DialogTitle");
  return Ie(() => {
    u.setTitleId(t.id), ht(() => u.setTitleId(null));
  }), () => {
    let { id: l, ...o } = t;
    return $e({ ourProps: { id: l }, theirProps: o, slot: { open: u.dialogState.value === 0 }, attrs: i, slots: r, name: "DialogTitle" });
  };
} });
function Gb(t, i) {
  return t === i;
}
var jb = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(jb || {}), Kb = ((t) => (t[t.Single = 0] = "Single", t[t.Multi = 1] = "Multi", t))(Kb || {}), qb = ((t) => (t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))(qb || {});
function Yb(t) {
  requestAnimationFrame(() => requestAnimationFrame(t));
}
let rd = Symbol("ListboxContext");
function vi(t) {
  let i = lt(rd, null);
  if (i === null) {
    let r = new Error(`<${t} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, vi), r;
  }
  return i;
}
let id = Q({ name: "Listbox", emits: { "update:modelValue": (t) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => Gb }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(t, { slots: i, attrs: r, emit: u }) {
  let l = z(1), o = z(null), f = z(null), c = z(null), v = z([]), d = z(""), h = z(null), m = z(1);
  function y(T = (E) => E) {
    let E = h.value !== null ? v.value[h.value] : null, F = $a(T(v.value.slice()), (R) => U(R.dataRef.domRef)), P = E ? F.indexOf(E) : null;
    return P === -1 && (P = null), { options: F, activeOptionIndex: P };
  }
  let w = k(() => t.multiple ? 1 : 0), [x, S] = Go(k(() => t.modelValue === void 0 ? Ce(w.value, { [1]: [], [0]: void 0 }) : t.modelValue), (T) => u("update:modelValue", T), k(() => t.defaultValue)), _ = { listboxState: l, value: x, mode: w, compare(T, E) {
    if (typeof t.by == "string") {
      let F = t.by;
      return (T == null ? void 0 : T[F]) === (E == null ? void 0 : E[F]);
    }
    return t.by(T, E);
  }, orientation: k(() => t.horizontal ? "horizontal" : "vertical"), labelRef: o, buttonRef: f, optionsRef: c, disabled: k(() => t.disabled), options: v, searchQuery: d, activeOptionIndex: h, activationTrigger: m, closeListbox() {
    t.disabled || l.value !== 1 && (l.value = 1, h.value = null);
  }, openListbox() {
    t.disabled || l.value !== 0 && (l.value = 0);
  }, goToOption(T, E, F) {
    if (t.disabled || l.value === 1)
      return;
    let P = y(), R = Wo(T === me.Specific ? { focus: me.Specific, id: E } : { focus: T }, { resolveItems: () => P.options, resolveActiveIndex: () => P.activeOptionIndex, resolveId: (V) => V.id, resolveDisabled: (V) => V.dataRef.disabled });
    d.value = "", h.value = R, m.value = F ?? 1, v.value = P.options;
  }, search(T) {
    if (t.disabled || l.value === 1)
      return;
    let E = d.value !== "" ? 0 : 1;
    d.value += T.toLowerCase();
    let F = (h.value !== null ? v.value.slice(h.value + E).concat(v.value.slice(0, h.value + E)) : v.value).find((R) => R.dataRef.textValue.startsWith(d.value) && !R.dataRef.disabled), P = F ? v.value.indexOf(F) : -1;
    P === -1 || P === h.value || (h.value = P, m.value = 1);
  }, clearSearch() {
    t.disabled || l.value !== 1 && d.value !== "" && (d.value = "");
  }, registerOption(T, E) {
    let F = y((P) => [...P, { id: T, dataRef: E }]);
    v.value = F.options, h.value = F.activeOptionIndex;
  }, unregisterOption(T) {
    let E = y((F) => {
      let P = F.findIndex((R) => R.id === T);
      return P !== -1 && F.splice(P, 1), F;
    });
    v.value = E.options, h.value = E.activeOptionIndex, m.value = 1;
  }, select(T) {
    t.disabled || S(Ce(w.value, { [0]: () => T, [1]: () => {
      let E = Fe(_.value.value).slice(), F = Fe(T), P = E.findIndex((R) => _.compare(F, Fe(R)));
      return P === -1 ? E.push(F) : E.splice(P, 1), E;
    } }));
  } };
  ci([f, c], (T, E) => {
    var F;
    _.closeListbox(), fi(E, si.Loose) || (T.preventDefault(), (F = U(f)) == null || F.focus());
  }, k(() => l.value === 0)), et(rd, _), ai(k(() => Ce(l.value, { [0]: Le.Open, [1]: Le.Closed })));
  let A = k(() => {
    var T;
    return (T = U(f)) == null ? void 0 : T.closest("form");
  });
  return Ie(() => {
    Je([A], () => {
      if (!A.value || t.defaultValue === void 0)
        return;
      function T() {
        _.select(t.defaultValue);
      }
      return A.value.addEventListener("reset", T), () => {
        var E;
        (E = A.value) == null || E.removeEventListener("reset", T);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: T, modelValue: E, disabled: F, ...P } = t, R = { open: l.value === 0, disabled: F, value: x.value };
    return Te(rt, [...T != null && x.value != null ? Ho({ [T]: x.value }).map(([V, M]) => Te(yn, zo({ features: an.Hidden, key: V, as: "input", type: "hidden", hidden: !0, readOnly: !0, name: V, value: M }))) : [], $e({ ourProps: {}, theirProps: { ...r, ...yr(P, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: R, slots: i, attrs: r, name: "Listbox" })]);
  };
} }), ad = Q({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-listbox-label-${ke()}` } }, setup(t, { attrs: i, slots: r }) {
  let u = vi("ListboxLabel");
  function l() {
    var o;
    (o = U(u.buttonRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: u.listboxState.value === 0, disabled: u.disabled.value }, { id: f, ...c } = t, v = { id: f, ref: u.labelRef, onClick: l };
    return $e({ ourProps: v, theirProps: c, slot: o, attrs: i, slots: r, name: "ListboxLabel" });
  };
} }), ld = Q({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-listbox-button-${ke()}` } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = vi("ListboxButton");
  u({ el: l.buttonRef, $el: l.buttonRef });
  function o(d) {
    switch (d.key) {
      case ae.Space:
      case ae.Enter:
      case ae.ArrowDown:
        d.preventDefault(), l.openListbox(), ze(() => {
          var h;
          (h = U(l.optionsRef)) == null || h.focus({ preventScroll: !0 }), l.value.value || l.goToOption(me.First);
        });
        break;
      case ae.ArrowUp:
        d.preventDefault(), l.openListbox(), ze(() => {
          var h;
          (h = U(l.optionsRef)) == null || h.focus({ preventScroll: !0 }), l.value.value || l.goToOption(me.Last);
        });
        break;
    }
  }
  function f(d) {
    switch (d.key) {
      case ae.Space:
        d.preventDefault();
        break;
    }
  }
  function c(d) {
    l.disabled.value || (l.listboxState.value === 0 ? (l.closeListbox(), ze(() => {
      var h;
      return (h = U(l.buttonRef)) == null ? void 0 : h.focus({ preventScroll: !0 });
    })) : (d.preventDefault(), l.openListbox(), Yb(() => {
      var h;
      return (h = U(l.optionsRef)) == null ? void 0 : h.focus({ preventScroll: !0 });
    })));
  }
  let v = li(k(() => ({ as: t.as, type: i.type })), l.buttonRef);
  return () => {
    var d, h;
    let m = { open: l.listboxState.value === 0, disabled: l.disabled.value, value: l.value.value }, { id: y, ...w } = t, x = { ref: l.buttonRef, id: y, type: v.value, "aria-haspopup": "listbox", "aria-controls": (d = U(l.optionsRef)) == null ? void 0 : d.id, "aria-expanded": l.disabled.value ? void 0 : l.listboxState.value === 0, "aria-labelledby": l.labelRef.value ? [(h = U(l.labelRef)) == null ? void 0 : h.id, y].join(" ") : void 0, disabled: l.disabled.value === !0 ? !0 : void 0, onKeydown: o, onKeyup: f, onClick: c };
    return $e({ ourProps: x, theirProps: w, slot: m, attrs: i, slots: r, name: "ListboxButton" });
  };
} }), od = Q({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-listbox-options-${ke()}` } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = vi("ListboxOptions"), o = z(null);
  u({ el: l.optionsRef, $el: l.optionsRef });
  function f(d) {
    switch (o.value && clearTimeout(o.value), d.key) {
      case ae.Space:
        if (l.searchQuery.value !== "")
          return d.preventDefault(), d.stopPropagation(), l.search(d.key);
      case ae.Enter:
        if (d.preventDefault(), d.stopPropagation(), l.activeOptionIndex.value !== null) {
          let h = l.options.value[l.activeOptionIndex.value];
          l.select(h.dataRef.value);
        }
        l.mode.value === 0 && (l.closeListbox(), ze(() => {
          var h;
          return (h = U(l.buttonRef)) == null ? void 0 : h.focus({ preventScroll: !0 });
        }));
        break;
      case Ce(l.orientation.value, { vertical: ae.ArrowDown, horizontal: ae.ArrowRight }):
        return d.preventDefault(), d.stopPropagation(), l.goToOption(me.Next);
      case Ce(l.orientation.value, { vertical: ae.ArrowUp, horizontal: ae.ArrowLeft }):
        return d.preventDefault(), d.stopPropagation(), l.goToOption(me.Previous);
      case ae.Home:
      case ae.PageUp:
        return d.preventDefault(), d.stopPropagation(), l.goToOption(me.First);
      case ae.End:
      case ae.PageDown:
        return d.preventDefault(), d.stopPropagation(), l.goToOption(me.Last);
      case ae.Escape:
        d.preventDefault(), d.stopPropagation(), l.closeListbox(), ze(() => {
          var h;
          return (h = U(l.buttonRef)) == null ? void 0 : h.focus({ preventScroll: !0 });
        });
        break;
      case ae.Tab:
        d.preventDefault(), d.stopPropagation();
        break;
      default:
        d.key.length === 1 && (l.search(d.key), o.value = setTimeout(() => l.clearSearch(), 350));
        break;
    }
  }
  let c = Rn(), v = k(() => c !== null ? (c.value & Le.Open) === Le.Open : l.listboxState.value === 0);
  return () => {
    var d, h, m, y;
    let w = { open: l.listboxState.value === 0 }, { id: x, ...S } = t, _ = { "aria-activedescendant": l.activeOptionIndex.value === null || (d = l.options.value[l.activeOptionIndex.value]) == null ? void 0 : d.id, "aria-multiselectable": l.mode.value === 1 ? !0 : void 0, "aria-labelledby": (y = (h = U(l.labelRef)) == null ? void 0 : h.id) != null ? y : (m = U(l.buttonRef)) == null ? void 0 : m.id, "aria-orientation": l.orientation.value, id: x, onKeydown: f, role: "listbox", tabIndex: 0, ref: l.optionsRef };
    return $e({ ourProps: _, theirProps: S, slot: w, attrs: i, slots: r, features: pt.RenderStrategy | pt.Static, visible: v.value, name: "ListboxOptions" });
  };
} }), ud = Q({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-listbox.option-${ke()}` } }, setup(t, { slots: i, attrs: r, expose: u }) {
  let l = vi("ListboxOption"), o = z(null);
  u({ el: o, $el: o });
  let f = k(() => l.activeOptionIndex.value !== null ? l.options.value[l.activeOptionIndex.value].id === t.id : !1), c = k(() => Ce(l.mode.value, { [0]: () => l.compare(Fe(l.value.value), Fe(t.value)), [1]: () => Fe(l.value.value).some((_) => l.compare(Fe(_), Fe(t.value))) })), v = k(() => Ce(l.mode.value, { [1]: () => {
    var _;
    let A = Fe(l.value.value);
    return ((_ = l.options.value.find((T) => A.some((E) => l.compare(Fe(E), Fe(T.dataRef.value))))) == null ? void 0 : _.id) === t.id;
  }, [0]: () => c.value })), d = k(() => ({ disabled: t.disabled, value: t.value, textValue: "", domRef: o }));
  Ie(() => {
    var _, A;
    let T = (A = (_ = U(o)) == null ? void 0 : _.textContent) == null ? void 0 : A.toLowerCase().trim();
    T !== void 0 && (d.value.textValue = T);
  }), Ie(() => l.registerOption(t.id, d)), ht(() => l.unregisterOption(t.id)), Ie(() => {
    Je([l.listboxState, c], () => {
      l.listboxState.value === 0 && c.value && Ce(l.mode.value, { [1]: () => {
        v.value && l.goToOption(me.Specific, t.id);
      }, [0]: () => {
        l.goToOption(me.Specific, t.id);
      } });
    }, { immediate: !0 });
  }), Xe(() => {
    l.listboxState.value === 0 && f.value && l.activationTrigger.value !== 0 && ze(() => {
      var _, A;
      return (A = (_ = U(o)) == null ? void 0 : _.scrollIntoView) == null ? void 0 : A.call(_, { block: "nearest" });
    });
  });
  function h(_) {
    if (t.disabled)
      return _.preventDefault();
    l.select(t.value), l.mode.value === 0 && (l.closeListbox(), ze(() => {
      var A;
      return (A = U(l.buttonRef)) == null ? void 0 : A.focus({ preventScroll: !0 });
    }));
  }
  function m() {
    if (t.disabled)
      return l.goToOption(me.Nothing);
    l.goToOption(me.Specific, t.id);
  }
  let y = jo();
  function w(_) {
    y.update(_);
  }
  function x(_) {
    y.wasMoved(_) && (t.disabled || f.value || l.goToOption(me.Specific, t.id, 0));
  }
  function S(_) {
    y.wasMoved(_) && (t.disabled || f.value && l.goToOption(me.Nothing));
  }
  return () => {
    let { disabled: _ } = t, A = { active: f.value, selected: c.value, disabled: _ }, { id: T, value: E, disabled: F, ...P } = t, R = { id: T, ref: o, role: "option", tabIndex: _ === !0 ? void 0 : -1, "aria-disabled": _ === !0 ? !0 : void 0, "aria-selected": c.value, disabled: void 0, onClick: h, onFocus: m, onPointerenter: w, onMouseenter: w, onPointermove: x, onMousemove: x, onPointerleave: S, onMouseleave: S };
    return $e({ ourProps: R, theirProps: P, slot: A, attrs: r, slots: i, name: "ListboxOption" });
  };
} });
var Zb = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(Zb || {}), Jb = ((t) => (t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))(Jb || {});
function Xb(t) {
  requestAnimationFrame(() => requestAnimationFrame(t));
}
let sd = Symbol("MenuContext");
function Ta(t) {
  let i = lt(sd, null);
  if (i === null) {
    let r = new Error(`<${t} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ta), r;
  }
  return i;
}
let Qb = Q({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(t, { slots: i, attrs: r }) {
  let u = z(1), l = z(null), o = z(null), f = z([]), c = z(""), v = z(null), d = z(1);
  function h(y = (w) => w) {
    let w = v.value !== null ? f.value[v.value] : null, x = $a(y(f.value.slice()), (_) => U(_.dataRef.domRef)), S = w ? x.indexOf(w) : null;
    return S === -1 && (S = null), { items: x, activeItemIndex: S };
  }
  let m = { menuState: u, buttonRef: l, itemsRef: o, items: f, searchQuery: c, activeItemIndex: v, activationTrigger: d, closeMenu: () => {
    u.value = 1, v.value = null;
  }, openMenu: () => u.value = 0, goToItem(y, w, x) {
    let S = h(), _ = Wo(y === me.Specific ? { focus: me.Specific, id: w } : { focus: y }, { resolveItems: () => S.items, resolveActiveIndex: () => S.activeItemIndex, resolveId: (A) => A.id, resolveDisabled: (A) => A.dataRef.disabled });
    c.value = "", v.value = _, d.value = x ?? 1, f.value = S.items;
  }, search(y) {
    let w = c.value !== "" ? 0 : 1;
    c.value += y.toLowerCase();
    let x = (v.value !== null ? f.value.slice(v.value + w).concat(f.value.slice(0, v.value + w)) : f.value).find((_) => _.dataRef.textValue.startsWith(c.value) && !_.dataRef.disabled), S = x ? f.value.indexOf(x) : -1;
    S === -1 || S === v.value || (v.value = S, d.value = 1);
  }, clearSearch() {
    c.value = "";
  }, registerItem(y, w) {
    let x = h((S) => [...S, { id: y, dataRef: w }]);
    f.value = x.items, v.value = x.activeItemIndex, d.value = 1;
  }, unregisterItem(y) {
    let w = h((x) => {
      let S = x.findIndex((_) => _.id === y);
      return S !== -1 && x.splice(S, 1), x;
    });
    f.value = w.items, v.value = w.activeItemIndex, d.value = 1;
  } };
  return ci([l, o], (y, w) => {
    var x;
    m.closeMenu(), fi(w, si.Loose) || (y.preventDefault(), (x = U(l)) == null || x.focus());
  }, k(() => u.value === 0)), et(sd, m), ai(k(() => Ce(u.value, { [0]: Le.Open, [1]: Le.Closed }))), () => {
    let y = { open: u.value === 0, close: m.closeMenu };
    return $e({ ourProps: {}, theirProps: t, slot: y, slots: i, attrs: r, name: "Menu" });
  };
} }), ew = Q({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-menu-button-${ke()}` } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = Ta("MenuButton");
  u({ el: l.buttonRef, $el: l.buttonRef });
  function o(d) {
    switch (d.key) {
      case ae.Space:
      case ae.Enter:
      case ae.ArrowDown:
        d.preventDefault(), d.stopPropagation(), l.openMenu(), ze(() => {
          var h;
          (h = U(l.itemsRef)) == null || h.focus({ preventScroll: !0 }), l.goToItem(me.First);
        });
        break;
      case ae.ArrowUp:
        d.preventDefault(), d.stopPropagation(), l.openMenu(), ze(() => {
          var h;
          (h = U(l.itemsRef)) == null || h.focus({ preventScroll: !0 }), l.goToItem(me.Last);
        });
        break;
    }
  }
  function f(d) {
    switch (d.key) {
      case ae.Space:
        d.preventDefault();
        break;
    }
  }
  function c(d) {
    t.disabled || (l.menuState.value === 0 ? (l.closeMenu(), ze(() => {
      var h;
      return (h = U(l.buttonRef)) == null ? void 0 : h.focus({ preventScroll: !0 });
    })) : (d.preventDefault(), l.openMenu(), Xb(() => {
      var h;
      return (h = U(l.itemsRef)) == null ? void 0 : h.focus({ preventScroll: !0 });
    })));
  }
  let v = li(k(() => ({ as: t.as, type: i.type })), l.buttonRef);
  return () => {
    var d;
    let h = { open: l.menuState.value === 0 }, { id: m, ...y } = t, w = { ref: l.buttonRef, id: m, type: v.value, "aria-haspopup": "menu", "aria-controls": (d = U(l.itemsRef)) == null ? void 0 : d.id, "aria-expanded": t.disabled ? void 0 : l.menuState.value === 0, onKeydown: o, onKeyup: f, onClick: c };
    return $e({ ourProps: w, theirProps: y, slot: h, attrs: i, slots: r, name: "MenuButton" });
  };
} }), tw = Q({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-menu-items-${ke()}` } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = Ta("MenuItems"), o = z(null);
  u({ el: l.itemsRef, $el: l.itemsRef }), Bc({ container: k(() => U(l.itemsRef)), enabled: k(() => l.menuState.value === 0), accept(h) {
    return h.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : h.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(h) {
    h.setAttribute("role", "none");
  } });
  function f(h) {
    var m;
    switch (o.value && clearTimeout(o.value), h.key) {
      case ae.Space:
        if (l.searchQuery.value !== "")
          return h.preventDefault(), h.stopPropagation(), l.search(h.key);
      case ae.Enter:
        if (h.preventDefault(), h.stopPropagation(), l.activeItemIndex.value !== null) {
          let y = l.items.value[l.activeItemIndex.value];
          (m = U(y.dataRef.domRef)) == null || m.click();
        }
        l.closeMenu(), kc(U(l.buttonRef));
        break;
      case ae.ArrowDown:
        return h.preventDefault(), h.stopPropagation(), l.goToItem(me.Next);
      case ae.ArrowUp:
        return h.preventDefault(), h.stopPropagation(), l.goToItem(me.Previous);
      case ae.Home:
      case ae.PageUp:
        return h.preventDefault(), h.stopPropagation(), l.goToItem(me.First);
      case ae.End:
      case ae.PageDown:
        return h.preventDefault(), h.stopPropagation(), l.goToItem(me.Last);
      case ae.Escape:
        h.preventDefault(), h.stopPropagation(), l.closeMenu(), ze(() => {
          var y;
          return (y = U(l.buttonRef)) == null ? void 0 : y.focus({ preventScroll: !0 });
        });
        break;
      case ae.Tab:
        h.preventDefault(), h.stopPropagation(), l.closeMenu(), ze(() => hb(U(l.buttonRef), h.shiftKey ? at.Previous : at.Next));
        break;
      default:
        h.key.length === 1 && (l.search(h.key), o.value = setTimeout(() => l.clearSearch(), 350));
        break;
    }
  }
  function c(h) {
    switch (h.key) {
      case ae.Space:
        h.preventDefault();
        break;
    }
  }
  let v = Rn(), d = k(() => v !== null ? (v.value & Le.Open) === Le.Open : l.menuState.value === 0);
  return () => {
    var h, m;
    let y = { open: l.menuState.value === 0 }, { id: w, ...x } = t, S = { "aria-activedescendant": l.activeItemIndex.value === null || (h = l.items.value[l.activeItemIndex.value]) == null ? void 0 : h.id, "aria-labelledby": (m = U(l.buttonRef)) == null ? void 0 : m.id, id: w, onKeydown: f, onKeyup: c, role: "menu", tabIndex: 0, ref: l.itemsRef };
    return $e({ ourProps: S, theirProps: x, slot: y, attrs: i, slots: r, features: pt.RenderStrategy | pt.Static, visible: d.value, name: "MenuItems" });
  };
} }), nw = Q({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-menu-item-${ke()}` } }, setup(t, { slots: i, attrs: r, expose: u }) {
  let l = Ta("MenuItem"), o = z(null);
  u({ el: o, $el: o });
  let f = k(() => l.activeItemIndex.value !== null ? l.items.value[l.activeItemIndex.value].id === t.id : !1), c = k(() => ({ disabled: t.disabled, textValue: "", domRef: o }));
  Ie(() => {
    var x, S;
    let _ = (S = (x = U(o)) == null ? void 0 : x.textContent) == null ? void 0 : S.toLowerCase().trim();
    _ !== void 0 && (c.value.textValue = _);
  }), Ie(() => l.registerItem(t.id, c)), ht(() => l.unregisterItem(t.id)), Xe(() => {
    l.menuState.value === 0 && f.value && l.activationTrigger.value !== 0 && ze(() => {
      var x, S;
      return (S = (x = U(o)) == null ? void 0 : x.scrollIntoView) == null ? void 0 : S.call(x, { block: "nearest" });
    });
  });
  function v(x) {
    if (t.disabled)
      return x.preventDefault();
    l.closeMenu(), kc(U(l.buttonRef));
  }
  function d() {
    if (t.disabled)
      return l.goToItem(me.Nothing);
    l.goToItem(me.Specific, t.id);
  }
  let h = jo();
  function m(x) {
    h.update(x);
  }
  function y(x) {
    h.wasMoved(x) && (t.disabled || f.value || l.goToItem(me.Specific, t.id, 0));
  }
  function w(x) {
    h.wasMoved(x) && (t.disabled || f.value && l.goToItem(me.Nothing));
  }
  return () => {
    let { disabled: x } = t, S = { active: f.value, disabled: x, close: l.closeMenu }, { id: _, ...A } = t;
    return $e({ ourProps: { id: _, ref: o, role: "menuitem", tabIndex: x === !0 ? void 0 : -1, "aria-disabled": x === !0 ? !0 : void 0, disabled: void 0, onClick: v, onFocus: d, onPointerenter: m, onMouseenter: m, onPointermove: y, onMousemove: y, onPointerleave: w, onMouseleave: w }, theirProps: { ...r, ...A }, slot: S, attrs: r, slots: i, name: "MenuItem" });
  };
} });
var rw = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(rw || {});
let fd = Symbol("PopoverContext");
function Ca(t) {
  let i = lt(fd, null);
  if (i === null) {
    let r = new Error(`<${t} /> is missing a parent <${pd.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ca), r;
  }
  return i;
}
let cd = Symbol("PopoverGroupContext");
function dd() {
  return lt(cd, null);
}
let vd = Symbol("PopoverPanelContext");
function iw() {
  return lt(vd, null);
}
let pd = Q({ name: "Popover", props: { as: { type: [Object, String], default: "div" } }, setup(t, { slots: i, attrs: r, expose: u }) {
  var l;
  let o = z(null);
  u({ el: o, $el: o });
  let f = z(1), c = z(null), v = z(null), d = z(null), h = z(null), m = k(() => Zt(o)), y = k(() => {
    var T, E;
    if (!U(c) || !U(h))
      return !1;
    for (let K of document.querySelectorAll("body > *"))
      if (Number(K == null ? void 0 : K.contains(U(c))) ^ Number(K == null ? void 0 : K.contains(U(h))))
        return !0;
    let F = ui(), P = F.indexOf(U(c)), R = (P + F.length - 1) % F.length, V = (P + 1) % F.length, M = F[R], H = F[V];
    return !((T = U(h)) != null && T.contains(M)) && !((E = U(h)) != null && E.contains(H));
  }), w = { popoverState: f, buttonId: z(null), panelId: z(null), panel: h, button: c, isPortalled: y, beforePanelSentinel: v, afterPanelSentinel: d, togglePopover() {
    f.value = Ce(f.value, { [0]: 1, [1]: 0 });
  }, closePopover() {
    f.value !== 1 && (f.value = 1);
  }, close(T) {
    w.closePopover();
    let E = (() => T ? T instanceof HTMLElement ? T : T.value instanceof HTMLElement ? U(T) : U(w.button) : U(w.button))();
    E == null || E.focus();
  } };
  et(fd, w), ai(k(() => Ce(f.value, { [0]: Le.Open, [1]: Le.Closed })));
  let x = { buttonId: w.buttonId, panelId: w.panelId, close() {
    w.closePopover();
  } }, S = dd(), _ = S == null ? void 0 : S.registerPopover;
  function A() {
    var T, E, F, P;
    return (P = S == null ? void 0 : S.isFocusWithinPopoverGroup()) != null ? P : ((T = m.value) == null ? void 0 : T.activeElement) && (((E = U(c)) == null ? void 0 : E.contains(m.value.activeElement)) || ((F = U(h)) == null ? void 0 : F.contains(m.value.activeElement)));
  }
  return Xe(() => _ == null ? void 0 : _(x)), qo((l = m.value) == null ? void 0 : l.defaultView, "focus", (T) => {
    var E, F;
    f.value === 0 && (A() || c && h && T.target !== window && ((E = U(w.beforePanelSentinel)) != null && E.contains(T.target) || (F = U(w.afterPanelSentinel)) != null && F.contains(T.target) || w.closePopover()));
  }, !0), ci([c, h], (T, E) => {
    var F;
    w.closePopover(), fi(E, si.Loose) || (T.preventDefault(), (F = U(c)) == null || F.focus());
  }, k(() => f.value === 0)), () => {
    let T = { open: f.value === 0, close: w.close };
    return $e({ theirProps: t, ourProps: { ref: o }, slot: T, slots: i, attrs: r, name: "Popover" });
  };
} }), aw = Q({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-popover-button-${ke()}` } }, inheritAttrs: !1, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = Ca("PopoverButton"), o = k(() => Zt(l.button));
  u({ el: l.button, $el: l.button }), Ie(() => {
    l.buttonId.value = t.id;
  }), ht(() => {
    l.buttonId.value = null;
  });
  let f = dd(), c = f == null ? void 0 : f.closeOthers, v = iw(), d = k(() => v === null ? !1 : v.value === l.panelId.value), h = z(null), m = `headlessui-focus-sentinel-${ke()}`;
  d.value || Xe(() => {
    l.button.value = h.value;
  });
  let y = li(k(() => ({ as: t.as, type: i.type })), h);
  function w(A) {
    var T, E, F, P, R;
    if (d.value) {
      if (l.popoverState.value === 1)
        return;
      switch (A.key) {
        case ae.Space:
        case ae.Enter:
          A.preventDefault(), (E = (T = A.target).click) == null || E.call(T), l.closePopover(), (F = U(l.button)) == null || F.focus();
          break;
      }
    } else
      switch (A.key) {
        case ae.Space:
        case ae.Enter:
          A.preventDefault(), A.stopPropagation(), l.popoverState.value === 1 && (c == null || c(l.buttonId.value)), l.togglePopover();
          break;
        case ae.Escape:
          if (l.popoverState.value !== 0)
            return c == null ? void 0 : c(l.buttonId.value);
          if (!U(l.button) || (P = o.value) != null && P.activeElement && !((R = U(l.button)) != null && R.contains(o.value.activeElement)))
            return;
          A.preventDefault(), A.stopPropagation(), l.closePopover();
          break;
      }
  }
  function x(A) {
    d.value || A.key === ae.Space && A.preventDefault();
  }
  function S(A) {
    var T, E;
    t.disabled || (d.value ? (l.closePopover(), (T = U(l.button)) == null || T.focus()) : (A.preventDefault(), A.stopPropagation(), l.popoverState.value === 1 && (c == null || c(l.buttonId.value)), l.togglePopover(), (E = U(l.button)) == null || E.focus()));
  }
  function _(A) {
    A.preventDefault(), A.stopPropagation();
  }
  return () => {
    let A = l.popoverState.value === 0, T = { open: A }, { id: E, ...F } = t, P = d.value ? { ref: h, type: y.value, onKeydown: w, onClick: S } : { ref: h, id: E, type: y.value, "aria-expanded": t.disabled ? void 0 : l.popoverState.value === 0, "aria-controls": U(l.panel) ? l.panelId.value : void 0, disabled: t.disabled ? !0 : void 0, onKeydown: w, onKeyup: x, onClick: S, onMousedown: _ }, R = Ko();
    function V() {
      let M = U(l.panel);
      if (!M)
        return;
      function H() {
        Ce(R.value, { [It.Forwards]: () => Nt(M, at.First), [It.Backwards]: () => Nt(M, at.Last) }) === ti.Error && Nt(ui().filter((K) => K.dataset.headlessuiFocusGuard !== "true"), Ce(R.value, { [It.Forwards]: at.Next, [It.Backwards]: at.Previous }), { relativeTo: U(l.button) });
      }
      H();
    }
    return Te(rt, [$e({ ourProps: P, theirProps: { ...i, ...F }, slot: T, attrs: i, slots: r, name: "PopoverButton" }), A && !d.value && l.isPortalled.value && Te(yn, { id: m, features: an.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: V })]);
  };
} });
Q({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(t, { attrs: i, slots: r }) {
  let u = Ca("PopoverOverlay"), l = `headlessui-popover-overlay-${ke()}`, o = Rn(), f = k(() => o !== null ? (o.value & Le.Open) === Le.Open : u.popoverState.value === 0);
  function c() {
    u.closePopover();
  }
  return () => {
    let v = { open: u.popoverState.value === 0 };
    return $e({ ourProps: { id: l, "aria-hidden": !0, onClick: c }, theirProps: t, slot: v, attrs: i, slots: r, features: pt.RenderStrategy | pt.Static, visible: f.value, name: "PopoverOverlay" });
  };
} });
let lw = Q({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-popover-panel-${ke()}` } }, inheritAttrs: !1, setup(t, { attrs: i, slots: r, expose: u }) {
  let { focus: l } = t, o = Ca("PopoverPanel"), f = k(() => Zt(o.panel)), c = `headlessui-focus-sentinel-before-${ke()}`, v = `headlessui-focus-sentinel-after-${ke()}`;
  u({ el: o.panel, $el: o.panel }), Ie(() => {
    o.panelId.value = t.id;
  }), ht(() => {
    o.panelId.value = null;
  }), et(vd, o.panelId), Xe(() => {
    var _, A;
    if (!l || o.popoverState.value !== 0 || !o.panel)
      return;
    let T = (_ = f.value) == null ? void 0 : _.activeElement;
    (A = U(o.panel)) != null && A.contains(T) || Nt(U(o.panel), at.First);
  });
  let d = Rn(), h = k(() => d !== null ? (d.value & Le.Open) === Le.Open : o.popoverState.value === 0);
  function m(_) {
    var A, T;
    switch (_.key) {
      case ae.Escape:
        if (o.popoverState.value !== 0 || !U(o.panel) || f.value && !((A = U(o.panel)) != null && A.contains(f.value.activeElement)))
          return;
        _.preventDefault(), _.stopPropagation(), o.closePopover(), (T = U(o.button)) == null || T.focus();
        break;
    }
  }
  function y(_) {
    var A, T, E, F, P;
    let R = _.relatedTarget;
    R && U(o.panel) && ((A = U(o.panel)) != null && A.contains(R) || (o.closePopover(), ((E = (T = U(o.beforePanelSentinel)) == null ? void 0 : T.contains) != null && E.call(T, R) || (P = (F = U(o.afterPanelSentinel)) == null ? void 0 : F.contains) != null && P.call(F, R)) && R.focus({ preventScroll: !0 })));
  }
  let w = Ko();
  function x() {
    let _ = U(o.panel);
    if (!_)
      return;
    function A() {
      Ce(w.value, { [It.Forwards]: () => {
        var T;
        Nt(_, at.First) === ti.Error && ((T = U(o.afterPanelSentinel)) == null || T.focus());
      }, [It.Backwards]: () => {
        var T;
        (T = U(o.button)) == null || T.focus({ preventScroll: !0 });
      } });
    }
    A();
  }
  function S() {
    let _ = U(o.panel);
    if (!_)
      return;
    function A() {
      Ce(w.value, { [It.Forwards]: () => {
        let T = U(o.button), E = U(o.panel);
        if (!T)
          return;
        let F = ui(), P = F.indexOf(T), R = F.slice(0, P + 1), V = [...F.slice(P + 1), ...R];
        for (let M of V.slice())
          if (M.dataset.headlessuiFocusGuard === "true" || E != null && E.contains(M)) {
            let H = V.indexOf(M);
            H !== -1 && V.splice(H, 1);
          }
        Nt(V, at.First, { sorted: !1 });
      }, [It.Backwards]: () => {
        var T;
        Nt(_, at.Previous) === ti.Error && ((T = U(o.button)) == null || T.focus());
      } });
    }
    A();
  }
  return () => {
    let _ = { open: o.popoverState.value === 0, close: o.close }, { id: A, focus: T, ...E } = t, F = { ref: o.panel, id: A, onKeydown: m, onFocusout: l && o.popoverState.value === 0 ? y : void 0, tabIndex: -1 };
    return $e({ ourProps: F, theirProps: { ...i, ...E }, attrs: i, slot: _, slots: { ...r, default: (...P) => {
      var R;
      return [Te(rt, [h.value && o.isPortalled.value && Te(yn, { id: c, ref: o.beforePanelSentinel, features: an.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: x }), (R = r.default) == null ? void 0 : R.call(r, ...P), h.value && o.isPortalled.value && Te(yn, { id: v, ref: o.afterPanelSentinel, features: an.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: S })])];
    } }, features: pt.RenderStrategy | pt.Static, visible: h.value, name: "PopoverPanel" });
  };
} });
Q({ name: "PopoverGroup", props: { as: { type: [Object, String], default: "div" } }, setup(t, { attrs: i, slots: r, expose: u }) {
  let l = z(null), o = xa([]), f = k(() => Zt(l));
  u({ el: l, $el: l });
  function c(m) {
    let y = o.value.indexOf(m);
    y !== -1 && o.value.splice(y, 1);
  }
  function v(m) {
    return o.value.push(m), () => {
      c(m);
    };
  }
  function d() {
    var m;
    let y = f.value;
    if (!y)
      return !1;
    let w = y.activeElement;
    return (m = U(l)) != null && m.contains(w) ? !0 : o.value.some((x) => {
      var S, _;
      return ((S = y.getElementById(x.buttonId.value)) == null ? void 0 : S.contains(w)) || ((_ = y.getElementById(x.panelId.value)) == null ? void 0 : _.contains(w));
    });
  }
  function h(m) {
    for (let y of o.value)
      y.buttonId.value !== m && y.close();
  }
  return et(cd, { registerPopover: v, unregisterPopover: c, isFocusWithinPopoverGroup: d, closeOthers: h }), () => $e({ ourProps: { ref: l }, theirProps: t, slot: {}, attrs: i, slots: r, name: "PopoverGroup" });
} });
let hd = Symbol("LabelContext");
function md() {
  let t = lt(hd, null);
  if (t === null) {
    let i = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(i, md), i;
  }
  return t;
}
function ow({ slot: t = {}, name: i = "Label", props: r = {} } = {}) {
  let u = z([]);
  function l(o) {
    return u.value.push(o), () => {
      let f = u.value.indexOf(o);
      f !== -1 && u.value.splice(f, 1);
    };
  }
  return et(hd, { register: l, slot: t, name: i, props: r }), k(() => u.value.length > 0 ? u.value.join(" ") : void 0);
}
Q({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-label-${ke()}` } }, setup(t, { slots: i, attrs: r }) {
  let u = md();
  return Ie(() => ht(u.register(t.id))), () => {
    let { name: l = "Label", slot: o = {}, props: f = {} } = u, { id: c, passive: v, ...d } = t, h = { ...Object.entries(f).reduce((m, [y, w]) => Object.assign(m, { [y]: j(w) }), {}), id: c };
    return v && (delete h.onClick, delete h.htmlFor, delete d.onClick), $e({ ourProps: h, theirProps: d, slot: o, attrs: r, slots: i, name: l });
  };
} });
let gd = Symbol("GroupContext");
Q({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(t, { slots: i, attrs: r }) {
  let u = z(null), l = ow({ name: "SwitchLabel", props: { htmlFor: k(() => {
    var f;
    return (f = u.value) == null ? void 0 : f.id;
  }), onClick(f) {
    u.value && (f.currentTarget.tagName === "LABEL" && f.preventDefault(), u.value.click(), u.value.focus({ preventScroll: !0 }));
  } } }), o = nd({ name: "SwitchDescription" });
  return et(gd, { switchRef: u, labelledby: l, describedby: o }), () => $e({ theirProps: t, ourProps: {}, slot: {}, slots: i, attrs: r, name: "SwitchGroup" });
} });
let uw = Q({ name: "Switch", emits: { "update:modelValue": (t) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-switch-${ke()}` } }, inheritAttrs: !1, setup(t, { emit: i, attrs: r, slots: u, expose: l }) {
  let o = lt(gd, null), [f, c] = Go(k(() => t.modelValue), (_) => i("update:modelValue", _), k(() => t.defaultChecked));
  function v() {
    c(!f.value);
  }
  let d = z(null), h = o === null ? d : o.switchRef, m = li(k(() => ({ as: t.as, type: r.type })), h);
  l({ el: h, $el: h });
  function y(_) {
    _.preventDefault(), v();
  }
  function w(_) {
    _.key === ae.Space ? (_.preventDefault(), v()) : _.key === ae.Enter && mb(_.currentTarget);
  }
  function x(_) {
    _.preventDefault();
  }
  let S = k(() => {
    var _, A;
    return (A = (_ = U(h)) == null ? void 0 : _.closest) == null ? void 0 : A.call(_, "form");
  });
  return Ie(() => {
    Je([S], () => {
      if (!S.value || t.defaultChecked === void 0)
        return;
      function _() {
        c(t.defaultChecked);
      }
      return S.value.addEventListener("reset", _), () => {
        var A;
        (A = S.value) == null || A.removeEventListener("reset", _);
      };
    }, { immediate: !0 });
  }), () => {
    let { id: _, name: A, value: T, ...E } = t, F = { checked: f.value }, P = { id: _, ref: h, role: "switch", type: m.value, tabIndex: 0, "aria-checked": f.value, "aria-labelledby": o == null ? void 0 : o.labelledby.value, "aria-describedby": o == null ? void 0 : o.describedby.value, onClick: y, onKeyup: w, onKeypress: x };
    return Te(rt, [A != null && f.value != null ? Te(yn, zo({ features: an.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: f.value, name: A, value: T })) : null, $e({ ourProps: P, theirProps: { ...r, ...yr(E, ["modelValue", "defaultChecked"]) }, slot: F, attrs: r, slots: u, name: "Switch" })]);
  };
} });
function sw(t) {
  let i = { called: !1 };
  return (...r) => {
    if (!i.called)
      return i.called = !0, t(...r);
  };
}
function fo(t, ...i) {
  t && i.length > 0 && t.classList.add(...i);
}
function ua(t, ...i) {
  t && i.length > 0 && t.classList.remove(...i);
}
var Ao = ((t) => (t.Finished = "finished", t.Cancelled = "cancelled", t))(Ao || {});
function fw(t, i) {
  let r = Aa();
  if (!t)
    return r.dispose;
  let { transitionDuration: u, transitionDelay: l } = getComputedStyle(t), [o, f] = [u, l].map((c) => {
    let [v = 0] = c.split(",").filter(Boolean).map((d) => d.includes("ms") ? parseFloat(d) : parseFloat(d) * 1e3).sort((d, h) => h - d);
    return v;
  });
  return o !== 0 ? r.setTimeout(() => i("finished"), o + f) : i("finished"), r.add(() => i("cancelled")), r.dispose;
}
function Hf(t, i, r, u, l, o) {
  let f = Aa(), c = o !== void 0 ? sw(o) : () => {
  };
  return ua(t, ...l), fo(t, ...i, ...r), f.nextFrame(() => {
    ua(t, ...r), fo(t, ...u), f.add(fw(t, (v) => (ua(t, ...u, ...i), fo(t, ...l), c(v))));
  }), f.add(() => ua(t, ...i, ...r, ...u, ...l)), f.add(() => c("cancelled")), f.dispose;
}
function Hn(t = "") {
  return t.split(" ").filter((i) => i.trim().length > 1);
}
let Zo = Symbol("TransitionContext");
var cw = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(cw || {});
function dw() {
  return lt(Zo, null) !== null;
}
function vw() {
  let t = lt(Zo, null);
  if (t === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return t;
}
function pw() {
  let t = lt(Jo, null);
  if (t === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return t;
}
let Jo = Symbol("NestingContext");
function Ea(t) {
  return "children" in t ? Ea(t.children) : t.value.filter(({ state: i }) => i === "visible").length > 0;
}
function yd(t) {
  let i = z([]), r = z(!1);
  Ie(() => r.value = !0), ht(() => r.value = !1);
  function u(o, f = In.Hidden) {
    let c = i.value.findIndex(({ id: v }) => v === o);
    c !== -1 && (Ce(f, { [In.Unmount]() {
      i.value.splice(c, 1);
    }, [In.Hidden]() {
      i.value[c].state = "hidden";
    } }), !Ea(i) && r.value && (t == null || t()));
  }
  function l(o) {
    let f = i.value.find(({ id: c }) => c === o);
    return f ? f.state !== "visible" && (f.state = "visible") : i.value.push({ id: o, state: "visible" }), () => u(o, In.Unmount);
  }
  return { children: i, register: l, unregister: u };
}
let bd = pt.RenderStrategy, pa = Q({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(t, { emit: i, attrs: r, slots: u, expose: l }) {
  let o = z(0);
  function f() {
    o.value |= Le.Opening, i("beforeEnter");
  }
  function c() {
    o.value &= ~Le.Opening, i("afterEnter");
  }
  function v() {
    o.value |= Le.Closing, i("beforeLeave");
  }
  function d() {
    o.value &= ~Le.Closing, i("afterLeave");
  }
  if (!dw() && ub())
    return () => Te(wd, { ...t, onBeforeEnter: f, onAfterEnter: c, onBeforeLeave: v, onAfterLeave: d }, u);
  let h = z(null), m = z("visible"), y = k(() => t.unmount ? In.Unmount : In.Hidden);
  l({ el: h, $el: h });
  let { show: w, appear: x } = vw(), { register: S, unregister: _ } = pw(), A = { value: !0 }, T = ke(), E = { value: !1 }, F = yd(() => {
    !E.value && m.value !== "hidden" && (m.value = "hidden", _(T), d());
  });
  Ie(() => {
    let ne = S(T);
    ht(ne);
  }), Xe(() => {
    if (y.value === In.Hidden && T) {
      if (w && m.value !== "visible") {
        m.value = "visible";
        return;
      }
      Ce(m.value, { hidden: () => _(T), visible: () => S(T) });
    }
  });
  let P = Hn(t.enter), R = Hn(t.enterFrom), V = Hn(t.enterTo), M = Hn(t.entered), H = Hn(t.leave), K = Hn(t.leaveFrom), Y = Hn(t.leaveTo);
  Ie(() => {
    Xe(() => {
      if (m.value === "visible") {
        let ne = U(h);
        if (ne instanceof Comment && ne.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function ee(ne) {
    let J = A.value && !x.value, oe = U(h);
    !oe || !(oe instanceof HTMLElement) || J || (E.value = !0, w.value && f(), w.value || v(), ne(w.value ? Hf(oe, P, R, V, M, (de) => {
      E.value = !1, de === Ao.Finished && c();
    }) : Hf(oe, H, K, Y, M, (de) => {
      E.value = !1, de === Ao.Finished && (Ea(F) || (m.value = "hidden", _(T), d()));
    })));
  }
  return Ie(() => {
    Je([w], (ne, J, oe) => {
      ee(oe), A.value = !1;
    }, { immediate: !0 });
  }), et(Jo, F), ai(k(() => Ce(m.value, { visible: Le.Open, hidden: Le.Closed }) | o.value)), () => {
    let { appear: ne, show: J, enter: oe, enterFrom: de, enterTo: ye, entered: We, leave: qe, leaveFrom: wn, leaveTo: bt, ...Jn } = t, Tr = { ref: h }, Va = { ...Jn, ...x && w && oi.isServer ? { class: Ee([r.class, Jn.class, ...P, ...R]) } : {} };
    return $e({ theirProps: Va, ourProps: Tr, slot: {}, slots: u, attrs: r, features: bd, visible: m.value === "visible", name: "TransitionChild" });
  };
} }), hw = pa, wd = Q({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(t, { emit: i, attrs: r, slots: u }) {
  let l = Rn(), o = k(() => t.show === null && l !== null ? (l.value & Le.Open) === Le.Open : t.show);
  Xe(() => {
    if (![!0, !1].includes(o.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let f = z(o.value ? "visible" : "hidden"), c = yd(() => {
    f.value = "hidden";
  }), v = z(!0), d = { show: o, appear: k(() => t.appear || !v.value) };
  return Ie(() => {
    Xe(() => {
      v.value = !1, o.value ? f.value = "visible" : Ea(c) || (f.value = "hidden");
    });
  }), et(Jo, c), et(Zo, d), () => {
    let h = yr(t, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), m = { unmount: t.unmount };
    return $e({ ourProps: { ...m, as: "template" }, theirProps: {}, slot: {}, slots: { ...u, default: () => [Te(hw, { onBeforeEnter: () => i("beforeEnter"), onAfterEnter: () => i("afterEnter"), onBeforeLeave: () => i("beforeLeave"), onAfterLeave: () => i("afterLeave"), ...r, ...m, ...h }, u.default)] }, attrs: {}, features: bd, visible: f.value === "visible", name: "Transition" });
  };
} });
var Ge = function() {
  return Ge = Object.assign || function(i) {
    for (var r, u = 1, l = arguments.length; u < l; u++) {
      r = arguments[u];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (i[o] = r[o]);
    }
    return i;
  }, Ge.apply(this, arguments);
};
function mw(t, i, r, u) {
  function l(o) {
    return o instanceof r ? o : new r(function(f) {
      f(o);
    });
  }
  return new (r || (r = Promise))(function(o, f) {
    function c(h) {
      try {
        d(u.next(h));
      } catch (m) {
        f(m);
      }
    }
    function v(h) {
      try {
        d(u.throw(h));
      } catch (m) {
        f(m);
      }
    }
    function d(h) {
      h.done ? o(h.value) : l(h.value).then(c, v);
    }
    d((u = u.apply(t, i || [])).next());
  });
}
function gw(t, i) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, u, l, o, f;
  return f = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (f[Symbol.iterator] = function() {
    return this;
  }), f;
  function c(d) {
    return function(h) {
      return v([d, h]);
    };
  }
  function v(d) {
    if (u)
      throw new TypeError("Generator is already executing.");
    for (; f && (f = 0, d[0] && (r = 0)), r; )
      try {
        if (u = 1, l && (o = d[0] & 2 ? l.return : d[0] ? l.throw || ((o = l.return) && o.call(l), 0) : l.next) && !(o = o.call(l, d[1])).done)
          return o;
        switch (l = 0, o && (d = [d[0] & 2, o.value]), d[0]) {
          case 0:
          case 1:
            o = d;
            break;
          case 4:
            return r.label++, { value: d[1], done: !1 };
          case 5:
            r.label++, l = d[1], d = [0];
            continue;
          case 7:
            d = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (d[0] === 6 || d[0] === 2)) {
              r = 0;
              continue;
            }
            if (d[0] === 3 && (!o || d[1] > o[0] && d[1] < o[3])) {
              r.label = d[1];
              break;
            }
            if (d[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = d;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(d);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        d = i.call(t, r);
      } catch (h) {
        d = [6, h], l = 0;
      } finally {
        u = o = 0;
      }
    if (d[0] & 5)
      throw d[1];
    return { value: d[0] ? d[1] : void 0, done: !0 };
  }
}
function xe(t) {
  var i = typeof Symbol == "function" && Symbol.iterator, r = i && t[i], u = 0;
  if (r)
    return r.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && u >= t.length && (t = void 0), { value: t && t[u++], done: !t };
      }
    };
  throw new TypeError(i ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Qe(t, i) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var u = r.call(t), l, o = [], f;
  try {
    for (; (i === void 0 || i-- > 0) && !(l = u.next()).done; )
      o.push(l.value);
  } catch (c) {
    f = { error: c };
  } finally {
    try {
      l && !l.done && (r = u.return) && r.call(u);
    } finally {
      if (f)
        throw f.error;
    }
  }
  return o;
}
var yw = "ENTRIES", xd = "KEYS", _d = "VALUES", st = "", co = (
  /** @class */
  function() {
    function t(i, r) {
      var u = i._tree, l = Array.from(u.keys());
      this.set = i, this._type = r, this._path = l.length > 0 ? [{ node: u, keys: l }] : [];
    }
    return t.prototype.next = function() {
      var i = this.dive();
      return this.backtrack(), i;
    }, t.prototype.dive = function() {
      if (this._path.length === 0)
        return { done: !0, value: void 0 };
      var i = hr(this._path), r = i.node, u = i.keys;
      if (hr(u) === st)
        return { done: !1, value: this.result() };
      var l = r.get(hr(u));
      return this._path.push({ node: l, keys: Array.from(l.keys()) }), this.dive();
    }, t.prototype.backtrack = function() {
      if (this._path.length !== 0) {
        var i = hr(this._path).keys;
        i.pop(), !(i.length > 0) && (this._path.pop(), this.backtrack());
      }
    }, t.prototype.key = function() {
      return this.set._prefix + this._path.map(function(i) {
        var r = i.keys;
        return hr(r);
      }).filter(function(i) {
        return i !== st;
      }).join("");
    }, t.prototype.value = function() {
      return hr(this._path).node.get(st);
    }, t.prototype.result = function() {
      switch (this._type) {
        case _d:
          return this.value();
        case xd:
          return this.key();
        default:
          return [this.key(), this.value()];
      }
    }, t.prototype[Symbol.iterator] = function() {
      return this;
    }, t;
  }()
), hr = function(t) {
  return t[t.length - 1];
}, bw = function(t, i, r) {
  var u = /* @__PURE__ */ new Map();
  if (i === void 0)
    return u;
  for (var l = i.length + 1, o = l + r, f = new Uint8Array(o * l).fill(r + 1), c = 0; c < l; ++c)
    f[c] = c;
  for (var v = 1; v < o; ++v)
    f[v * l] = v;
  return Sd(t, i, r, u, f, 1, l, ""), u;
}, Sd = function(t, i, r, u, l, o, f, c) {
  var v, d, h = o * f;
  try {
    e:
      for (var m = xe(t.keys()), y = m.next(); !y.done; y = m.next()) {
        var w = y.value;
        if (w === st) {
          var x = l[h - 1];
          x <= r && u.set(c, [t.get(w), x]);
        } else {
          for (var S = o, _ = 0; _ < w.length; ++_, ++S) {
            for (var A = w[_], T = f * S, E = T - f, F = l[T], P = Math.max(0, S - r - 1), R = Math.min(f - 1, S + r), V = P; V < R; ++V) {
              var M = A !== i[V], H = l[E + V] + +M, K = l[E + V + 1] + 1, Y = l[T + V] + 1, ee = l[T + V + 1] = Math.min(H, K, Y);
              ee < F && (F = ee);
            }
            if (F > r)
              continue e;
          }
          Sd(t.get(w), i, r, u, l, S, f, c + w);
        }
      }
  } catch (ne) {
    v = { error: ne };
  } finally {
    try {
      y && !y.done && (d = m.return) && d.call(m);
    } finally {
      if (v)
        throw v.error;
    }
  }
}, vo = (
  /** @class */
  function() {
    function t(i, r) {
      i === void 0 && (i = /* @__PURE__ */ new Map()), r === void 0 && (r = ""), this._size = void 0, this._tree = i, this._prefix = r;
    }
    return t.prototype.atPrefix = function(i) {
      var r, u;
      if (!i.startsWith(this._prefix))
        throw new Error("Mismatched prefix");
      var l = Qe(ha(this._tree, i.slice(this._prefix.length)), 2), o = l[0], f = l[1];
      if (o === void 0) {
        var c = Qe(Xo(f), 2), v = c[0], d = c[1];
        try {
          for (var h = xe(v.keys()), m = h.next(); !m.done; m = h.next()) {
            var y = m.value;
            if (y !== st && y.startsWith(d)) {
              var w = /* @__PURE__ */ new Map();
              return w.set(y.slice(d.length), v.get(y)), new t(w, i);
            }
          }
        } catch (x) {
          r = { error: x };
        } finally {
          try {
            m && !m.done && (u = h.return) && u.call(h);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
      return new t(o, i);
    }, t.prototype.clear = function() {
      this._size = void 0, this._tree.clear();
    }, t.prototype.delete = function(i) {
      return this._size = void 0, ww(this._tree, i);
    }, t.prototype.entries = function() {
      return new co(this, yw);
    }, t.prototype.forEach = function(i) {
      var r, u;
      try {
        for (var l = xe(this), o = l.next(); !o.done; o = l.next()) {
          var f = Qe(o.value, 2), c = f[0], v = f[1];
          i(c, v, this);
        }
      } catch (d) {
        r = { error: d };
      } finally {
        try {
          o && !o.done && (u = l.return) && u.call(l);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }, t.prototype.fuzzyGet = function(i, r) {
      return bw(this._tree, i, r);
    }, t.prototype.get = function(i) {
      var r = To(this._tree, i);
      return r !== void 0 ? r.get(st) : void 0;
    }, t.prototype.has = function(i) {
      var r = To(this._tree, i);
      return r !== void 0 && r.has(st);
    }, t.prototype.keys = function() {
      return new co(this, xd);
    }, t.prototype.set = function(i, r) {
      if (typeof i != "string")
        throw new Error("key must be a string");
      this._size = void 0;
      var u = po(this._tree, i);
      return u.set(st, r), this;
    }, Object.defineProperty(t.prototype, "size", {
      /**
       * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map/size
       */
      get: function() {
        if (this._size)
          return this._size;
        this._size = 0;
        for (var i = this.entries(); !i.next().done; )
          this._size += 1;
        return this._size;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.update = function(i, r) {
      if (typeof i != "string")
        throw new Error("key must be a string");
      this._size = void 0;
      var u = po(this._tree, i);
      return u.set(st, r(u.get(st))), this;
    }, t.prototype.fetch = function(i, r) {
      if (typeof i != "string")
        throw new Error("key must be a string");
      this._size = void 0;
      var u = po(this._tree, i), l = u.get(st);
      return l === void 0 && u.set(st, l = r()), l;
    }, t.prototype.values = function() {
      return new co(this, _d);
    }, t.prototype[Symbol.iterator] = function() {
      return this.entries();
    }, t.from = function(i) {
      var r, u, l = new t();
      try {
        for (var o = xe(i), f = o.next(); !f.done; f = o.next()) {
          var c = Qe(f.value, 2), v = c[0], d = c[1];
          l.set(v, d);
        }
      } catch (h) {
        r = { error: h };
      } finally {
        try {
          f && !f.done && (u = o.return) && u.call(o);
        } finally {
          if (r)
            throw r.error;
        }
      }
      return l;
    }, t.fromObject = function(i) {
      return t.from(Object.entries(i));
    }, t;
  }()
), ha = function(t, i, r) {
  var u, l;
  if (r === void 0 && (r = []), i.length === 0 || t == null)
    return [t, r];
  try {
    for (var o = xe(t.keys()), f = o.next(); !f.done; f = o.next()) {
      var c = f.value;
      if (c !== st && i.startsWith(c))
        return r.push([t, c]), ha(t.get(c), i.slice(c.length), r);
    }
  } catch (v) {
    u = { error: v };
  } finally {
    try {
      f && !f.done && (l = o.return) && l.call(o);
    } finally {
      if (u)
        throw u.error;
    }
  }
  return r.push([t, i]), ha(void 0, "", r);
}, To = function(t, i) {
  var r, u;
  if (i.length === 0 || t == null)
    return t;
  try {
    for (var l = xe(t.keys()), o = l.next(); !o.done; o = l.next()) {
      var f = o.value;
      if (f !== st && i.startsWith(f))
        return To(t.get(f), i.slice(f.length));
    }
  } catch (c) {
    r = { error: c };
  } finally {
    try {
      o && !o.done && (u = l.return) && u.call(l);
    } finally {
      if (r)
        throw r.error;
    }
  }
}, po = function(t, i) {
  var r, u, l = i.length;
  e:
    for (var o = 0; t && o < l; ) {
      try {
        for (var f = (r = void 0, xe(t.keys())), c = f.next(); !c.done; c = f.next()) {
          var v = c.value;
          if (v !== st && i[o] === v[0]) {
            for (var d = Math.min(l - o, v.length), h = 1; h < d && i[o + h] === v[h]; )
              ++h;
            var m = t.get(v);
            if (h === v.length)
              t = m;
            else {
              var y = /* @__PURE__ */ new Map();
              y.set(v.slice(h), m), t.set(i.slice(o, o + h), y), t.delete(v), t = y;
            }
            o += h;
            continue e;
          }
        }
      } catch (x) {
        r = { error: x };
      } finally {
        try {
          c && !c.done && (u = f.return) && u.call(f);
        } finally {
          if (r)
            throw r.error;
        }
      }
      var w = /* @__PURE__ */ new Map();
      return t.set(i.slice(o), w), w;
    }
  return t;
}, ww = function(t, i) {
  var r = Qe(ha(t, i), 2), u = r[0], l = r[1];
  if (u !== void 0) {
    if (u.delete(st), u.size === 0)
      $d(l);
    else if (u.size === 1) {
      var o = Qe(u.entries().next().value, 2), f = o[0], c = o[1];
      Ad(l, f, c);
    }
  }
}, $d = function(t) {
  if (t.length !== 0) {
    var i = Qe(Xo(t), 2), r = i[0], u = i[1];
    if (r.delete(u), r.size === 0)
      $d(t.slice(0, -1));
    else if (r.size === 1) {
      var l = Qe(r.entries().next().value, 2), o = l[0], f = l[1];
      o !== st && Ad(t.slice(0, -1), o, f);
    }
  }
}, Ad = function(t, i, r) {
  if (t.length !== 0) {
    var u = Qe(Xo(t), 2), l = u[0], o = u[1];
    l.set(o + i, r), l.delete(o);
  }
}, Xo = function(t) {
  return t[t.length - 1];
}, Jr, Qo = "or", Td = "and", xw = "and_not", Cd = (
  /** @class */
  function() {
    function t(i) {
      if ((i == null ? void 0 : i.fields) == null)
        throw new Error('MiniSearch: option "fields" must be provided');
      var r = i.autoVacuum == null || i.autoVacuum === !0 ? go : i.autoVacuum;
      this._options = Ge(Ge(Ge({}, mo), i), { autoVacuum: r, searchOptions: Ge(Ge({}, Gf), i.searchOptions || {}), autoSuggestOptions: Ge(Ge({}, Tw), i.autoSuggestOptions || {}) }), this._index = new vo(), this._documentCount = 0, this._documentIds = /* @__PURE__ */ new Map(), this._idToShortId = /* @__PURE__ */ new Map(), this._fieldIds = {}, this._fieldLength = /* @__PURE__ */ new Map(), this._avgFieldLength = [], this._nextId = 0, this._storedFields = /* @__PURE__ */ new Map(), this._dirtCount = 0, this._currentVacuum = null, this._enqueuedVacuum = null, this._enqueuedVacuumConditions = Eo, this.addFields(this._options.fields);
    }
    return t.prototype.add = function(i) {
      var r, u, l, o, f, c, v = this._options, d = v.extractField, h = v.tokenize, m = v.processTerm, y = v.fields, w = v.idField, x = d(i, w);
      if (x == null)
        throw new Error('MiniSearch: document does not have ID field "'.concat(w, '"'));
      if (this._idToShortId.has(x))
        throw new Error("MiniSearch: duplicate ID ".concat(x));
      var S = this.addDocumentId(x);
      this.saveStoredFields(S, i);
      try {
        for (var _ = xe(y), A = _.next(); !A.done; A = _.next()) {
          var T = A.value, E = d(i, T);
          if (E != null) {
            var F = h(E.toString(), T), P = this._fieldIds[T], R = new Set(F).size;
            this.addFieldLength(S, P, this._documentCount - 1, R);
            try {
              for (var V = (l = void 0, xe(F)), M = V.next(); !M.done; M = V.next()) {
                var H = M.value, K = m(H, T);
                if (Array.isArray(K))
                  try {
                    for (var Y = (f = void 0, xe(K)), ee = Y.next(); !ee.done; ee = Y.next()) {
                      var ne = ee.value;
                      this.addTerm(P, S, ne);
                    }
                  } catch (J) {
                    f = { error: J };
                  } finally {
                    try {
                      ee && !ee.done && (c = Y.return) && c.call(Y);
                    } finally {
                      if (f)
                        throw f.error;
                    }
                  }
                else
                  K && this.addTerm(P, S, K);
              }
            } catch (J) {
              l = { error: J };
            } finally {
              try {
                M && !M.done && (o = V.return) && o.call(V);
              } finally {
                if (l)
                  throw l.error;
              }
            }
          }
        }
      } catch (J) {
        r = { error: J };
      } finally {
        try {
          A && !A.done && (u = _.return) && u.call(_);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }, t.prototype.addAll = function(i) {
      var r, u;
      try {
        for (var l = xe(i), o = l.next(); !o.done; o = l.next()) {
          var f = o.value;
          this.add(f);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          o && !o.done && (u = l.return) && u.call(l);
        } finally {
          if (r)
            throw r.error;
        }
      }
    }, t.prototype.addAllAsync = function(i, r) {
      var u = this;
      r === void 0 && (r = {});
      var l = r.chunkSize, o = l === void 0 ? 10 : l, f = { chunk: [], promise: Promise.resolve() }, c = i.reduce(function(h, m, y) {
        var w = h.chunk, x = h.promise;
        return w.push(m), (y + 1) % o === 0 ? {
          chunk: [],
          promise: x.then(function() {
            return new Promise(function(S) {
              return setTimeout(S, 0);
            });
          }).then(function() {
            return u.addAll(w);
          })
        } : { chunk: w, promise: x };
      }, f), v = c.chunk, d = c.promise;
      return d.then(function() {
        return u.addAll(v);
      });
    }, t.prototype.remove = function(i) {
      var r, u, l, o, f, c, v = this._options, d = v.tokenize, h = v.processTerm, m = v.extractField, y = v.fields, w = v.idField, x = m(i, w);
      if (x == null)
        throw new Error('MiniSearch: document does not have ID field "'.concat(w, '"'));
      var S = this._idToShortId.get(x);
      if (S == null)
        throw new Error("MiniSearch: cannot remove document with ID ".concat(x, ": it is not in the index"));
      try {
        for (var _ = xe(y), A = _.next(); !A.done; A = _.next()) {
          var T = A.value, E = m(i, T);
          if (E != null) {
            var F = d(E.toString(), T), P = this._fieldIds[T], R = new Set(F).size;
            this.removeFieldLength(S, P, this._documentCount, R);
            try {
              for (var V = (l = void 0, xe(F)), M = V.next(); !M.done; M = V.next()) {
                var H = M.value, K = h(H, T);
                if (Array.isArray(K))
                  try {
                    for (var Y = (f = void 0, xe(K)), ee = Y.next(); !ee.done; ee = Y.next()) {
                      var ne = ee.value;
                      this.removeTerm(P, S, ne);
                    }
                  } catch (J) {
                    f = { error: J };
                  } finally {
                    try {
                      ee && !ee.done && (c = Y.return) && c.call(Y);
                    } finally {
                      if (f)
                        throw f.error;
                    }
                  }
                else
                  K && this.removeTerm(P, S, K);
              }
            } catch (J) {
              l = { error: J };
            } finally {
              try {
                M && !M.done && (o = V.return) && o.call(V);
              } finally {
                if (l)
                  throw l.error;
              }
            }
          }
        }
      } catch (J) {
        r = { error: J };
      } finally {
        try {
          A && !A.done && (u = _.return) && u.call(_);
        } finally {
          if (r)
            throw r.error;
        }
      }
      this._storedFields.delete(S), this._documentIds.delete(S), this._idToShortId.delete(x), this._fieldLength.delete(S), this._documentCount -= 1;
    }, t.prototype.removeAll = function(i) {
      var r, u;
      if (i)
        try {
          for (var l = xe(i), o = l.next(); !o.done; o = l.next()) {
            var f = o.value;
            this.remove(f);
          }
        } catch (c) {
          r = { error: c };
        } finally {
          try {
            o && !o.done && (u = l.return) && u.call(l);
          } finally {
            if (r)
              throw r.error;
          }
        }
      else {
        if (arguments.length > 0)
          throw new Error("Expected documents to be present. Omit the argument to remove all documents.");
        this._index = new vo(), this._documentCount = 0, this._documentIds = /* @__PURE__ */ new Map(), this._idToShortId = /* @__PURE__ */ new Map(), this._fieldLength = /* @__PURE__ */ new Map(), this._avgFieldLength = [], this._storedFields = /* @__PURE__ */ new Map(), this._nextId = 0;
      }
    }, t.prototype.discard = function(i) {
      var r = this, u = this._idToShortId.get(i);
      if (u == null)
        throw new Error("MiniSearch: cannot discard document with ID ".concat(i, ": it is not in the index"));
      this._idToShortId.delete(i), this._documentIds.delete(u), this._storedFields.delete(u), (this._fieldLength.get(u) || []).forEach(function(l, o) {
        r.removeFieldLength(u, o, r._documentCount, l);
      }), this._fieldLength.delete(u), this._documentCount -= 1, this._dirtCount += 1, this.maybeAutoVacuum();
    }, t.prototype.maybeAutoVacuum = function() {
      if (this._options.autoVacuum !== !1) {
        var i = this._options.autoVacuum, r = i.minDirtFactor, u = i.minDirtCount, l = i.batchSize, o = i.batchWait;
        this.conditionalVacuum({ batchSize: l, batchWait: o }, { minDirtCount: u, minDirtFactor: r });
      }
    }, t.prototype.discardAll = function(i) {
      var r, u, l = this._options.autoVacuum;
      try {
        this._options.autoVacuum = !1;
        try {
          for (var o = xe(i), f = o.next(); !f.done; f = o.next()) {
            var c = f.value;
            this.discard(c);
          }
        } catch (v) {
          r = { error: v };
        } finally {
          try {
            f && !f.done && (u = o.return) && u.call(o);
          } finally {
            if (r)
              throw r.error;
          }
        }
      } finally {
        this._options.autoVacuum = l;
      }
      this.maybeAutoVacuum();
    }, t.prototype.replace = function(i) {
      var r = this._options, u = r.idField, l = r.extractField, o = l(i, u);
      this.discard(o), this.add(i);
    }, t.prototype.vacuum = function(i) {
      return i === void 0 && (i = {}), this.conditionalVacuum(i);
    }, t.prototype.conditionalVacuum = function(i, r) {
      var u = this;
      return this._currentVacuum ? (this._enqueuedVacuumConditions = this._enqueuedVacuumConditions && r, this._enqueuedVacuum != null ? this._enqueuedVacuum : (this._enqueuedVacuum = this._currentVacuum.then(function() {
        var l = u._enqueuedVacuumConditions;
        return u._enqueuedVacuumConditions = Eo, u.performVacuuming(i, l);
      }), this._enqueuedVacuum)) : this.vacuumConditionsMet(r) === !1 ? Promise.resolve() : (this._currentVacuum = this.performVacuuming(i), this._currentVacuum);
    }, t.prototype.performVacuuming = function(i, r) {
      return mw(this, void 0, void 0, function() {
        var u, l, o, f, c, v, d, h, m, y, w, x, S, _, A, T, E, F, P, R, V, M, H, K, Y;
        return gw(this, function(ee) {
          switch (ee.label) {
            case 0:
              if (u = this._dirtCount, !this.vacuumConditionsMet(r))
                return [3, 10];
              l = i.batchSize || Co.batchSize, o = i.batchWait || Co.batchWait, f = 1, ee.label = 1;
            case 1:
              ee.trys.push([1, 7, 8, 9]), c = xe(this._index), v = c.next(), ee.label = 2;
            case 2:
              if (v.done)
                return [3, 6];
              d = Qe(v.value, 2), h = d[0], m = d[1];
              try {
                for (y = (M = void 0, xe(m)), w = y.next(); !w.done; w = y.next()) {
                  x = Qe(w.value, 2), S = x[0], _ = x[1];
                  try {
                    for (A = (K = void 0, xe(_)), T = A.next(); !T.done; T = A.next())
                      E = Qe(T.value, 1), F = E[0], !this._documentIds.has(F) && (_.size <= 1 ? m.delete(S) : _.delete(F));
                  } catch (ne) {
                    K = { error: ne };
                  } finally {
                    try {
                      T && !T.done && (Y = A.return) && Y.call(A);
                    } finally {
                      if (K)
                        throw K.error;
                    }
                  }
                }
              } catch (ne) {
                M = { error: ne };
              } finally {
                try {
                  w && !w.done && (H = y.return) && H.call(y);
                } finally {
                  if (M)
                    throw M.error;
                }
              }
              return this._index.get(h).size === 0 && this._index.delete(h), f % l !== 0 ? [3, 4] : [4, new Promise(function(ne) {
                return setTimeout(ne, o);
              })];
            case 3:
              ee.sent(), ee.label = 4;
            case 4:
              f += 1, ee.label = 5;
            case 5:
              return v = c.next(), [3, 2];
            case 6:
              return [3, 9];
            case 7:
              return P = ee.sent(), R = { error: P }, [3, 9];
            case 8:
              try {
                v && !v.done && (V = c.return) && V.call(c);
              } finally {
                if (R)
                  throw R.error;
              }
              return [
                7
                /*endfinally*/
              ];
            case 9:
              this._dirtCount -= u, ee.label = 10;
            case 10:
              return [4, null];
            case 11:
              return ee.sent(), this._currentVacuum = this._enqueuedVacuum, this._enqueuedVacuum = null, [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.vacuumConditionsMet = function(i) {
      if (i == null)
        return !0;
      var r = i.minDirtCount, u = i.minDirtFactor;
      return r = r || go.minDirtCount, u = u || go.minDirtFactor, this.dirtCount >= r && this.dirtFactor >= u;
    }, Object.defineProperty(t.prototype, "isVacuuming", {
      /**
       * Is `true` if a vacuuming operation is ongoing, `false` otherwise
       */
      get: function() {
        return this._currentVacuum != null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "dirtCount", {
      /**
       * The number of documents discarded since the most recent vacuuming
       */
      get: function() {
        return this._dirtCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "dirtFactor", {
      /**
       * A number between 0 and 1 giving an indication about the proportion of
       * documents that are discarded, and can therefore be cleaned up by vacuuming.
       * A value close to 0 means that the index is relatively clean, while a higher
       * value means that the index is relatively dirty, and vacuuming could release
       * memory.
       */
      get: function() {
        return this._dirtCount / (1 + this._documentCount + this._dirtCount);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.has = function(i) {
      return this._idToShortId.has(i);
    }, t.prototype.search = function(i, r) {
      var u, l;
      r === void 0 && (r = {});
      var o = this.executeQuery(i, r), f = [];
      try {
        for (var c = xe(o), v = c.next(); !v.done; v = c.next()) {
          var d = Qe(v.value, 2), h = d[0], m = d[1], y = m.score, w = m.terms, x = m.match, S = w.length, _ = {
            id: this._documentIds.get(h),
            score: y * S,
            terms: Object.keys(x),
            match: x
          };
          Object.assign(_, this._storedFields.get(h)), (r.filter == null || r.filter(_)) && f.push(_);
        }
      } catch (A) {
        u = { error: A };
      } finally {
        try {
          v && !v.done && (l = c.return) && l.call(c);
        } finally {
          if (u)
            throw u.error;
        }
      }
      return f.sort(Kf), f;
    }, t.prototype.autoSuggest = function(i, r) {
      var u, l, o, f;
      r === void 0 && (r = {}), r = Ge(Ge({}, this._options.autoSuggestOptions), r);
      var c = /* @__PURE__ */ new Map();
      try {
        for (var v = xe(this.search(i, r)), d = v.next(); !d.done; d = v.next()) {
          var h = d.value, m = h.score, y = h.terms, w = y.join(" "), x = c.get(w);
          x != null ? (x.score += m, x.count += 1) : c.set(w, { score: m, terms: y, count: 1 });
        }
      } catch (P) {
        u = { error: P };
      } finally {
        try {
          d && !d.done && (l = v.return) && l.call(v);
        } finally {
          if (u)
            throw u.error;
        }
      }
      var S = [];
      try {
        for (var _ = xe(c), A = _.next(); !A.done; A = _.next()) {
          var T = Qe(A.value, 2), x = T[0], E = T[1], m = E.score, y = E.terms, F = E.count;
          S.push({ suggestion: x, terms: y, score: m / F });
        }
      } catch (P) {
        o = { error: P };
      } finally {
        try {
          A && !A.done && (f = _.return) && f.call(_);
        } finally {
          if (o)
            throw o.error;
        }
      }
      return S.sort(Kf), S;
    }, Object.defineProperty(t.prototype, "documentCount", {
      /**
       * Total number of documents available to search
       */
      get: function() {
        return this._documentCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "termCount", {
      /**
       * Number of terms in the index
       */
      get: function() {
        return this._index.size;
      },
      enumerable: !1,
      configurable: !0
    }), t.loadJSON = function(i, r) {
      if (r == null)
        throw new Error("MiniSearch: loadJSON should be given the same options used when serializing the index");
      return this.loadJS(JSON.parse(i), r);
    }, t.getDefault = function(i) {
      if (mo.hasOwnProperty(i))
        return ho(mo, i);
      throw new Error('MiniSearch: unknown option "'.concat(i, '"'));
    }, t.loadJS = function(i, r) {
      var u, l, o, f, c, v, d = i.index, h = i.documentCount, m = i.nextId, y = i.documentIds, w = i.fieldIds, x = i.fieldLength, S = i.averageFieldLength, _ = i.storedFields, A = i.dirtCount, T = i.serializationVersion;
      if (T !== 1 && T !== 2)
        throw new Error("MiniSearch: cannot deserialize an index created with an incompatible version");
      var E = new t(r);
      E._documentCount = h, E._nextId = m, E._documentIds = sa(y), E._idToShortId = /* @__PURE__ */ new Map(), E._fieldIds = w, E._fieldLength = sa(x), E._avgFieldLength = S, E._storedFields = sa(_), E._dirtCount = A || 0, E._index = new vo();
      try {
        for (var F = xe(E._documentIds), P = F.next(); !P.done; P = F.next()) {
          var R = Qe(P.value, 2), V = R[0], M = R[1];
          E._idToShortId.set(M, V);
        }
      } catch (qe) {
        u = { error: qe };
      } finally {
        try {
          P && !P.done && (l = F.return) && l.call(F);
        } finally {
          if (u)
            throw u.error;
        }
      }
      try {
        for (var H = xe(d), K = H.next(); !K.done; K = H.next()) {
          var Y = Qe(K.value, 2), ee = Y[0], ne = Y[1], J = /* @__PURE__ */ new Map();
          try {
            for (var oe = (c = void 0, xe(Object.keys(ne))), de = oe.next(); !de.done; de = oe.next()) {
              var ye = de.value, We = ne[ye];
              T === 1 && (We = We.ds), J.set(parseInt(ye, 10), sa(We));
            }
          } catch (qe) {
            c = { error: qe };
          } finally {
            try {
              de && !de.done && (v = oe.return) && v.call(oe);
            } finally {
              if (c)
                throw c.error;
            }
          }
          E._index.set(ee, J);
        }
      } catch (qe) {
        o = { error: qe };
      } finally {
        try {
          K && !K.done && (f = H.return) && f.call(H);
        } finally {
          if (o)
            throw o.error;
        }
      }
      return E;
    }, t.prototype.executeQuery = function(i, r) {
      var u = this;
      if (r === void 0 && (r = {}), typeof i != "string") {
        var l = Ge(Ge(Ge({}, r), i), { queries: void 0 }), o = i.queries.map(function(_) {
          return u.executeQuery(_, l);
        });
        return this.combineResults(o, l.combineWith);
      }
      var f = this._options, c = f.tokenize, v = f.processTerm, d = f.searchOptions, h = Ge(Ge({ tokenize: c, processTerm: v }, d), r), m = h.tokenize, y = h.processTerm, w = m(i).flatMap(function(_) {
        return y(_);
      }).filter(function(_) {
        return !!_;
      }), x = w.map(Aw(h)), S = x.map(function(_) {
        return u.executeQuerySpec(_, h);
      });
      return this.combineResults(S, h.combineWith);
    }, t.prototype.executeQuerySpec = function(i, r) {
      var u, l, o, f, c = Ge(Ge({}, this._options.searchOptions), r), v = (c.fields || this._options.fields).reduce(function(ye, We) {
        var qe;
        return Ge(Ge({}, ye), (qe = {}, qe[We] = ho(c.boost, We) || 1, qe));
      }, {}), d = c.boostDocument, h = c.weights, m = c.maxFuzzy, y = c.bm25, w = Ge(Ge({}, Gf.weights), h), x = w.fuzzy, S = w.prefix, _ = this._index.get(i.term), A = this.termResults(i.term, i.term, 1, _, v, d, y), T, E;
      if (i.prefix && (T = this._index.atPrefix(i.term)), i.fuzzy) {
        var F = i.fuzzy === !0 ? 0.2 : i.fuzzy, P = F < 1 ? Math.min(m, Math.round(i.term.length * F)) : F;
        P && (E = this._index.fuzzyGet(i.term, P));
      }
      if (T)
        try {
          for (var R = xe(T), V = R.next(); !V.done; V = R.next()) {
            var M = Qe(V.value, 2), H = M[0], K = M[1], Y = H.length - i.term.length;
            if (Y) {
              E == null || E.delete(H);
              var ee = S * H.length / (H.length + 0.3 * Y);
              this.termResults(i.term, H, ee, K, v, d, y, A);
            }
          }
        } catch (ye) {
          u = { error: ye };
        } finally {
          try {
            V && !V.done && (l = R.return) && l.call(R);
          } finally {
            if (u)
              throw u.error;
          }
        }
      if (E)
        try {
          for (var ne = xe(E.keys()), J = ne.next(); !J.done; J = ne.next()) {
            var H = J.value, oe = Qe(E.get(H), 2), de = oe[0], Y = oe[1];
            if (Y) {
              var ee = x * H.length / (H.length + Y);
              this.termResults(i.term, H, ee, de, v, d, y, A);
            }
          }
        } catch (ye) {
          o = { error: ye };
        } finally {
          try {
            J && !J.done && (f = ne.return) && f.call(ne);
          } finally {
            if (o)
              throw o.error;
          }
        }
      return A;
    }, t.prototype.combineResults = function(i, r) {
      if (r === void 0 && (r = Qo), i.length === 0)
        return /* @__PURE__ */ new Map();
      var u = r.toLowerCase();
      return i.reduce(_w[u]) || /* @__PURE__ */ new Map();
    }, t.prototype.toJSON = function() {
      var i, r, u, l, o = [];
      try {
        for (var f = xe(this._index), c = f.next(); !c.done; c = f.next()) {
          var v = Qe(c.value, 2), d = v[0], h = v[1], m = {};
          try {
            for (var y = (u = void 0, xe(h)), w = y.next(); !w.done; w = y.next()) {
              var x = Qe(w.value, 2), S = x[0], _ = x[1];
              m[S] = Object.fromEntries(_);
            }
          } catch (A) {
            u = { error: A };
          } finally {
            try {
              w && !w.done && (l = y.return) && l.call(y);
            } finally {
              if (u)
                throw u.error;
            }
          }
          o.push([d, m]);
        }
      } catch (A) {
        i = { error: A };
      } finally {
        try {
          c && !c.done && (r = f.return) && r.call(f);
        } finally {
          if (i)
            throw i.error;
        }
      }
      return {
        documentCount: this._documentCount,
        nextId: this._nextId,
        documentIds: Object.fromEntries(this._documentIds),
        fieldIds: this._fieldIds,
        fieldLength: Object.fromEntries(this._fieldLength),
        averageFieldLength: this._avgFieldLength,
        storedFields: Object.fromEntries(this._storedFields),
        dirtCount: this._dirtCount,
        index: o,
        serializationVersion: 2
      };
    }, t.prototype.termResults = function(i, r, u, l, o, f, c, v) {
      var d, h, m, y, w;
      if (v === void 0 && (v = /* @__PURE__ */ new Map()), l == null)
        return v;
      try {
        for (var x = xe(Object.keys(o)), S = x.next(); !S.done; S = x.next()) {
          var _ = S.value, A = o[_], T = this._fieldIds[_], E = l.get(T);
          if (E != null) {
            var F = E.size, P = this._avgFieldLength[T];
            try {
              for (var R = (m = void 0, xe(E.keys())), V = R.next(); !V.done; V = R.next()) {
                var M = V.value;
                if (!this._documentIds.has(M)) {
                  this.removeTerm(T, M, r), F -= 1;
                  continue;
                }
                var H = f ? f(this._documentIds.get(M), r) : 1;
                if (H) {
                  var K = E.get(M), Y = this._fieldLength.get(M)[T], ee = $w(K, F, this._documentCount, Y, P, c), ne = u * A * H * ee, J = v.get(M);
                  if (J) {
                    J.score += ne, Cw(J.terms, i);
                    var oe = ho(J.match, r);
                    oe ? oe.push(_) : J.match[r] = [_];
                  } else
                    v.set(M, {
                      score: ne,
                      terms: [i],
                      match: (w = {}, w[r] = [_], w)
                    });
                }
              }
            } catch (de) {
              m = { error: de };
            } finally {
              try {
                V && !V.done && (y = R.return) && y.call(R);
              } finally {
                if (m)
                  throw m.error;
              }
            }
          }
        }
      } catch (de) {
        d = { error: de };
      } finally {
        try {
          S && !S.done && (h = x.return) && h.call(x);
        } finally {
          if (d)
            throw d.error;
        }
      }
      return v;
    }, t.prototype.addTerm = function(i, r, u) {
      var l = this._index.fetch(u, qf), o = l.get(i);
      if (o == null)
        o = /* @__PURE__ */ new Map(), o.set(r, 1), l.set(i, o);
      else {
        var f = o.get(r);
        o.set(r, (f || 0) + 1);
      }
    }, t.prototype.removeTerm = function(i, r, u) {
      if (!this._index.has(u)) {
        this.warnDocumentChanged(r, i, u);
        return;
      }
      var l = this._index.fetch(u, qf), o = l.get(i);
      o == null || o.get(r) == null ? this.warnDocumentChanged(r, i, u) : o.get(r) <= 1 ? o.size <= 1 ? l.delete(i) : o.delete(r) : o.set(r, o.get(r) - 1), this._index.get(u).size === 0 && this._index.delete(u);
    }, t.prototype.warnDocumentChanged = function(i, r, u) {
      var l, o;
      try {
        for (var f = xe(Object.keys(this._fieldIds)), c = f.next(); !c.done; c = f.next()) {
          var v = c.value;
          if (this._fieldIds[v] === r) {
            this._options.logger("warn", "MiniSearch: document with ID ".concat(this._documentIds.get(i), ' has changed before removal: term "').concat(u, '" was not present in field "').concat(v, '". Removing a document after it has changed can corrupt the index!'), "version_conflict");
            return;
          }
        }
      } catch (d) {
        l = { error: d };
      } finally {
        try {
          c && !c.done && (o = f.return) && o.call(f);
        } finally {
          if (l)
            throw l.error;
        }
      }
    }, t.prototype.addDocumentId = function(i) {
      var r = this._nextId;
      return this._idToShortId.set(i, r), this._documentIds.set(r, i), this._documentCount += 1, this._nextId += 1, r;
    }, t.prototype.addFields = function(i) {
      for (var r = 0; r < i.length; r++)
        this._fieldIds[i[r]] = r;
    }, t.prototype.addFieldLength = function(i, r, u, l) {
      var o = this._fieldLength.get(i);
      o == null && this._fieldLength.set(i, o = []), o[r] = l;
      var f = this._avgFieldLength[r] || 0, c = f * u + l;
      this._avgFieldLength[r] = c / (u + 1);
    }, t.prototype.removeFieldLength = function(i, r, u, l) {
      if (u === 1) {
        this._avgFieldLength[r] = 0;
        return;
      }
      var o = this._avgFieldLength[r] * u - l;
      this._avgFieldLength[r] = o / (u - 1);
    }, t.prototype.saveStoredFields = function(i, r) {
      var u, l, o = this._options, f = o.storeFields, c = o.extractField;
      if (!(f == null || f.length === 0)) {
        var v = this._storedFields.get(i);
        v == null && this._storedFields.set(i, v = {});
        try {
          for (var d = xe(f), h = d.next(); !h.done; h = d.next()) {
            var m = h.value, y = c(r, m);
            y !== void 0 && (v[m] = y);
          }
        } catch (w) {
          u = { error: w };
        } finally {
          try {
            h && !h.done && (l = d.return) && l.call(d);
          } finally {
            if (u)
              throw u.error;
          }
        }
      }
    }, t;
  }()
), ho = function(t, i) {
  return Object.prototype.hasOwnProperty.call(t, i) ? t[i] : void 0;
}, _w = (Jr = {}, Jr[Qo] = function(t, i) {
  var r, u;
  try {
    for (var l = xe(i.keys()), o = l.next(); !o.done; o = l.next()) {
      var f = o.value, c = t.get(f);
      if (c == null)
        t.set(f, i.get(f));
      else {
        var v = i.get(f), d = v.score, h = v.terms, m = v.match;
        c.score = c.score + d, c.match = Object.assign(c.match, m), jf(c.terms, h);
      }
    }
  } catch (y) {
    r = { error: y };
  } finally {
    try {
      o && !o.done && (u = l.return) && u.call(l);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return t;
}, Jr[Td] = function(t, i) {
  var r, u, l = /* @__PURE__ */ new Map();
  try {
    for (var o = xe(i.keys()), f = o.next(); !f.done; f = o.next()) {
      var c = f.value, v = t.get(c);
      if (v != null) {
        var d = i.get(c), h = d.score, m = d.terms, y = d.match;
        jf(v.terms, m), l.set(c, {
          score: v.score + h,
          terms: v.terms,
          match: Object.assign(v.match, y)
        });
      }
    }
  } catch (w) {
    r = { error: w };
  } finally {
    try {
      f && !f.done && (u = o.return) && u.call(o);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return l;
}, Jr[xw] = function(t, i) {
  var r, u;
  try {
    for (var l = xe(i.keys()), o = l.next(); !o.done; o = l.next()) {
      var f = o.value;
      t.delete(f);
    }
  } catch (c) {
    r = { error: c };
  } finally {
    try {
      o && !o.done && (u = l.return) && u.call(l);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return t;
}, Jr), Sw = { k: 1.2, b: 0.7, d: 0.5 }, $w = function(t, i, r, u, l, o) {
  var f = o.k, c = o.b, v = o.d, d = Math.log(1 + (r - i + 0.5) / (i + 0.5));
  return d * (v + t * (f + 1) / (t + f * (1 - c + c * u / l)));
}, Aw = function(t) {
  return function(i, r, u) {
    var l = typeof t.fuzzy == "function" ? t.fuzzy(i, r, u) : t.fuzzy || !1, o = typeof t.prefix == "function" ? t.prefix(i, r, u) : t.prefix === !0;
    return { term: i, fuzzy: l, prefix: o };
  };
}, mo = {
  idField: "id",
  extractField: function(t, i) {
    return t[i];
  },
  tokenize: function(t, i) {
    return t.split(Ew);
  },
  processTerm: function(t, i) {
    return t.toLowerCase();
  },
  fields: void 0,
  searchOptions: void 0,
  storeFields: [],
  logger: function(t, i, r) {
    return console != null && console.warn != null && console[t](i);
  },
  autoVacuum: !0
}, Gf = {
  combineWith: Qo,
  prefix: !1,
  fuzzy: !1,
  maxFuzzy: 6,
  boost: {},
  weights: { fuzzy: 0.45, prefix: 0.375 },
  bm25: Sw
}, Tw = {
  combineWith: Td,
  prefix: function(t, i, r) {
    return i === r.length - 1;
  }
}, Co = { batchSize: 1e3, batchWait: 10 }, Eo = { minDirtFactor: 0.1, minDirtCount: 20 }, go = Ge(Ge({}, Co), Eo), Cw = function(t, i) {
  t.includes(i) || t.push(i);
}, jf = function(t, i) {
  var r, u;
  try {
    for (var l = xe(i), o = l.next(); !o.done; o = l.next()) {
      var f = o.value;
      t.includes(f) || t.push(f);
    }
  } catch (c) {
    r = { error: c };
  } finally {
    try {
      o && !o.done && (u = l.return) && u.call(l);
    } finally {
      if (r)
        throw r.error;
    }
  }
}, Kf = function(t, i) {
  var r = t.score, u = i.score;
  return u - r;
}, qf = function() {
  return /* @__PURE__ */ new Map();
}, sa = function(t) {
  var i, r, u = /* @__PURE__ */ new Map();
  try {
    for (var l = xe(Object.keys(t)), o = l.next(); !o.done; o = l.next()) {
      var f = o.value;
      u.set(parseInt(f, 10), t[f]);
    }
  } catch (c) {
    i = { error: c };
  } finally {
    try {
      o && !o.done && (r = l.return) && r.call(l);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return u;
}, Ew = /[\n\r -#%-*,-/:;?@[-\]_{}\u00A0\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u1680\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2000-\u200A\u2010-\u2029\u202F-\u2043\u2045-\u2051\u2053-\u205F\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u3000-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]+/u;
const Ow = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, Iw = /* @__PURE__ */ te("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0c1.172 1.025 1.172 2.687 0 3.712c-.203.179-.43.326-.67.442c-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
}, null, -1), Fw = [
  Iw
];
function Pw(t, i) {
  return W(), re("svg", Ow, Fw);
}
const Lw = { name: "heroicons-question-mark-circle", render: Pw }, Rw = {
  key: 0,
  class: "tune-icon-hint"
}, Dw = /* @__PURE__ */ Q({
  __name: "TuneIconHint",
  props: {
    hint: null
  },
  setup(t) {
    return (i, r) => {
      const u = No("tippy");
      return t.hint ? _a((W(), re("span", Rw, [
        se(j(Lw))
      ])), [
        [u, { content: t.hint }]
      ]) : Oe("", !0);
    };
  }
}), Mw = { class: "tune-label-container flex flex-col" }, Bw = { class: "tune-label flex items-center gap-1" }, kw = {
  key: 0,
  class: "tune-sublabel"
}, Ut = /* @__PURE__ */ Q({
  __name: "TuneLabelInput",
  props: {
    hint: null,
    sublabel: null
  },
  setup(t) {
    return (i, r) => (W(), re("div", Mw, [
      te("div", Bw, [
        dt(i.$slots, "default"),
        se(Dw, { hint: t.hint }, null, 8, ["hint"])
      ]),
      t.sublabel ? (W(), re("div", kw, De(t.sublabel), 1)) : Oe("", !0)
    ]));
  }
}), Vw = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, Nw = /* @__PURE__ */ te("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m19.5 8.25l-7.5 7.5l-7.5-7.5"
}, null, -1), Uw = [
  Nw
];
function zw(t, i) {
  return W(), re("svg", Vw, Uw);
}
const Zn = { name: "heroicons-chevron-down", render: zw }, Ww = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, Hw = /* @__PURE__ */ te("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m4.5 12.75l6 6l9-13.5"
}, null, -1), Gw = [
  Hw
];
function jw(t, i) {
  return W(), re("svg", Ww, Gw);
}
const Oa = { name: "heroicons-check", render: jw }, Kw = { class: "relative" }, qw = { class: "max-h-[180px] overflow-y-auto" }, Yw = { key: 1 }, Zw = {
  key: 0,
  class: /* @__PURE__ */ Ee(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, ZC = /* @__PURE__ */ Q({
  __name: "TuneCombobox",
  props: {
    modelValue: null,
    items: null,
    label: null,
    hint: null,
    disabled: { type: Boolean },
    definition: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t;
    let u = new Cd({
      fields: ["id", "name"],
      storeFields: ["id"],
      searchOptions: {
        boost: { name: 2 },
        fuzzy: 0.6
      }
    });
    u.addAll(r.items);
    const l = z(""), o = k({
      get: () => r.items.find((c) => c.id === r.modelValue) || r.items[0],
      set: (c) => i("update:modelValue", c.id)
    }), f = k(() => {
      var m;
      if (l.value === "")
        return r.items;
      const c = u.search(l.value).map((y) => y.id), v = (m = r.items) == null ? void 0 : m.filter((y) => y.name.toLowerCase().includes(l.value.toLowerCase())).map((y) => y.id), d = [...c, ...v];
      return r.items.filter((y) => d.includes(y.id));
    });
    return (c, v) => (W(), ve(j(Wc), {
      modelValue: j(o),
      "onUpdate:modelValue": v[1] || (v[1] = (d) => qn(o) ? o.value = d : null),
      disabled: t.disabled,
      as: "div",
      class: "w-full"
    }, {
      default: le(() => {
        var d;
        return [
          t.label || (d = t.definition) != null && d.title ? (W(), ve(j(Hc), {
            key: 0,
            class: "block"
          }, {
            default: le(() => {
              var h;
              return [
                se(Ut, {
                  hint: t.hint || ((h = t.definition) == null ? void 0 : h.examples[0])
                }, {
                  default: le(() => [
                    vt(De(t.label || t.definition.title), 1)
                  ]),
                  _: 1
                }, 8, ["hint"])
              ];
            }),
            _: 1
          })) : Oe("", !0),
          te("div", Kw, [
            se(j(va), { class: "w-full" }, {
              default: le(() => [
                se(j(Gc), {
                  class: Ee(["tune-input w-full py-2 !pr-[30px] pl-3 focus:outline-none", { "cursor-not-allowed": t.disabled }]),
                  spellcheck: "false",
                  "display-value": (h) => h.name,
                  disabled: t.disabled,
                  onChange: v[0] || (v[0] = (h) => l.value = h.target.value)
                }, null, 8, ["display-value", "class", "disabled"])
              ]),
              _: 1
            }),
            se(j(va), {
              class: Ee(["absolute inset-y-0 right-1 flex items-center px-2 focus:outline-none", { "cursor-not-allowed": t.disabled }])
            }, {
              default: le(() => [
                se(j(Zn), { class: "text-sm" })
              ]),
              _: 1
            }, 8, ["class"]),
            j(f).length > 0 ? (W(), ve(j(jc), {
              key: 0,
              class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none"
            }, {
              default: le(() => [
                te("div", qw, [
                  (W(!0), re(rt, null, rn(j(f), (h) => (W(), ve(j(Kc), {
                    key: h.id,
                    as: "template",
                    value: h
                  }, {
                    default: le(({ active: m, selected: y, disabled: w }) => [
                      te("li", {
                        class: Ee([
                          { active: m },
                          "tune-listbox-item relative cursor-default select-none truncate py-2 pl-3 pr-[50px]"
                        ])
                      }, [
                        te("span", {
                          class: Ee([
                            y ? "selected" : "font-normal",
                            { disabled: w },
                            "tune-listbox-item block truncate"
                          ])
                        }, [
                          c.$slots.item ? dt(c.$slots, "item", {
                            key: 0,
                            item: h
                          }) : (W(), re("span", Yw, De(h.name), 1))
                        ], 2),
                        y ? (W(), re("span", Zw, [
                          se(j(Oa), { class: "text-sm" })
                        ])) : Oe("", !0)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ])
              ]),
              _: 3
            })) : Oe("", !0)
          ])
        ];
      }),
      _: 3
    }, 8, ["modelValue", "disabled"]));
  }
}), Jw = { class: "tune-tag" }, Ed = /* @__PURE__ */ Q({
  __name: "TuneTag",
  props: {
    label: null
  },
  setup(t) {
    return (i, r) => (W(), re("span", Jw, De(t.label), 1));
  }
}), Xw = { class: "relative" }, Qw = { class: "no-scrollbar flex items-center overflow-x-auto" }, ex = {
  key: 0,
  class: "whitespace-nowrap py-2 pl-2"
}, tx = { class: "max-h-[180px] overflow-y-auto" }, nx = { key: 1 }, rx = {
  key: 0,
  class: /* @__PURE__ */ Ee(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, JC = /* @__PURE__ */ Q({
  __name: "TuneComboboxMultiple",
  props: {
    modelValue: null,
    items: null,
    label: null,
    hint: null,
    disabled: { type: Boolean },
    definition: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t;
    let u = new Cd({
      fields: ["id", "name"],
      storeFields: ["id"],
      searchOptions: {
        boost: { name: 2 },
        fuzzy: 0.4
      }
    });
    u.addAll(r.items);
    const l = z(""), o = k({
      get: () => r.items.filter((c) => r.modelValue.includes(c.id)),
      set: (c) => i(
        "update:modelValue",
        c.map((v) => v.id)
      )
    }), f = k(() => {
      var m;
      if (l.value === "")
        return r.items;
      const c = u.search(l.value).map((y) => y.id), v = (m = r.items) == null ? void 0 : m.filter((y) => y.name.toLowerCase().includes(l.value.toLowerCase())).map((y) => y.id), d = [...c, ...v];
      return r.items.filter((y) => d.includes(y.id));
    });
    return (c, v) => (W(), ve(j(Wc), {
      modelValue: j(o),
      "onUpdate:modelValue": v[2] || (v[2] = (d) => qn(o) ? o.value = d : null),
      multiple: "",
      disabled: t.disabled,
      as: "div",
      class: "w-full"
    }, {
      default: le(() => {
        var d;
        return [
          t.label || (d = t.definition) != null && d.title ? (W(), ve(j(Hc), {
            key: 0,
            class: "block"
          }, {
            default: le(() => {
              var h;
              return [
                se(Ut, {
                  hint: t.hint || ((h = t.definition) == null ? void 0 : h.examples[0])
                }, {
                  default: le(() => [
                    vt(De(t.label || t.definition.title), 1)
                  ]),
                  _: 1
                }, 8, ["hint"])
              ];
            }),
            _: 1
          })) : Oe("", !0),
          te("div", Xw, [
            se(j(va), { class: "tune-listbox-button w-full" }, {
              default: le(() => [
                te("div", Qw, [
                  j(o).length ? (W(), re("div", ex, [
                    (W(!0), re(rt, null, rn(j(o), (h) => (W(), re("span", {
                      key: h.id,
                      class: "mr-1 inline-block"
                    }, [
                      se(Ed, {
                        label: h.name
                      }, null, 8, ["label"])
                    ]))), 128))
                  ])) : Oe("", !0),
                  se(j(Gc), {
                    class: Ee(["mr-1 w-full min-w-[200px] py-2 !pr-[30px] pl-2 focus:outline-none", { "cursor-not-allowed": t.disabled }]),
                    spellcheck: "false",
                    disabled: t.disabled,
                    onBlur: v[0] || (v[0] = (h) => l.value = ""),
                    onChange: v[1] || (v[1] = (h) => l.value = h.target.value)
                  }, null, 8, ["class", "disabled"])
                ])
              ]),
              _: 1
            }),
            se(j(va), {
              class: Ee(["absolute inset-y-0 right-1 flex items-center px-2 focus:outline-none", { "cursor-not-allowed": t.disabled }])
            }, {
              default: le(() => [
                se(j(Zn), { class: "text-sm" })
              ]),
              _: 1
            }, 8, ["class"]),
            j(f).length > 0 ? (W(), ve(j(jc), {
              key: 0,
              class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none"
            }, {
              default: le(() => [
                te("div", tx, [
                  (W(!0), re(rt, null, rn(j(f), (h) => (W(), ve(j(Kc), {
                    key: h.id,
                    as: "template",
                    value: h
                  }, {
                    default: le(({ active: m, selected: y, disabled: w }) => [
                      te("li", {
                        class: Ee([
                          { active: m },
                          "tune-listbox-item relative cursor-default select-none truncate py-2 pl-3 pr-[50px]"
                        ])
                      }, [
                        te("span", {
                          class: Ee([
                            y ? "selected" : "font-normal",
                            { disabled: w },
                            "tune-listbox-item block truncate"
                          ])
                        }, [
                          c.$slots.item ? dt(c.$slots, "item", {
                            key: 0,
                            item: h
                          }) : (W(), re("span", nx, De(h.name), 1))
                        ], 2),
                        y ? (W(), re("span", rx, [
                          se(j(Oa), { class: "text-sm" })
                        ])) : Oe("", !0)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ])
              ]),
              _: 3
            })) : Oe("", !0)
          ])
        ];
      }),
      _: 3
    }, 8, ["modelValue", "disabled"]));
  }
}), ix = {
  class: /* @__PURE__ */ Ee(["tune-error-text mt-[2px]"])
}, eu = /* @__PURE__ */ Q({
  __name: "TuneErrorInput",
  props: {
    error: null
  },
  setup(t) {
    return (i, r) => (W(), re("div", ix, De(t.error), 1));
  }
}), ax = { class: "flex" }, lx = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
}, ox = ["type", "value", "placeholder", "readonly", "disabled", "maxlength"], ux = {
  key: 1,
  class: "tune-input-loading absolute inset-y-0 right-0 top-[1px] mr-1 flex h-[40px] items-center overflow-hidden pl-2 pr-2"
}, sx = {
  key: 2,
  class: "absolute inset-y-0 right-0 flex items-center pr-4"
}, fx = {
  inheritAttrs: !1
}, Ia = /* @__PURE__ */ Q({
  ...fx,
  __name: "TuneInput",
  props: {
    label: { default: "" },
    hint: { default: "" },
    loading: { type: Boolean, default: !1 },
    error: { default: "" },
    block: { type: Boolean, default: !0 },
    type: { default: "text" },
    modelValue: { default: "" },
    autofocus: { type: Boolean, default: !1 },
    placeholder: { default: "" },
    maxLength: { default: void 0 },
    readonly: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    definition: { default: {} }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i }) {
    const r = t, u = z(), l = z(!1);
    function o() {
      l.value = !0;
    }
    return i({
      forceShowError: o
    }), Ie(() => {
      var f;
      r.autofocus && ((f = u == null ? void 0 : u.value) == null || f.focus());
    }), (f, c) => {
      var v, d, h, m, y;
      return W(), re("div", {
        class: Ee({ "w-full": t.block })
      }, [
        t.label || (v = t.definition) != null && v.title ? (W(), ve(Ut, {
          key: 0,
          hint: t.hint || ((d = t.definition) == null ? void 0 : d.description)
        }, {
          default: le(() => [
            vt(De(t.label || t.definition.title), 1)
          ]),
          _: 1
        }, 8, ["hint"])) : Oe("", !0),
        te("div", ax, [
          te("div", {
            class: Ee(["group relative z-10 flex", { "w-full": t.block }])
          }, [
            f.$slots.before ? (W(), re("div", lx, [
              dt(f.$slots, "before")
            ])) : Oe("", !0),
            te("input", tn(f.$attrs, {
              ref_key: "inputRef",
              ref: u,
              type: t.type,
              value: t.modelValue,
              class: [
                "tune-input px-3 py-2",
                { "tune-error-border": t.error && l.value },
                { "cursor-not-allowed": t.disabled },
                { "w-full": t.block }
              ],
              placeholder: t.placeholder || ((m = (h = t.definition) == null ? void 0 : h.examples) == null ? void 0 : m[0]) || "",
              readonly: t.readonly,
              disabled: t.disabled,
              maxlength: t.maxLength || ((y = t.definition) == null ? void 0 : y.maxLength),
              onBlur: c[0] || (c[0] = (w) => t.error ? l.value = !0 : null),
              onFocus: c[1] || (c[1] = (w) => t.error ? null : l.value = !1),
              onInput: c[2] || (c[2] = (w) => f.$emit("update:modelValue", w.target.value))
            }), null, 16, ox),
            t.loading || t.error && l.value ? (W(), re("div", ux, [
              t.loading ? (W(), ve(Lc, { key: 0 })) : Oe("", !0)
            ])) : f.$slots.after ? (W(), re("div", sx, [
              dt(f.$slots, "after")
            ])) : Oe("", !0)
          ], 2)
        ]),
        t.error && l.value ? (W(), ve(eu, {
          key: 1,
          error: t.error
        }, null, 8, ["error"])) : Oe("", !0)
      ], 2);
    };
  }
}), cx = ["placeholder", "disabled", "maxlength"], tu = /* @__PURE__ */ Q({
  __name: "TuneTextarea",
  props: {
    modelValue: null,
    definition: null,
    label: { default: "" },
    hint: { default: "" },
    placeholder: { default: "" },
    error: { default: "" },
    autosize: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    maxLength: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = t, l = k({
      get: () => {
        var m;
        return u.modelValue || ((m = u.definition) == null ? void 0 : m.default) || "";
      },
      set: (m) => r("update:modelValue", m)
    }), o = z(), f = z(!1), c = z("auto"), v = k(() => u.autosize ? `resize: none; height: ${c.value};` : "");
    function d() {
      f.value = !0;
    }
    function h() {
      c.value = "auto", ze(() => {
        if (!o.value)
          return;
        let m = o.value.scrollHeight + 1;
        c.value = `${m}px`;
      });
    }
    return i({
      forceShowError: d
    }), Je(l, (m) => {
      ze(h), m && h();
    }), Ie(() => h()), (m, y) => {
      var w, x, S, _;
      return W(), re("div", null, [
        se(Ut, {
          hint: t.hint || ((w = t.definition) == null ? void 0 : w.description)
        }, {
          default: le(() => {
            var A;
            return [
              vt(De(t.label || ((A = t.definition) == null ? void 0 : A.title)), 1)
            ];
          }),
          _: 1
        }, 8, ["hint"]),
        _a(te("textarea", tn(m.$attrs, {
          ref_key: "textareaRef",
          ref: o,
          "onUpdate:modelValue": y[0] || (y[0] = (A) => qn(l) ? l.value = A : null),
          class: [
            "tune-textarea w-full",
            {
              "tune-error-border": !!t.error && f.value
            },
            { disabled: t.disabled }
          ],
          style: j(v),
          placeholder: t.placeholder || ((S = (x = t.definition) == null ? void 0 : x.examples) == null ? void 0 : S[0]),
          disabled: t.disabled,
          maxlength: t.maxLength || ((_ = t.definition) == null ? void 0 : _.maxLength),
          onBlur: y[1] || (y[1] = (A) => t.error ? f.value = !0 : null),
          onFocus: y[2] || (y[2] = (A) => t.error ? null : f.value = !1)
        }), null, 16, cx), [
          [jy, j(l)]
        ]),
        t.error && f.value ? (W(), ve(eu, {
          key: 0,
          class: "!-mt-1",
          error: t.error
        }, null, 8, ["error"])) : Oe("", !0)
      ]);
    };
  }
});
var mn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function dx() {
  this.__data__ = [], this.size = 0;
}
var vx = dx;
function px(t, i) {
  return t === i || t !== t && i !== i;
}
var Od = px, hx = Od;
function mx(t, i) {
  for (var r = t.length; r--; )
    if (hx(t[r][0], i))
      return r;
  return -1;
}
var Fa = mx, gx = Fa, yx = Array.prototype, bx = yx.splice;
function wx(t) {
  var i = this.__data__, r = gx(i, t);
  if (r < 0)
    return !1;
  var u = i.length - 1;
  return r == u ? i.pop() : bx.call(i, r, 1), --this.size, !0;
}
var xx = wx, _x = Fa;
function Sx(t) {
  var i = this.__data__, r = _x(i, t);
  return r < 0 ? void 0 : i[r][1];
}
var $x = Sx, Ax = Fa;
function Tx(t) {
  return Ax(this.__data__, t) > -1;
}
var Cx = Tx, Ex = Fa;
function Ox(t, i) {
  var r = this.__data__, u = Ex(r, t);
  return u < 0 ? (++this.size, r.push([t, i])) : r[u][1] = i, this;
}
var Ix = Ox, Fx = vx, Px = xx, Lx = $x, Rx = Cx, Dx = Ix;
function wr(t) {
  var i = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++i < r; ) {
    var u = t[i];
    this.set(u[0], u[1]);
  }
}
wr.prototype.clear = Fx;
wr.prototype.delete = Px;
wr.prototype.get = Lx;
wr.prototype.has = Rx;
wr.prototype.set = Dx;
var Pa = wr, Mx = Pa;
function Bx() {
  this.__data__ = new Mx(), this.size = 0;
}
var kx = Bx;
function Vx(t) {
  var i = this.__data__, r = i.delete(t);
  return this.size = i.size, r;
}
var Nx = Vx;
function Ux(t) {
  return this.__data__.get(t);
}
var zx = Ux;
function Wx(t) {
  return this.__data__.has(t);
}
var Hx = Wx, Gx = typeof mn == "object" && mn && mn.Object === Object && mn, Id = Gx, jx = Id, Kx = typeof self == "object" && self && self.Object === Object && self, qx = jx || Kx || Function("return this")(), bn = qx, Yx = bn, Zx = Yx.Symbol, nu = Zx, Yf = nu, Fd = Object.prototype, Jx = Fd.hasOwnProperty, Xx = Fd.toString, Xr = Yf ? Yf.toStringTag : void 0;
function Qx(t) {
  var i = Jx.call(t, Xr), r = t[Xr];
  try {
    t[Xr] = void 0;
    var u = !0;
  } catch {
  }
  var l = Xx.call(t);
  return u && (i ? t[Xr] = r : delete t[Xr]), l;
}
var e_ = Qx, t_ = Object.prototype, n_ = t_.toString;
function r_(t) {
  return n_.call(t);
}
var i_ = r_, Zf = nu, a_ = e_, l_ = i_, o_ = "[object Null]", u_ = "[object Undefined]", Jf = Zf ? Zf.toStringTag : void 0;
function s_(t) {
  return t == null ? t === void 0 ? u_ : o_ : Jf && Jf in Object(t) ? a_(t) : l_(t);
}
var La = s_;
function f_(t) {
  var i = typeof t;
  return t != null && (i == "object" || i == "function");
}
var Pd = f_, c_ = La, d_ = Pd, v_ = "[object AsyncFunction]", p_ = "[object Function]", h_ = "[object GeneratorFunction]", m_ = "[object Proxy]";
function g_(t) {
  if (!d_(t))
    return !1;
  var i = c_(t);
  return i == p_ || i == h_ || i == v_ || i == m_;
}
var Ld = g_, y_ = bn, b_ = y_["__core-js_shared__"], w_ = b_, yo = w_, Xf = function() {
  var t = /[^.]+$/.exec(yo && yo.keys && yo.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function x_(t) {
  return !!Xf && Xf in t;
}
var __ = x_, S_ = Function.prototype, $_ = S_.toString;
function A_(t) {
  if (t != null) {
    try {
      return $_.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Rd = A_, T_ = Ld, C_ = __, E_ = Pd, O_ = Rd, I_ = /[\\^$.*+?()[\]{}|]/g, F_ = /^\[object .+?Constructor\]$/, P_ = Function.prototype, L_ = Object.prototype, R_ = P_.toString, D_ = L_.hasOwnProperty, M_ = RegExp(
  "^" + R_.call(D_).replace(I_, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function B_(t) {
  if (!E_(t) || C_(t))
    return !1;
  var i = T_(t) ? M_ : F_;
  return i.test(O_(t));
}
var k_ = B_;
function V_(t, i) {
  return t == null ? void 0 : t[i];
}
var N_ = V_, U_ = k_, z_ = N_;
function W_(t, i) {
  var r = z_(t, i);
  return U_(r) ? r : void 0;
}
var xr = W_, H_ = xr, G_ = bn, j_ = H_(G_, "Map"), ru = j_, K_ = xr, q_ = K_(Object, "create"), Ra = q_, Qf = Ra;
function Y_() {
  this.__data__ = Qf ? Qf(null) : {}, this.size = 0;
}
var Z_ = Y_;
function J_(t) {
  var i = this.has(t) && delete this.__data__[t];
  return this.size -= i ? 1 : 0, i;
}
var X_ = J_, Q_ = Ra, e2 = "__lodash_hash_undefined__", t2 = Object.prototype, n2 = t2.hasOwnProperty;
function r2(t) {
  var i = this.__data__;
  if (Q_) {
    var r = i[t];
    return r === e2 ? void 0 : r;
  }
  return n2.call(i, t) ? i[t] : void 0;
}
var i2 = r2, a2 = Ra, l2 = Object.prototype, o2 = l2.hasOwnProperty;
function u2(t) {
  var i = this.__data__;
  return a2 ? i[t] !== void 0 : o2.call(i, t);
}
var s2 = u2, f2 = Ra, c2 = "__lodash_hash_undefined__";
function d2(t, i) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = f2 && i === void 0 ? c2 : i, this;
}
var v2 = d2, p2 = Z_, h2 = X_, m2 = i2, g2 = s2, y2 = v2;
function _r(t) {
  var i = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++i < r; ) {
    var u = t[i];
    this.set(u[0], u[1]);
  }
}
_r.prototype.clear = p2;
_r.prototype.delete = h2;
_r.prototype.get = m2;
_r.prototype.has = g2;
_r.prototype.set = y2;
var b2 = _r, ec = b2, w2 = Pa, x2 = ru;
function _2() {
  this.size = 0, this.__data__ = {
    hash: new ec(),
    map: new (x2 || w2)(),
    string: new ec()
  };
}
var S2 = _2;
function $2(t) {
  var i = typeof t;
  return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? t !== "__proto__" : t === null;
}
var A2 = $2, T2 = A2;
function C2(t, i) {
  var r = t.__data__;
  return T2(i) ? r[typeof i == "string" ? "string" : "hash"] : r.map;
}
var Da = C2, E2 = Da;
function O2(t) {
  var i = E2(this, t).delete(t);
  return this.size -= i ? 1 : 0, i;
}
var I2 = O2, F2 = Da;
function P2(t) {
  return F2(this, t).get(t);
}
var L2 = P2, R2 = Da;
function D2(t) {
  return R2(this, t).has(t);
}
var M2 = D2, B2 = Da;
function k2(t, i) {
  var r = B2(this, t), u = r.size;
  return r.set(t, i), this.size += r.size == u ? 0 : 1, this;
}
var V2 = k2, N2 = S2, U2 = I2, z2 = L2, W2 = M2, H2 = V2;
function Sr(t) {
  var i = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++i < r; ) {
    var u = t[i];
    this.set(u[0], u[1]);
  }
}
Sr.prototype.clear = N2;
Sr.prototype.delete = U2;
Sr.prototype.get = z2;
Sr.prototype.has = W2;
Sr.prototype.set = H2;
var Dd = Sr, G2 = Pa, j2 = ru, K2 = Dd, q2 = 200;
function Y2(t, i) {
  var r = this.__data__;
  if (r instanceof G2) {
    var u = r.__data__;
    if (!j2 || u.length < q2 - 1)
      return u.push([t, i]), this.size = ++r.size, this;
    r = this.__data__ = new K2(u);
  }
  return r.set(t, i), this.size = r.size, this;
}
var Z2 = Y2, J2 = Pa, X2 = kx, Q2 = Nx, eS = zx, tS = Hx, nS = Z2;
function $r(t) {
  var i = this.__data__ = new J2(t);
  this.size = i.size;
}
$r.prototype.clear = X2;
$r.prototype.delete = Q2;
$r.prototype.get = eS;
$r.prototype.has = tS;
$r.prototype.set = nS;
var rS = $r, iS = "__lodash_hash_undefined__";
function aS(t) {
  return this.__data__.set(t, iS), this;
}
var lS = aS;
function oS(t) {
  return this.__data__.has(t);
}
var uS = oS, sS = Dd, fS = lS, cS = uS;
function ma(t) {
  var i = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new sS(); ++i < r; )
    this.add(t[i]);
}
ma.prototype.add = ma.prototype.push = fS;
ma.prototype.has = cS;
var dS = ma;
function vS(t, i) {
  for (var r = -1, u = t == null ? 0 : t.length; ++r < u; )
    if (i(t[r], r, t))
      return !0;
  return !1;
}
var pS = vS;
function hS(t, i) {
  return t.has(i);
}
var mS = hS, gS = dS, yS = pS, bS = mS, wS = 1, xS = 2;
function _S(t, i, r, u, l, o) {
  var f = r & wS, c = t.length, v = i.length;
  if (c != v && !(f && v > c))
    return !1;
  var d = o.get(t), h = o.get(i);
  if (d && h)
    return d == i && h == t;
  var m = -1, y = !0, w = r & xS ? new gS() : void 0;
  for (o.set(t, i), o.set(i, t); ++m < c; ) {
    var x = t[m], S = i[m];
    if (u)
      var _ = f ? u(S, x, m, i, t, o) : u(x, S, m, t, i, o);
    if (_ !== void 0) {
      if (_)
        continue;
      y = !1;
      break;
    }
    if (w) {
      if (!yS(i, function(A, T) {
        if (!bS(w, T) && (x === A || l(x, A, r, u, o)))
          return w.push(T);
      })) {
        y = !1;
        break;
      }
    } else if (!(x === S || l(x, S, r, u, o))) {
      y = !1;
      break;
    }
  }
  return o.delete(t), o.delete(i), y;
}
var Md = _S, SS = bn, $S = SS.Uint8Array, AS = $S;
function TS(t) {
  var i = -1, r = Array(t.size);
  return t.forEach(function(u, l) {
    r[++i] = [l, u];
  }), r;
}
var CS = TS;
function ES(t) {
  var i = -1, r = Array(t.size);
  return t.forEach(function(u) {
    r[++i] = u;
  }), r;
}
var OS = ES, tc = nu, nc = AS, IS = Od, FS = Md, PS = CS, LS = OS, RS = 1, DS = 2, MS = "[object Boolean]", BS = "[object Date]", kS = "[object Error]", VS = "[object Map]", NS = "[object Number]", US = "[object RegExp]", zS = "[object Set]", WS = "[object String]", HS = "[object Symbol]", GS = "[object ArrayBuffer]", jS = "[object DataView]", rc = tc ? tc.prototype : void 0, bo = rc ? rc.valueOf : void 0;
function KS(t, i, r, u, l, o, f) {
  switch (r) {
    case jS:
      if (t.byteLength != i.byteLength || t.byteOffset != i.byteOffset)
        return !1;
      t = t.buffer, i = i.buffer;
    case GS:
      return !(t.byteLength != i.byteLength || !o(new nc(t), new nc(i)));
    case MS:
    case BS:
    case NS:
      return IS(+t, +i);
    case kS:
      return t.name == i.name && t.message == i.message;
    case US:
    case WS:
      return t == i + "";
    case VS:
      var c = PS;
    case zS:
      var v = u & RS;
      if (c || (c = LS), t.size != i.size && !v)
        return !1;
      var d = f.get(t);
      if (d)
        return d == i;
      u |= DS, f.set(t, i);
      var h = FS(c(t), c(i), u, l, o, f);
      return f.delete(t), h;
    case HS:
      if (bo)
        return bo.call(t) == bo.call(i);
  }
  return !1;
}
var qS = KS;
function YS(t, i) {
  for (var r = -1, u = i.length, l = t.length; ++r < u; )
    t[l + r] = i[r];
  return t;
}
var ZS = YS, JS = Array.isArray, iu = JS, XS = ZS, QS = iu;
function e$(t, i, r) {
  var u = i(t);
  return QS(t) ? u : XS(u, r(t));
}
var t$ = e$;
function n$(t, i) {
  for (var r = -1, u = t == null ? 0 : t.length, l = 0, o = []; ++r < u; ) {
    var f = t[r];
    i(f, r, t) && (o[l++] = f);
  }
  return o;
}
var r$ = n$;
function i$() {
  return [];
}
var a$ = i$, l$ = r$, o$ = a$, u$ = Object.prototype, s$ = u$.propertyIsEnumerable, ic = Object.getOwnPropertySymbols, f$ = ic ? function(t) {
  return t == null ? [] : (t = Object(t), l$(ic(t), function(i) {
    return s$.call(t, i);
  }));
} : o$, c$ = f$;
function d$(t, i) {
  for (var r = -1, u = Array(t); ++r < t; )
    u[r] = i(r);
  return u;
}
var v$ = d$;
function p$(t) {
  return t != null && typeof t == "object";
}
var Ma = p$, h$ = La, m$ = Ma, g$ = "[object Arguments]";
function y$(t) {
  return m$(t) && h$(t) == g$;
}
var b$ = y$, ac = b$, w$ = Ma, Bd = Object.prototype, x$ = Bd.hasOwnProperty, _$ = Bd.propertyIsEnumerable, S$ = ac(function() {
  return arguments;
}()) ? ac : function(t) {
  return w$(t) && x$.call(t, "callee") && !_$.call(t, "callee");
}, $$ = S$, ni = {}, A$ = {
  get exports() {
    return ni;
  },
  set exports(t) {
    ni = t;
  }
};
function T$() {
  return !1;
}
var C$ = T$;
(function(t, i) {
  var r = bn, u = C$, l = i && !i.nodeType && i, o = l && !0 && t && !t.nodeType && t, f = o && o.exports === l, c = f ? r.Buffer : void 0, v = c ? c.isBuffer : void 0, d = v || u;
  t.exports = d;
})(A$, ni);
var E$ = 9007199254740991, O$ = /^(?:0|[1-9]\d*)$/;
function I$(t, i) {
  var r = typeof t;
  return i = i ?? E$, !!i && (r == "number" || r != "symbol" && O$.test(t)) && t > -1 && t % 1 == 0 && t < i;
}
var F$ = I$, P$ = 9007199254740991;
function L$(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= P$;
}
var kd = L$, R$ = La, D$ = kd, M$ = Ma, B$ = "[object Arguments]", k$ = "[object Array]", V$ = "[object Boolean]", N$ = "[object Date]", U$ = "[object Error]", z$ = "[object Function]", W$ = "[object Map]", H$ = "[object Number]", G$ = "[object Object]", j$ = "[object RegExp]", K$ = "[object Set]", q$ = "[object String]", Y$ = "[object WeakMap]", Z$ = "[object ArrayBuffer]", J$ = "[object DataView]", X$ = "[object Float32Array]", Q$ = "[object Float64Array]", eA = "[object Int8Array]", tA = "[object Int16Array]", nA = "[object Int32Array]", rA = "[object Uint8Array]", iA = "[object Uint8ClampedArray]", aA = "[object Uint16Array]", lA = "[object Uint32Array]", Ue = {};
Ue[X$] = Ue[Q$] = Ue[eA] = Ue[tA] = Ue[nA] = Ue[rA] = Ue[iA] = Ue[aA] = Ue[lA] = !0;
Ue[B$] = Ue[k$] = Ue[Z$] = Ue[V$] = Ue[J$] = Ue[N$] = Ue[U$] = Ue[z$] = Ue[W$] = Ue[H$] = Ue[G$] = Ue[j$] = Ue[K$] = Ue[q$] = Ue[Y$] = !1;
function oA(t) {
  return M$(t) && D$(t.length) && !!Ue[R$(t)];
}
var uA = oA;
function sA(t) {
  return function(i) {
    return t(i);
  };
}
var fA = sA, ga = {}, cA = {
  get exports() {
    return ga;
  },
  set exports(t) {
    ga = t;
  }
};
(function(t, i) {
  var r = Id, u = i && !i.nodeType && i, l = u && !0 && t && !t.nodeType && t, o = l && l.exports === u, f = o && r.process, c = function() {
    try {
      var v = l && l.require && l.require("util").types;
      return v || f && f.binding && f.binding("util");
    } catch {
    }
  }();
  t.exports = c;
})(cA, ga);
var dA = uA, vA = fA, lc = ga, oc = lc && lc.isTypedArray, pA = oc ? vA(oc) : dA, Vd = pA, hA = v$, mA = $$, gA = iu, yA = ni, bA = F$, wA = Vd, xA = Object.prototype, _A = xA.hasOwnProperty;
function SA(t, i) {
  var r = gA(t), u = !r && mA(t), l = !r && !u && yA(t), o = !r && !u && !l && wA(t), f = r || u || l || o, c = f ? hA(t.length, String) : [], v = c.length;
  for (var d in t)
    (i || _A.call(t, d)) && !(f && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    l && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    bA(d, v))) && c.push(d);
  return c;
}
var $A = SA, AA = Object.prototype;
function TA(t) {
  var i = t && t.constructor, r = typeof i == "function" && i.prototype || AA;
  return t === r;
}
var CA = TA;
function EA(t, i) {
  return function(r) {
    return t(i(r));
  };
}
var OA = EA, IA = OA, FA = IA(Object.keys, Object), PA = FA, LA = CA, RA = PA, DA = Object.prototype, MA = DA.hasOwnProperty;
function BA(t) {
  if (!LA(t))
    return RA(t);
  var i = [];
  for (var r in Object(t))
    MA.call(t, r) && r != "constructor" && i.push(r);
  return i;
}
var kA = BA, VA = Ld, NA = kd;
function UA(t) {
  return t != null && NA(t.length) && !VA(t);
}
var zA = UA, WA = $A, HA = kA, GA = zA;
function jA(t) {
  return GA(t) ? WA(t) : HA(t);
}
var KA = jA, qA = t$, YA = c$, ZA = KA;
function JA(t) {
  return qA(t, ZA, YA);
}
var XA = JA, uc = XA, QA = 1, e3 = Object.prototype, t3 = e3.hasOwnProperty;
function n3(t, i, r, u, l, o) {
  var f = r & QA, c = uc(t), v = c.length, d = uc(i), h = d.length;
  if (v != h && !f)
    return !1;
  for (var m = v; m--; ) {
    var y = c[m];
    if (!(f ? y in i : t3.call(i, y)))
      return !1;
  }
  var w = o.get(t), x = o.get(i);
  if (w && x)
    return w == i && x == t;
  var S = !0;
  o.set(t, i), o.set(i, t);
  for (var _ = f; ++m < v; ) {
    y = c[m];
    var A = t[y], T = i[y];
    if (u)
      var E = f ? u(T, A, y, i, t, o) : u(A, T, y, t, i, o);
    if (!(E === void 0 ? A === T || l(A, T, r, u, o) : E)) {
      S = !1;
      break;
    }
    _ || (_ = y == "constructor");
  }
  if (S && !_) {
    var F = t.constructor, P = i.constructor;
    F != P && "constructor" in t && "constructor" in i && !(typeof F == "function" && F instanceof F && typeof P == "function" && P instanceof P) && (S = !1);
  }
  return o.delete(t), o.delete(i), S;
}
var r3 = n3, i3 = xr, a3 = bn, l3 = i3(a3, "DataView"), o3 = l3, u3 = xr, s3 = bn, f3 = u3(s3, "Promise"), c3 = f3, d3 = xr, v3 = bn, p3 = d3(v3, "Set"), h3 = p3, m3 = xr, g3 = bn, y3 = m3(g3, "WeakMap"), b3 = y3, Oo = o3, Io = ru, Fo = c3, Po = h3, Lo = b3, Nd = La, Ar = Rd, sc = "[object Map]", w3 = "[object Object]", fc = "[object Promise]", cc = "[object Set]", dc = "[object WeakMap]", vc = "[object DataView]", x3 = Ar(Oo), _3 = Ar(Io), S3 = Ar(Fo), $3 = Ar(Po), A3 = Ar(Lo), Gn = Nd;
(Oo && Gn(new Oo(new ArrayBuffer(1))) != vc || Io && Gn(new Io()) != sc || Fo && Gn(Fo.resolve()) != fc || Po && Gn(new Po()) != cc || Lo && Gn(new Lo()) != dc) && (Gn = function(t) {
  var i = Nd(t), r = i == w3 ? t.constructor : void 0, u = r ? Ar(r) : "";
  if (u)
    switch (u) {
      case x3:
        return vc;
      case _3:
        return sc;
      case S3:
        return fc;
      case $3:
        return cc;
      case A3:
        return dc;
    }
  return i;
});
var T3 = Gn, wo = rS, C3 = Md, E3 = qS, O3 = r3, pc = T3, hc = iu, mc = ni, I3 = Vd, F3 = 1, gc = "[object Arguments]", yc = "[object Array]", fa = "[object Object]", P3 = Object.prototype, bc = P3.hasOwnProperty;
function L3(t, i, r, u, l, o) {
  var f = hc(t), c = hc(i), v = f ? yc : pc(t), d = c ? yc : pc(i);
  v = v == gc ? fa : v, d = d == gc ? fa : d;
  var h = v == fa, m = d == fa, y = v == d;
  if (y && mc(t)) {
    if (!mc(i))
      return !1;
    f = !0, h = !1;
  }
  if (y && !h)
    return o || (o = new wo()), f || I3(t) ? C3(t, i, r, u, l, o) : E3(t, i, v, r, u, l, o);
  if (!(r & F3)) {
    var w = h && bc.call(t, "__wrapped__"), x = m && bc.call(i, "__wrapped__");
    if (w || x) {
      var S = w ? t.value() : t, _ = x ? i.value() : i;
      return o || (o = new wo()), l(S, _, r, u, o);
    }
  }
  return y ? (o || (o = new wo()), O3(t, i, r, u, l, o)) : !1;
}
var R3 = L3, D3 = R3, wc = Ma;
function Ud(t, i, r, u, l) {
  return t === i ? !0 : t == null || i == null || !wc(t) && !wc(i) ? t !== t && i !== i : D3(t, i, r, u, Ud, l);
}
var M3 = Ud, B3 = M3;
function k3(t, i) {
  return B3(t, i);
}
var V3 = k3;
const N3 = { class: "relative" }, U3 = { key: 1 }, z3 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-[12px]" }, W3 = { class: "max-h-[180px] overflow-y-auto" }, H3 = { key: 1 }, G3 = {
  key: 0,
  class: /* @__PURE__ */ Ee(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, j3 = /* @__PURE__ */ Q({
  __name: "TuneListbox",
  props: {
    items: null,
    modelValue: null,
    label: null,
    disabled: { type: Boolean },
    definition: null,
    hint: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t, u = k({
      get: () => r.items.find((l) => V3(l.value, r.modelValue)) || r.items[0],
      set: (l) => i("update:modelValue", l.value)
    });
    return (l, o) => (W(), ve(j(id), {
      modelValue: j(u),
      "onUpdate:modelValue": o[0] || (o[0] = (f) => qn(u) ? u.value = f : null),
      as: "div",
      disabled: t.disabled
    }, {
      default: le(() => [
        se(j(ad), null, {
          default: le(() => {
            var f;
            return [
              se(Ut, {
                hint: t.hint || ((f = t.definition) == null ? void 0 : f.description)
              }, {
                default: le(() => {
                  var c;
                  return [
                    vt(De(t.label || ((c = t.definition) == null ? void 0 : c.title)), 1)
                  ];
                }),
                _: 1
              }, 8, ["hint"])
            ];
          }),
          _: 1
        }),
        te("div", N3, [
          se(j(ld), {
            class: Ee(["tune-listbox-button relative h-[42px] w-full truncate pl-3 pr-[40px] text-left", { "disabled cursor-not-allowed": t.disabled }])
          }, {
            default: le(() => {
              var f;
              return [
                l.$slots.selected ? dt(l.$slots, "selected", {
                  key: 0,
                  selectedItem: j(u)
                }) : j(u) ? (W(), re("span", U3, De(((f = j(u)) == null ? void 0 : f.name) || j(u).value), 1)) : Oe("", !0),
                te("span", z3, [
                  se(j(Zn), { class: "text-sm" })
                ])
              ];
            }),
            _: 3
          }, 8, ["class"]),
          se(Uo, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform -translate-y-2 scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-out",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: le(() => [
              se(j(od), { class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none" }, {
                default: le(() => [
                  te("div", W3, [
                    (W(!0), re(rt, null, rn(t.items, (f) => (W(), ve(j(ud), {
                      key: f.value,
                      as: "template",
                      value: f
                    }, {
                      default: le(({ active: c, selected: v, disabled: d }) => [
                        te("li", {
                          class: Ee([
                            { active: c && !d },
                            "tune-listbox-item relative cursor-default select-none py-2 pl-3 pr-[50px]"
                          ])
                        }, [
                          te("span", {
                            class: Ee([
                              v ? "selected" : "font-normal",
                              { disabled: d },
                              "tune-listbox-item block truncate"
                            ])
                          }, [
                            l.$slots.item ? dt(l.$slots, "item", {
                              key: 0,
                              item: f
                            }) : (W(), re("span", H3, De((f == null ? void 0 : f.name) || f.value), 1))
                          ], 2),
                          v ? (W(), re("span", G3, [
                            se(j(Oa), { class: "text-sm" })
                          ])) : Oe("", !0)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ])
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "disabled"]));
  }
}), zd = /* @__PURE__ */ Q({
  __name: "FormString",
  props: {
    modelValue: null,
    definition: null,
    error: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = t, l = z();
    function o() {
      var c;
      (c = l == null ? void 0 : l.value) == null || c.forceShowError();
    }
    i({
      forceShowError: o
    });
    const f = k(() => {
      var c, v;
      return (c = u.definition) != null && c.enum ? u.definition.enum.map((d) => ({
        value: d
      })) : (v = u.definition) != null && v.anyOf ? u.definition.anyOf.map((d) => ({
        value: d.const,
        name: d.title
      })) : [];
    });
    return (c, v) => {
      var d, h, m;
      return (d = t.definition) != null && d.enum || (h = t.definition) != null && h.anyOf ? (W(), ve(j3, {
        key: 0,
        items: j(f),
        "model-value": t.modelValue,
        definition: t.definition,
        "onUpdate:modelValue": v[0] || (v[0] = (y) => r("update:modelValue", y))
      }, null, 8, ["items", "model-value", "definition"])) : ((m = t.definition) == null ? void 0 : m.format) === "long" ? (W(), ve(tu, tn({
        key: 1,
        ref_key: "textInputRef",
        ref: l
      }, u, {
        "onUpdate:modelValue": v[1] || (v[1] = (y) => r("update:modelValue", y))
      }), null, 16)) : (W(), ve(Ia, tn({
        key: 2,
        ref_key: "textInputRef",
        ref: l
      }, u, {
        "onUpdate:modelValue": v[2] || (v[2] = (y) => r("update:modelValue", y))
      }), null, 16));
    };
  }
}), Wd = /* @__PURE__ */ Q({
  __name: "FormNumber",
  props: {
    modelValue: null,
    definition: null,
    error: { default: "" },
    type: { default: "number" }
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = t, l = z();
    function o() {
      var f;
      (f = l == null ? void 0 : l.value) == null || f.forceShowError();
    }
    return i({
      forceShowError: o
    }), (f, c) => (W(), ve(Ia, tn({
      ref_key: "numberInputRef",
      ref: l
    }, u, {
      "onUpdate:modelValue": c[0] || (c[0] = (v) => r("update:modelValue", Number(v)))
    }), null, 16));
  }
}), K3 = {
  key: 0,
  class: "sr-only"
}, q3 = /* @__PURE__ */ te("svg", {
  class: "h-[10px] w-[10px]",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /* @__PURE__ */ te("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), Y3 = [
  q3
], Z3 = /* @__PURE__ */ te("svg", {
  class: "h-[10px] w-[10px]",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /* @__PURE__ */ te("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1), J3 = [
  Z3
], X3 = /* @__PURE__ */ Q({
  __name: "TuneSwitch",
  props: {
    modelValue: { type: Boolean },
    label: null,
    sublabel: null,
    hint: null,
    definition: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    return (r, u) => {
      var l, o, f, c;
      return W(), re("div", {
        class: Ee(["flex space-x-2 pr-2 pt-1", t.sublabel || (l = t.definition) != null && l.sublabel ? "items-start" : "items-center"])
      }, [
        se(j(uw), {
          "model-value": t.modelValue,
          class: Ee([
            "tune-switch relative inline-flex h-[22px] w-[38px] flex-shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-in-out",
            t.modelValue ? "switched-on-bg" : "switched-off-bg",
            { "!cursor-not-allowed ": t.disabled }
          ]),
          disabled: t.disabled,
          "onUpdate:modelValue": u[0] || (u[0] = (v) => i("update:modelValue", v))
        }, {
          default: le(() => {
            var v, d;
            return [
              t.label || (v = t.definition) != null && v.title ? (W(), re("span", K3, De(t.label || ((d = t.definition) == null ? void 0 : d.title)), 1)) : Oe("", !0),
              te("span", {
                class: Ee([
                  t.modelValue ? "translate-x-[16px]" : "translate-x-0",
                  "shadow tune-switch-button pointer-events-none inline-block h-[18px] w-[18px] transform rounded-full transition duration-200 ease-in-out"
                ])
              }, [
                te("span", {
                  class: Ee([
                    t.modelValue ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in",
                    "tune-switch switched-off-text absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                  ]),
                  "aria-hidden": "true"
                }, Y3, 2),
                te("span", {
                  class: Ee([
                    t.modelValue ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out",
                    "tune-switch switched-on-text absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                  ]),
                  "aria-hidden": "true"
                }, J3, 2)
              ], 2)
            ];
          }),
          _: 1
        }, 8, ["model-value", "class", "disabled"]),
        t.label || (o = t.definition) != null && o.title ? (W(), ve(Ut, {
          key: 0,
          hint: t.hint || ((f = t.definition) == null ? void 0 : f.description),
          sublabel: t.sublabel || ((c = t.definition) == null ? void 0 : c.sublabel)
        }, {
          default: le(() => {
            var v;
            return [
              vt(De(t.label || ((v = t.definition) == null ? void 0 : v.title)), 1)
            ];
          }),
          _: 1
        }, 8, ["hint", "sublabel"])) : Oe("", !0)
      ], 2);
    };
  }
}), Hd = /* @__PURE__ */ Q({
  __name: "FormBoolean",
  props: {
    modelValue: { type: Boolean },
    definition: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t;
    return Ie(() => {
      var u;
      i("update:modelValue", r.modelValue || ((u = r.definition) == null ? void 0 : u.default) || !1);
    }), (u, l) => (W(), ve(X3, tn(r, {
      "onUpdate:modelValue": l[0] || (l[0] = (o) => i("update:modelValue", o))
    }), null, 16));
  }
});
var mr = {}, Q3 = {
  get exports() {
    return mr;
  },
  set exports(t) {
    mr = t;
  }
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(t, i) {
  (function() {
    var r, u = "4.17.21", l = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", f = "Expected a function", c = "Invalid `variable` option passed into `_.template`", v = "__lodash_hash_undefined__", d = 500, h = "__lodash_placeholder__", m = 1, y = 2, w = 4, x = 1, S = 2, _ = 1, A = 2, T = 4, E = 8, F = 16, P = 32, R = 64, V = 128, M = 256, H = 512, K = 30, Y = "...", ee = 800, ne = 16, J = 1, oe = 2, de = 3, ye = 1 / 0, We = 9007199254740991, qe = 17976931348623157e292, wn = 0 / 0, bt = 4294967295, Jn = bt - 1, Tr = bt >>> 1, Va = [
      ["ary", V],
      ["bind", _],
      ["bindKey", A],
      ["curry", E],
      ["curryRight", F],
      ["flip", H],
      ["partial", P],
      ["partialRight", R],
      ["rearg", M]
    ], Xn = "[object Arguments]", hi = "[object Array]", av = "[object AsyncFunction]", Cr = "[object Boolean]", Er = "[object Date]", lv = "[object DOMException]", mi = "[object Error]", gi = "[object Function]", ou = "[object GeneratorFunction]", zt = "[object Map]", Or = "[object Number]", ov = "[object Null]", ln = "[object Object]", uu = "[object Promise]", uv = "[object Proxy]", Ir = "[object RegExp]", Wt = "[object Set]", Fr = "[object String]", yi = "[object Symbol]", sv = "[object Undefined]", Pr = "[object WeakMap]", fv = "[object WeakSet]", Lr = "[object ArrayBuffer]", Qn = "[object DataView]", Na = "[object Float32Array]", Ua = "[object Float64Array]", za = "[object Int8Array]", Wa = "[object Int16Array]", Ha = "[object Int32Array]", Ga = "[object Uint8Array]", ja = "[object Uint8ClampedArray]", Ka = "[object Uint16Array]", qa = "[object Uint32Array]", cv = /\b__p \+= '';/g, dv = /\b(__p \+=) '' \+/g, vv = /(__e\(.*?\)|\b__t\)) \+\n'';/g, su = /&(?:amp|lt|gt|quot|#39);/g, fu = /[&<>"']/g, pv = RegExp(su.source), hv = RegExp(fu.source), mv = /<%-([\s\S]+?)%>/g, gv = /<%([\s\S]+?)%>/g, cu = /<%=([\s\S]+?)%>/g, yv = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, bv = /^\w*$/, wv = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ya = /[\\^$.*+?()[\]{}|]/g, xv = RegExp(Ya.source), Za = /^\s+/, _v = /\s/, Sv = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, $v = /\{\n\/\* \[wrapped with (.+)\] \*/, Av = /,? & /, Tv = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Cv = /[()=,{}\[\]\/\s]/, Ev = /\\(\\)?/g, Ov = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, du = /\w*$/, Iv = /^[-+]0x[0-9a-f]+$/i, Fv = /^0b[01]+$/i, Pv = /^\[object .+?Constructor\]$/, Lv = /^0o[0-7]+$/i, Rv = /^(?:0|[1-9]\d*)$/, Dv = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, bi = /($^)/, Mv = /['\n\r\u2028\u2029\\]/g, wi = "\\ud800-\\udfff", Bv = "\\u0300-\\u036f", kv = "\\ufe20-\\ufe2f", Vv = "\\u20d0-\\u20ff", vu = Bv + kv + Vv, pu = "\\u2700-\\u27bf", hu = "a-z\\xdf-\\xf6\\xf8-\\xff", Nv = "\\xac\\xb1\\xd7\\xf7", Uv = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", zv = "\\u2000-\\u206f", Wv = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", mu = "A-Z\\xc0-\\xd6\\xd8-\\xde", gu = "\\ufe0e\\ufe0f", yu = Nv + Uv + zv + Wv, Ja = "['’]", Hv = "[" + wi + "]", bu = "[" + yu + "]", xi = "[" + vu + "]", wu = "\\d+", Gv = "[" + pu + "]", xu = "[" + hu + "]", _u = "[^" + wi + yu + wu + pu + hu + mu + "]", Xa = "\\ud83c[\\udffb-\\udfff]", jv = "(?:" + xi + "|" + Xa + ")", Su = "[^" + wi + "]", Qa = "(?:\\ud83c[\\udde6-\\uddff]){2}", el = "[\\ud800-\\udbff][\\udc00-\\udfff]", er = "[" + mu + "]", $u = "\\u200d", Au = "(?:" + xu + "|" + _u + ")", Kv = "(?:" + er + "|" + _u + ")", Tu = "(?:" + Ja + "(?:d|ll|m|re|s|t|ve))?", Cu = "(?:" + Ja + "(?:D|LL|M|RE|S|T|VE))?", Eu = jv + "?", Ou = "[" + gu + "]?", qv = "(?:" + $u + "(?:" + [Su, Qa, el].join("|") + ")" + Ou + Eu + ")*", Yv = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Zv = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Iu = Ou + Eu + qv, Jv = "(?:" + [Gv, Qa, el].join("|") + ")" + Iu, Xv = "(?:" + [Su + xi + "?", xi, Qa, el, Hv].join("|") + ")", Qv = RegExp(Ja, "g"), ep = RegExp(xi, "g"), tl = RegExp(Xa + "(?=" + Xa + ")|" + Xv + Iu, "g"), tp = RegExp([
      er + "?" + xu + "+" + Tu + "(?=" + [bu, er, "$"].join("|") + ")",
      Kv + "+" + Cu + "(?=" + [bu, er + Au, "$"].join("|") + ")",
      er + "?" + Au + "+" + Tu,
      er + "+" + Cu,
      Zv,
      Yv,
      wu,
      Jv
    ].join("|"), "g"), np = RegExp("[" + $u + wi + vu + gu + "]"), rp = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ip = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], ap = -1, Ne = {};
    Ne[Na] = Ne[Ua] = Ne[za] = Ne[Wa] = Ne[Ha] = Ne[Ga] = Ne[ja] = Ne[Ka] = Ne[qa] = !0, Ne[Xn] = Ne[hi] = Ne[Lr] = Ne[Cr] = Ne[Qn] = Ne[Er] = Ne[mi] = Ne[gi] = Ne[zt] = Ne[Or] = Ne[ln] = Ne[Ir] = Ne[Wt] = Ne[Fr] = Ne[Pr] = !1;
    var Ve = {};
    Ve[Xn] = Ve[hi] = Ve[Lr] = Ve[Qn] = Ve[Cr] = Ve[Er] = Ve[Na] = Ve[Ua] = Ve[za] = Ve[Wa] = Ve[Ha] = Ve[zt] = Ve[Or] = Ve[ln] = Ve[Ir] = Ve[Wt] = Ve[Fr] = Ve[yi] = Ve[Ga] = Ve[ja] = Ve[Ka] = Ve[qa] = !0, Ve[mi] = Ve[gi] = Ve[Pr] = !1;
    var lp = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, op = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, up = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, sp = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, fp = parseFloat, cp = parseInt, Fu = typeof mn == "object" && mn && mn.Object === Object && mn, dp = typeof self == "object" && self && self.Object === Object && self, ot = Fu || dp || Function("return this")(), nl = i && !i.nodeType && i, Dn = nl && !0 && t && !t.nodeType && t, Pu = Dn && Dn.exports === nl, rl = Pu && Fu.process, Pt = function() {
      try {
        var O = Dn && Dn.require && Dn.require("util").types;
        return O || rl && rl.binding && rl.binding("util");
      } catch {
      }
    }(), Lu = Pt && Pt.isArrayBuffer, Ru = Pt && Pt.isDate, Du = Pt && Pt.isMap, Mu = Pt && Pt.isRegExp, Bu = Pt && Pt.isSet, ku = Pt && Pt.isTypedArray;
    function $t(O, D, L) {
      switch (L.length) {
        case 0:
          return O.call(D);
        case 1:
          return O.call(D, L[0]);
        case 2:
          return O.call(D, L[0], L[1]);
        case 3:
          return O.call(D, L[0], L[1], L[2]);
      }
      return O.apply(D, L);
    }
    function vp(O, D, L, X) {
      for (var pe = -1, Pe = O == null ? 0 : O.length; ++pe < Pe; ) {
        var tt = O[pe];
        D(X, tt, L(tt), O);
      }
      return X;
    }
    function Lt(O, D) {
      for (var L = -1, X = O == null ? 0 : O.length; ++L < X && D(O[L], L, O) !== !1; )
        ;
      return O;
    }
    function pp(O, D) {
      for (var L = O == null ? 0 : O.length; L-- && D(O[L], L, O) !== !1; )
        ;
      return O;
    }
    function Vu(O, D) {
      for (var L = -1, X = O == null ? 0 : O.length; ++L < X; )
        if (!D(O[L], L, O))
          return !1;
      return !0;
    }
    function xn(O, D) {
      for (var L = -1, X = O == null ? 0 : O.length, pe = 0, Pe = []; ++L < X; ) {
        var tt = O[L];
        D(tt, L, O) && (Pe[pe++] = tt);
      }
      return Pe;
    }
    function _i(O, D) {
      var L = O == null ? 0 : O.length;
      return !!L && tr(O, D, 0) > -1;
    }
    function il(O, D, L) {
      for (var X = -1, pe = O == null ? 0 : O.length; ++X < pe; )
        if (L(D, O[X]))
          return !0;
      return !1;
    }
    function He(O, D) {
      for (var L = -1, X = O == null ? 0 : O.length, pe = Array(X); ++L < X; )
        pe[L] = D(O[L], L, O);
      return pe;
    }
    function _n(O, D) {
      for (var L = -1, X = D.length, pe = O.length; ++L < X; )
        O[pe + L] = D[L];
      return O;
    }
    function al(O, D, L, X) {
      var pe = -1, Pe = O == null ? 0 : O.length;
      for (X && Pe && (L = O[++pe]); ++pe < Pe; )
        L = D(L, O[pe], pe, O);
      return L;
    }
    function hp(O, D, L, X) {
      var pe = O == null ? 0 : O.length;
      for (X && pe && (L = O[--pe]); pe--; )
        L = D(L, O[pe], pe, O);
      return L;
    }
    function ll(O, D) {
      for (var L = -1, X = O == null ? 0 : O.length; ++L < X; )
        if (D(O[L], L, O))
          return !0;
      return !1;
    }
    var mp = ol("length");
    function gp(O) {
      return O.split("");
    }
    function yp(O) {
      return O.match(Tv) || [];
    }
    function Nu(O, D, L) {
      var X;
      return L(O, function(pe, Pe, tt) {
        if (D(pe, Pe, tt))
          return X = Pe, !1;
      }), X;
    }
    function Si(O, D, L, X) {
      for (var pe = O.length, Pe = L + (X ? 1 : -1); X ? Pe-- : ++Pe < pe; )
        if (D(O[Pe], Pe, O))
          return Pe;
      return -1;
    }
    function tr(O, D, L) {
      return D === D ? Ip(O, D, L) : Si(O, Uu, L);
    }
    function bp(O, D, L, X) {
      for (var pe = L - 1, Pe = O.length; ++pe < Pe; )
        if (X(O[pe], D))
          return pe;
      return -1;
    }
    function Uu(O) {
      return O !== O;
    }
    function zu(O, D) {
      var L = O == null ? 0 : O.length;
      return L ? sl(O, D) / L : wn;
    }
    function ol(O) {
      return function(D) {
        return D == null ? r : D[O];
      };
    }
    function ul(O) {
      return function(D) {
        return O == null ? r : O[D];
      };
    }
    function Wu(O, D, L, X, pe) {
      return pe(O, function(Pe, tt, Be) {
        L = X ? (X = !1, Pe) : D(L, Pe, tt, Be);
      }), L;
    }
    function wp(O, D) {
      var L = O.length;
      for (O.sort(D); L--; )
        O[L] = O[L].value;
      return O;
    }
    function sl(O, D) {
      for (var L, X = -1, pe = O.length; ++X < pe; ) {
        var Pe = D(O[X]);
        Pe !== r && (L = L === r ? Pe : L + Pe);
      }
      return L;
    }
    function fl(O, D) {
      for (var L = -1, X = Array(O); ++L < O; )
        X[L] = D(L);
      return X;
    }
    function xp(O, D) {
      return He(D, function(L) {
        return [L, O[L]];
      });
    }
    function Hu(O) {
      return O && O.slice(0, qu(O) + 1).replace(Za, "");
    }
    function At(O) {
      return function(D) {
        return O(D);
      };
    }
    function cl(O, D) {
      return He(D, function(L) {
        return O[L];
      });
    }
    function Rr(O, D) {
      return O.has(D);
    }
    function Gu(O, D) {
      for (var L = -1, X = O.length; ++L < X && tr(D, O[L], 0) > -1; )
        ;
      return L;
    }
    function ju(O, D) {
      for (var L = O.length; L-- && tr(D, O[L], 0) > -1; )
        ;
      return L;
    }
    function _p(O, D) {
      for (var L = O.length, X = 0; L--; )
        O[L] === D && ++X;
      return X;
    }
    var Sp = ul(lp), $p = ul(op);
    function Ap(O) {
      return "\\" + sp[O];
    }
    function Tp(O, D) {
      return O == null ? r : O[D];
    }
    function nr(O) {
      return np.test(O);
    }
    function Cp(O) {
      return rp.test(O);
    }
    function Ep(O) {
      for (var D, L = []; !(D = O.next()).done; )
        L.push(D.value);
      return L;
    }
    function dl(O) {
      var D = -1, L = Array(O.size);
      return O.forEach(function(X, pe) {
        L[++D] = [pe, X];
      }), L;
    }
    function Ku(O, D) {
      return function(L) {
        return O(D(L));
      };
    }
    function Sn(O, D) {
      for (var L = -1, X = O.length, pe = 0, Pe = []; ++L < X; ) {
        var tt = O[L];
        (tt === D || tt === h) && (O[L] = h, Pe[pe++] = L);
      }
      return Pe;
    }
    function $i(O) {
      var D = -1, L = Array(O.size);
      return O.forEach(function(X) {
        L[++D] = X;
      }), L;
    }
    function Op(O) {
      var D = -1, L = Array(O.size);
      return O.forEach(function(X) {
        L[++D] = [X, X];
      }), L;
    }
    function Ip(O, D, L) {
      for (var X = L - 1, pe = O.length; ++X < pe; )
        if (O[X] === D)
          return X;
      return -1;
    }
    function Fp(O, D, L) {
      for (var X = L + 1; X--; )
        if (O[X] === D)
          return X;
      return X;
    }
    function rr(O) {
      return nr(O) ? Lp(O) : mp(O);
    }
    function Ht(O) {
      return nr(O) ? Rp(O) : gp(O);
    }
    function qu(O) {
      for (var D = O.length; D-- && _v.test(O.charAt(D)); )
        ;
      return D;
    }
    var Pp = ul(up);
    function Lp(O) {
      for (var D = tl.lastIndex = 0; tl.test(O); )
        ++D;
      return D;
    }
    function Rp(O) {
      return O.match(tl) || [];
    }
    function Dp(O) {
      return O.match(tp) || [];
    }
    var Mp = function O(D) {
      D = D == null ? ot : ir.defaults(ot.Object(), D, ir.pick(ot, ip));
      var L = D.Array, X = D.Date, pe = D.Error, Pe = D.Function, tt = D.Math, Be = D.Object, vl = D.RegExp, Bp = D.String, Rt = D.TypeError, Ai = L.prototype, kp = Pe.prototype, ar = Be.prototype, Ti = D["__core-js_shared__"], Ci = kp.toString, Me = ar.hasOwnProperty, Vp = 0, Yu = function() {
        var e = /[^.]+$/.exec(Ti && Ti.keys && Ti.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), Ei = ar.toString, Np = Ci.call(Be), Up = ot._, zp = vl(
        "^" + Ci.call(Me).replace(Ya, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Oi = Pu ? D.Buffer : r, $n = D.Symbol, Ii = D.Uint8Array, Zu = Oi ? Oi.allocUnsafe : r, Fi = Ku(Be.getPrototypeOf, Be), Ju = Be.create, Xu = ar.propertyIsEnumerable, Pi = Ai.splice, Qu = $n ? $n.isConcatSpreadable : r, Dr = $n ? $n.iterator : r, Mn = $n ? $n.toStringTag : r, Li = function() {
        try {
          var e = Un(Be, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), Wp = D.clearTimeout !== ot.clearTimeout && D.clearTimeout, Hp = X && X.now !== ot.Date.now && X.now, Gp = D.setTimeout !== ot.setTimeout && D.setTimeout, Ri = tt.ceil, Di = tt.floor, pl = Be.getOwnPropertySymbols, jp = Oi ? Oi.isBuffer : r, es = D.isFinite, Kp = Ai.join, qp = Ku(Be.keys, Be), nt = tt.max, ft = tt.min, Yp = X.now, Zp = D.parseInt, ts = tt.random, Jp = Ai.reverse, hl = Un(D, "DataView"), Mr = Un(D, "Map"), ml = Un(D, "Promise"), lr = Un(D, "Set"), Br = Un(D, "WeakMap"), kr = Un(Be, "create"), Mi = Br && new Br(), or = {}, Xp = zn(hl), Qp = zn(Mr), eh = zn(ml), th = zn(lr), nh = zn(Br), Bi = $n ? $n.prototype : r, Vr = Bi ? Bi.valueOf : r, ns = Bi ? Bi.toString : r;
      function g(e) {
        if (Ke(e) && !he(e) && !(e instanceof Se)) {
          if (e instanceof Dt)
            return e;
          if (Me.call(e, "__wrapped__"))
            return rf(e);
        }
        return new Dt(e);
      }
      var ur = function() {
        function e() {
        }
        return function(n) {
          if (!je(n))
            return {};
          if (Ju)
            return Ju(n);
          e.prototype = n;
          var a = new e();
          return e.prototype = r, a;
        };
      }();
      function ki() {
      }
      function Dt(e, n) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = r;
      }
      g.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: mv,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: gv,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: cu,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: g
        }
      }, g.prototype = ki.prototype, g.prototype.constructor = g, Dt.prototype = ur(ki.prototype), Dt.prototype.constructor = Dt;
      function Se(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = bt, this.__views__ = [];
      }
      function rh() {
        var e = new Se(this.__wrapped__);
        return e.__actions__ = wt(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = wt(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = wt(this.__views__), e;
      }
      function ih() {
        if (this.__filtered__) {
          var e = new Se(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function ah() {
        var e = this.__wrapped__.value(), n = this.__dir__, a = he(e), s = n < 0, p = a ? e.length : 0, b = g0(0, p, this.__views__), $ = b.start, C = b.end, I = C - $, B = s ? C : $ - 1, N = this.__iteratees__, G = N.length, Z = 0, ie = ft(I, this.__takeCount__);
        if (!a || !s && p == I && ie == I)
          return Ts(e, this.__actions__);
        var fe = [];
        e:
          for (; I-- && Z < ie; ) {
            B += n;
            for (var be = -1, ce = e[B]; ++be < G; ) {
              var _e = N[be], Ae = _e.iteratee, Et = _e.type, yt = Ae(ce);
              if (Et == oe)
                ce = yt;
              else if (!yt) {
                if (Et == J)
                  continue e;
                break e;
              }
            }
            fe[Z++] = ce;
          }
        return fe;
      }
      Se.prototype = ur(ki.prototype), Se.prototype.constructor = Se;
      function Bn(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.clear(); ++n < a; ) {
          var s = e[n];
          this.set(s[0], s[1]);
        }
      }
      function lh() {
        this.__data__ = kr ? kr(null) : {}, this.size = 0;
      }
      function oh(e) {
        var n = this.has(e) && delete this.__data__[e];
        return this.size -= n ? 1 : 0, n;
      }
      function uh(e) {
        var n = this.__data__;
        if (kr) {
          var a = n[e];
          return a === v ? r : a;
        }
        return Me.call(n, e) ? n[e] : r;
      }
      function sh(e) {
        var n = this.__data__;
        return kr ? n[e] !== r : Me.call(n, e);
      }
      function fh(e, n) {
        var a = this.__data__;
        return this.size += this.has(e) ? 0 : 1, a[e] = kr && n === r ? v : n, this;
      }
      Bn.prototype.clear = lh, Bn.prototype.delete = oh, Bn.prototype.get = uh, Bn.prototype.has = sh, Bn.prototype.set = fh;
      function on(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.clear(); ++n < a; ) {
          var s = e[n];
          this.set(s[0], s[1]);
        }
      }
      function ch() {
        this.__data__ = [], this.size = 0;
      }
      function dh(e) {
        var n = this.__data__, a = Vi(n, e);
        if (a < 0)
          return !1;
        var s = n.length - 1;
        return a == s ? n.pop() : Pi.call(n, a, 1), --this.size, !0;
      }
      function vh(e) {
        var n = this.__data__, a = Vi(n, e);
        return a < 0 ? r : n[a][1];
      }
      function ph(e) {
        return Vi(this.__data__, e) > -1;
      }
      function hh(e, n) {
        var a = this.__data__, s = Vi(a, e);
        return s < 0 ? (++this.size, a.push([e, n])) : a[s][1] = n, this;
      }
      on.prototype.clear = ch, on.prototype.delete = dh, on.prototype.get = vh, on.prototype.has = ph, on.prototype.set = hh;
      function un(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.clear(); ++n < a; ) {
          var s = e[n];
          this.set(s[0], s[1]);
        }
      }
      function mh() {
        this.size = 0, this.__data__ = {
          hash: new Bn(),
          map: new (Mr || on)(),
          string: new Bn()
        };
      }
      function gh(e) {
        var n = Ji(this, e).delete(e);
        return this.size -= n ? 1 : 0, n;
      }
      function yh(e) {
        return Ji(this, e).get(e);
      }
      function bh(e) {
        return Ji(this, e).has(e);
      }
      function wh(e, n) {
        var a = Ji(this, e), s = a.size;
        return a.set(e, n), this.size += a.size == s ? 0 : 1, this;
      }
      un.prototype.clear = mh, un.prototype.delete = gh, un.prototype.get = yh, un.prototype.has = bh, un.prototype.set = wh;
      function kn(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.__data__ = new un(); ++n < a; )
          this.add(e[n]);
      }
      function xh(e) {
        return this.__data__.set(e, v), this;
      }
      function _h(e) {
        return this.__data__.has(e);
      }
      kn.prototype.add = kn.prototype.push = xh, kn.prototype.has = _h;
      function Gt(e) {
        var n = this.__data__ = new on(e);
        this.size = n.size;
      }
      function Sh() {
        this.__data__ = new on(), this.size = 0;
      }
      function $h(e) {
        var n = this.__data__, a = n.delete(e);
        return this.size = n.size, a;
      }
      function Ah(e) {
        return this.__data__.get(e);
      }
      function Th(e) {
        return this.__data__.has(e);
      }
      function Ch(e, n) {
        var a = this.__data__;
        if (a instanceof on) {
          var s = a.__data__;
          if (!Mr || s.length < l - 1)
            return s.push([e, n]), this.size = ++a.size, this;
          a = this.__data__ = new un(s);
        }
        return a.set(e, n), this.size = a.size, this;
      }
      Gt.prototype.clear = Sh, Gt.prototype.delete = $h, Gt.prototype.get = Ah, Gt.prototype.has = Th, Gt.prototype.set = Ch;
      function rs(e, n) {
        var a = he(e), s = !a && Wn(e), p = !a && !s && On(e), b = !a && !s && !p && dr(e), $ = a || s || p || b, C = $ ? fl(e.length, Bp) : [], I = C.length;
        for (var B in e)
          (n || Me.call(e, B)) && !($ && // Safari 9 has enumerable `arguments.length` in strict mode.
          (B == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          p && (B == "offset" || B == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          b && (B == "buffer" || B == "byteLength" || B == "byteOffset") || // Skip index properties.
          dn(B, I))) && C.push(B);
        return C;
      }
      function is(e) {
        var n = e.length;
        return n ? e[Cl(0, n - 1)] : r;
      }
      function Eh(e, n) {
        return Xi(wt(e), Vn(n, 0, e.length));
      }
      function Oh(e) {
        return Xi(wt(e));
      }
      function gl(e, n, a) {
        (a !== r && !jt(e[n], a) || a === r && !(n in e)) && sn(e, n, a);
      }
      function Nr(e, n, a) {
        var s = e[n];
        (!(Me.call(e, n) && jt(s, a)) || a === r && !(n in e)) && sn(e, n, a);
      }
      function Vi(e, n) {
        for (var a = e.length; a--; )
          if (jt(e[a][0], n))
            return a;
        return -1;
      }
      function Ih(e, n, a, s) {
        return An(e, function(p, b, $) {
          n(s, p, a(p), $);
        }), s;
      }
      function as(e, n) {
        return e && Xt(n, it(n), e);
      }
      function Fh(e, n) {
        return e && Xt(n, _t(n), e);
      }
      function sn(e, n, a) {
        n == "__proto__" && Li ? Li(e, n, {
          configurable: !0,
          enumerable: !0,
          value: a,
          writable: !0
        }) : e[n] = a;
      }
      function yl(e, n) {
        for (var a = -1, s = n.length, p = L(s), b = e == null; ++a < s; )
          p[a] = b ? r : Xl(e, n[a]);
        return p;
      }
      function Vn(e, n, a) {
        return e === e && (a !== r && (e = e <= a ? e : a), n !== r && (e = e >= n ? e : n)), e;
      }
      function Mt(e, n, a, s, p, b) {
        var $, C = n & m, I = n & y, B = n & w;
        if (a && ($ = p ? a(e, s, p, b) : a(e)), $ !== r)
          return $;
        if (!je(e))
          return e;
        var N = he(e);
        if (N) {
          if ($ = b0(e), !C)
            return wt(e, $);
        } else {
          var G = ct(e), Z = G == gi || G == ou;
          if (On(e))
            return Os(e, C);
          if (G == ln || G == Xn || Z && !p) {
            if ($ = I || Z ? {} : qs(e), !C)
              return I ? u0(e, Fh($, e)) : o0(e, as($, e));
          } else {
            if (!Ve[G])
              return p ? e : {};
            $ = w0(e, G, C);
          }
        }
        b || (b = new Gt());
        var ie = b.get(e);
        if (ie)
          return ie;
        b.set(e, $), $f(e) ? e.forEach(function(ce) {
          $.add(Mt(ce, n, a, ce, e, b));
        }) : _f(e) && e.forEach(function(ce, _e) {
          $.set(_e, Mt(ce, n, a, _e, e, b));
        });
        var fe = B ? I ? kl : Bl : I ? _t : it, be = N ? r : fe(e);
        return Lt(be || e, function(ce, _e) {
          be && (_e = ce, ce = e[_e]), Nr($, _e, Mt(ce, n, a, _e, e, b));
        }), $;
      }
      function Ph(e) {
        var n = it(e);
        return function(a) {
          return ls(a, e, n);
        };
      }
      function ls(e, n, a) {
        var s = a.length;
        if (e == null)
          return !s;
        for (e = Be(e); s--; ) {
          var p = a[s], b = n[p], $ = e[p];
          if ($ === r && !(p in e) || !b($))
            return !1;
        }
        return !0;
      }
      function os(e, n, a) {
        if (typeof e != "function")
          throw new Rt(f);
        return Kr(function() {
          e.apply(r, a);
        }, n);
      }
      function Ur(e, n, a, s) {
        var p = -1, b = _i, $ = !0, C = e.length, I = [], B = n.length;
        if (!C)
          return I;
        a && (n = He(n, At(a))), s ? (b = il, $ = !1) : n.length >= l && (b = Rr, $ = !1, n = new kn(n));
        e:
          for (; ++p < C; ) {
            var N = e[p], G = a == null ? N : a(N);
            if (N = s || N !== 0 ? N : 0, $ && G === G) {
              for (var Z = B; Z--; )
                if (n[Z] === G)
                  continue e;
              I.push(N);
            } else
              b(n, G, s) || I.push(N);
          }
        return I;
      }
      var An = Rs(Jt), us = Rs(wl, !0);
      function Lh(e, n) {
        var a = !0;
        return An(e, function(s, p, b) {
          return a = !!n(s, p, b), a;
        }), a;
      }
      function Ni(e, n, a) {
        for (var s = -1, p = e.length; ++s < p; ) {
          var b = e[s], $ = n(b);
          if ($ != null && (C === r ? $ === $ && !Ct($) : a($, C)))
            var C = $, I = b;
        }
        return I;
      }
      function Rh(e, n, a, s) {
        var p = e.length;
        for (a = ge(a), a < 0 && (a = -a > p ? 0 : p + a), s = s === r || s > p ? p : ge(s), s < 0 && (s += p), s = a > s ? 0 : Tf(s); a < s; )
          e[a++] = n;
        return e;
      }
      function ss(e, n) {
        var a = [];
        return An(e, function(s, p, b) {
          n(s, p, b) && a.push(s);
        }), a;
      }
      function ut(e, n, a, s, p) {
        var b = -1, $ = e.length;
        for (a || (a = _0), p || (p = []); ++b < $; ) {
          var C = e[b];
          n > 0 && a(C) ? n > 1 ? ut(C, n - 1, a, s, p) : _n(p, C) : s || (p[p.length] = C);
        }
        return p;
      }
      var bl = Ds(), fs = Ds(!0);
      function Jt(e, n) {
        return e && bl(e, n, it);
      }
      function wl(e, n) {
        return e && fs(e, n, it);
      }
      function Ui(e, n) {
        return xn(n, function(a) {
          return vn(e[a]);
        });
      }
      function Nn(e, n) {
        n = Cn(n, e);
        for (var a = 0, s = n.length; e != null && a < s; )
          e = e[Qt(n[a++])];
        return a && a == s ? e : r;
      }
      function cs(e, n, a) {
        var s = n(e);
        return he(e) ? s : _n(s, a(e));
      }
      function mt(e) {
        return e == null ? e === r ? sv : ov : Mn && Mn in Be(e) ? m0(e) : O0(e);
      }
      function xl(e, n) {
        return e > n;
      }
      function Dh(e, n) {
        return e != null && Me.call(e, n);
      }
      function Mh(e, n) {
        return e != null && n in Be(e);
      }
      function Bh(e, n, a) {
        return e >= ft(n, a) && e < nt(n, a);
      }
      function _l(e, n, a) {
        for (var s = a ? il : _i, p = e[0].length, b = e.length, $ = b, C = L(b), I = 1 / 0, B = []; $--; ) {
          var N = e[$];
          $ && n && (N = He(N, At(n))), I = ft(N.length, I), C[$] = !a && (n || p >= 120 && N.length >= 120) ? new kn($ && N) : r;
        }
        N = e[0];
        var G = -1, Z = C[0];
        e:
          for (; ++G < p && B.length < I; ) {
            var ie = N[G], fe = n ? n(ie) : ie;
            if (ie = a || ie !== 0 ? ie : 0, !(Z ? Rr(Z, fe) : s(B, fe, a))) {
              for ($ = b; --$; ) {
                var be = C[$];
                if (!(be ? Rr(be, fe) : s(e[$], fe, a)))
                  continue e;
              }
              Z && Z.push(fe), B.push(ie);
            }
          }
        return B;
      }
      function kh(e, n, a, s) {
        return Jt(e, function(p, b, $) {
          n(s, a(p), b, $);
        }), s;
      }
      function zr(e, n, a) {
        n = Cn(n, e), e = Xs(e, n);
        var s = e == null ? e : e[Qt(kt(n))];
        return s == null ? r : $t(s, e, a);
      }
      function ds(e) {
        return Ke(e) && mt(e) == Xn;
      }
      function Vh(e) {
        return Ke(e) && mt(e) == Lr;
      }
      function Nh(e) {
        return Ke(e) && mt(e) == Er;
      }
      function Wr(e, n, a, s, p) {
        return e === n ? !0 : e == null || n == null || !Ke(e) && !Ke(n) ? e !== e && n !== n : Uh(e, n, a, s, Wr, p);
      }
      function Uh(e, n, a, s, p, b) {
        var $ = he(e), C = he(n), I = $ ? hi : ct(e), B = C ? hi : ct(n);
        I = I == Xn ? ln : I, B = B == Xn ? ln : B;
        var N = I == ln, G = B == ln, Z = I == B;
        if (Z && On(e)) {
          if (!On(n))
            return !1;
          $ = !0, N = !1;
        }
        if (Z && !N)
          return b || (b = new Gt()), $ || dr(e) ? Gs(e, n, a, s, p, b) : p0(e, n, I, a, s, p, b);
        if (!(a & x)) {
          var ie = N && Me.call(e, "__wrapped__"), fe = G && Me.call(n, "__wrapped__");
          if (ie || fe) {
            var be = ie ? e.value() : e, ce = fe ? n.value() : n;
            return b || (b = new Gt()), p(be, ce, a, s, b);
          }
        }
        return Z ? (b || (b = new Gt()), h0(e, n, a, s, p, b)) : !1;
      }
      function zh(e) {
        return Ke(e) && ct(e) == zt;
      }
      function Sl(e, n, a, s) {
        var p = a.length, b = p, $ = !s;
        if (e == null)
          return !b;
        for (e = Be(e); p--; ) {
          var C = a[p];
          if ($ && C[2] ? C[1] !== e[C[0]] : !(C[0] in e))
            return !1;
        }
        for (; ++p < b; ) {
          C = a[p];
          var I = C[0], B = e[I], N = C[1];
          if ($ && C[2]) {
            if (B === r && !(I in e))
              return !1;
          } else {
            var G = new Gt();
            if (s)
              var Z = s(B, N, I, e, n, G);
            if (!(Z === r ? Wr(N, B, x | S, s, G) : Z))
              return !1;
          }
        }
        return !0;
      }
      function vs(e) {
        if (!je(e) || $0(e))
          return !1;
        var n = vn(e) ? zp : Pv;
        return n.test(zn(e));
      }
      function Wh(e) {
        return Ke(e) && mt(e) == Ir;
      }
      function Hh(e) {
        return Ke(e) && ct(e) == Wt;
      }
      function Gh(e) {
        return Ke(e) && ia(e.length) && !!Ne[mt(e)];
      }
      function ps(e) {
        return typeof e == "function" ? e : e == null ? St : typeof e == "object" ? he(e) ? gs(e[0], e[1]) : ms(e) : Bf(e);
      }
      function $l(e) {
        if (!jr(e))
          return qp(e);
        var n = [];
        for (var a in Be(e))
          Me.call(e, a) && a != "constructor" && n.push(a);
        return n;
      }
      function jh(e) {
        if (!je(e))
          return E0(e);
        var n = jr(e), a = [];
        for (var s in e)
          s == "constructor" && (n || !Me.call(e, s)) || a.push(s);
        return a;
      }
      function Al(e, n) {
        return e < n;
      }
      function hs(e, n) {
        var a = -1, s = xt(e) ? L(e.length) : [];
        return An(e, function(p, b, $) {
          s[++a] = n(p, b, $);
        }), s;
      }
      function ms(e) {
        var n = Nl(e);
        return n.length == 1 && n[0][2] ? Zs(n[0][0], n[0][1]) : function(a) {
          return a === e || Sl(a, e, n);
        };
      }
      function gs(e, n) {
        return zl(e) && Ys(n) ? Zs(Qt(e), n) : function(a) {
          var s = Xl(a, e);
          return s === r && s === n ? Ql(a, e) : Wr(n, s, x | S);
        };
      }
      function zi(e, n, a, s, p) {
        e !== n && bl(n, function(b, $) {
          if (p || (p = new Gt()), je(b))
            Kh(e, n, $, a, zi, s, p);
          else {
            var C = s ? s(Hl(e, $), b, $ + "", e, n, p) : r;
            C === r && (C = b), gl(e, $, C);
          }
        }, _t);
      }
      function Kh(e, n, a, s, p, b, $) {
        var C = Hl(e, a), I = Hl(n, a), B = $.get(I);
        if (B) {
          gl(e, a, B);
          return;
        }
        var N = b ? b(C, I, a + "", e, n, $) : r, G = N === r;
        if (G) {
          var Z = he(I), ie = !Z && On(I), fe = !Z && !ie && dr(I);
          N = I, Z || ie || fe ? he(C) ? N = C : Ye(C) ? N = wt(C) : ie ? (G = !1, N = Os(I, !0)) : fe ? (G = !1, N = Is(I, !0)) : N = [] : qr(I) || Wn(I) ? (N = C, Wn(C) ? N = Cf(C) : (!je(C) || vn(C)) && (N = qs(I))) : G = !1;
        }
        G && ($.set(I, N), p(N, I, s, b, $), $.delete(I)), gl(e, a, N);
      }
      function ys(e, n) {
        var a = e.length;
        if (a)
          return n += n < 0 ? a : 0, dn(n, a) ? e[n] : r;
      }
      function bs(e, n, a) {
        n.length ? n = He(n, function(b) {
          return he(b) ? function($) {
            return Nn($, b.length === 1 ? b[0] : b);
          } : b;
        }) : n = [St];
        var s = -1;
        n = He(n, At(ue()));
        var p = hs(e, function(b, $, C) {
          var I = He(n, function(B) {
            return B(b);
          });
          return { criteria: I, index: ++s, value: b };
        });
        return wp(p, function(b, $) {
          return l0(b, $, a);
        });
      }
      function qh(e, n) {
        return ws(e, n, function(a, s) {
          return Ql(e, s);
        });
      }
      function ws(e, n, a) {
        for (var s = -1, p = n.length, b = {}; ++s < p; ) {
          var $ = n[s], C = Nn(e, $);
          a(C, $) && Hr(b, Cn($, e), C);
        }
        return b;
      }
      function Yh(e) {
        return function(n) {
          return Nn(n, e);
        };
      }
      function Tl(e, n, a, s) {
        var p = s ? bp : tr, b = -1, $ = n.length, C = e;
        for (e === n && (n = wt(n)), a && (C = He(e, At(a))); ++b < $; )
          for (var I = 0, B = n[b], N = a ? a(B) : B; (I = p(C, N, I, s)) > -1; )
            C !== e && Pi.call(C, I, 1), Pi.call(e, I, 1);
        return e;
      }
      function xs(e, n) {
        for (var a = e ? n.length : 0, s = a - 1; a--; ) {
          var p = n[a];
          if (a == s || p !== b) {
            var b = p;
            dn(p) ? Pi.call(e, p, 1) : Il(e, p);
          }
        }
        return e;
      }
      function Cl(e, n) {
        return e + Di(ts() * (n - e + 1));
      }
      function Zh(e, n, a, s) {
        for (var p = -1, b = nt(Ri((n - e) / (a || 1)), 0), $ = L(b); b--; )
          $[s ? b : ++p] = e, e += a;
        return $;
      }
      function El(e, n) {
        var a = "";
        if (!e || n < 1 || n > We)
          return a;
        do
          n % 2 && (a += e), n = Di(n / 2), n && (e += e);
        while (n);
        return a;
      }
      function we(e, n) {
        return Gl(Js(e, n, St), e + "");
      }
      function Jh(e) {
        return is(vr(e));
      }
      function Xh(e, n) {
        var a = vr(e);
        return Xi(a, Vn(n, 0, a.length));
      }
      function Hr(e, n, a, s) {
        if (!je(e))
          return e;
        n = Cn(n, e);
        for (var p = -1, b = n.length, $ = b - 1, C = e; C != null && ++p < b; ) {
          var I = Qt(n[p]), B = a;
          if (I === "__proto__" || I === "constructor" || I === "prototype")
            return e;
          if (p != $) {
            var N = C[I];
            B = s ? s(N, I, C) : r, B === r && (B = je(N) ? N : dn(n[p + 1]) ? [] : {});
          }
          Nr(C, I, B), C = C[I];
        }
        return e;
      }
      var _s = Mi ? function(e, n) {
        return Mi.set(e, n), e;
      } : St, Qh = Li ? function(e, n) {
        return Li(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: to(n),
          writable: !0
        });
      } : St;
      function e0(e) {
        return Xi(vr(e));
      }
      function Bt(e, n, a) {
        var s = -1, p = e.length;
        n < 0 && (n = -n > p ? 0 : p + n), a = a > p ? p : a, a < 0 && (a += p), p = n > a ? 0 : a - n >>> 0, n >>>= 0;
        for (var b = L(p); ++s < p; )
          b[s] = e[s + n];
        return b;
      }
      function t0(e, n) {
        var a;
        return An(e, function(s, p, b) {
          return a = n(s, p, b), !a;
        }), !!a;
      }
      function Wi(e, n, a) {
        var s = 0, p = e == null ? s : e.length;
        if (typeof n == "number" && n === n && p <= Tr) {
          for (; s < p; ) {
            var b = s + p >>> 1, $ = e[b];
            $ !== null && !Ct($) && (a ? $ <= n : $ < n) ? s = b + 1 : p = b;
          }
          return p;
        }
        return Ol(e, n, St, a);
      }
      function Ol(e, n, a, s) {
        var p = 0, b = e == null ? 0 : e.length;
        if (b === 0)
          return 0;
        n = a(n);
        for (var $ = n !== n, C = n === null, I = Ct(n), B = n === r; p < b; ) {
          var N = Di((p + b) / 2), G = a(e[N]), Z = G !== r, ie = G === null, fe = G === G, be = Ct(G);
          if ($)
            var ce = s || fe;
          else
            B ? ce = fe && (s || Z) : C ? ce = fe && Z && (s || !ie) : I ? ce = fe && Z && !ie && (s || !be) : ie || be ? ce = !1 : ce = s ? G <= n : G < n;
          ce ? p = N + 1 : b = N;
        }
        return ft(b, Jn);
      }
      function Ss(e, n) {
        for (var a = -1, s = e.length, p = 0, b = []; ++a < s; ) {
          var $ = e[a], C = n ? n($) : $;
          if (!a || !jt(C, I)) {
            var I = C;
            b[p++] = $ === 0 ? 0 : $;
          }
        }
        return b;
      }
      function $s(e) {
        return typeof e == "number" ? e : Ct(e) ? wn : +e;
      }
      function Tt(e) {
        if (typeof e == "string")
          return e;
        if (he(e))
          return He(e, Tt) + "";
        if (Ct(e))
          return ns ? ns.call(e) : "";
        var n = e + "";
        return n == "0" && 1 / e == -ye ? "-0" : n;
      }
      function Tn(e, n, a) {
        var s = -1, p = _i, b = e.length, $ = !0, C = [], I = C;
        if (a)
          $ = !1, p = il;
        else if (b >= l) {
          var B = n ? null : d0(e);
          if (B)
            return $i(B);
          $ = !1, p = Rr, I = new kn();
        } else
          I = n ? [] : C;
        e:
          for (; ++s < b; ) {
            var N = e[s], G = n ? n(N) : N;
            if (N = a || N !== 0 ? N : 0, $ && G === G) {
              for (var Z = I.length; Z--; )
                if (I[Z] === G)
                  continue e;
              n && I.push(G), C.push(N);
            } else
              p(I, G, a) || (I !== C && I.push(G), C.push(N));
          }
        return C;
      }
      function Il(e, n) {
        return n = Cn(n, e), e = Xs(e, n), e == null || delete e[Qt(kt(n))];
      }
      function As(e, n, a, s) {
        return Hr(e, n, a(Nn(e, n)), s);
      }
      function Hi(e, n, a, s) {
        for (var p = e.length, b = s ? p : -1; (s ? b-- : ++b < p) && n(e[b], b, e); )
          ;
        return a ? Bt(e, s ? 0 : b, s ? b + 1 : p) : Bt(e, s ? b + 1 : 0, s ? p : b);
      }
      function Ts(e, n) {
        var a = e;
        return a instanceof Se && (a = a.value()), al(n, function(s, p) {
          return p.func.apply(p.thisArg, _n([s], p.args));
        }, a);
      }
      function Fl(e, n, a) {
        var s = e.length;
        if (s < 2)
          return s ? Tn(e[0]) : [];
        for (var p = -1, b = L(s); ++p < s; )
          for (var $ = e[p], C = -1; ++C < s; )
            C != p && (b[p] = Ur(b[p] || $, e[C], n, a));
        return Tn(ut(b, 1), n, a);
      }
      function Cs(e, n, a) {
        for (var s = -1, p = e.length, b = n.length, $ = {}; ++s < p; ) {
          var C = s < b ? n[s] : r;
          a($, e[s], C);
        }
        return $;
      }
      function Pl(e) {
        return Ye(e) ? e : [];
      }
      function Ll(e) {
        return typeof e == "function" ? e : St;
      }
      function Cn(e, n) {
        return he(e) ? e : zl(e, n) ? [e] : nf(Re(e));
      }
      var n0 = we;
      function En(e, n, a) {
        var s = e.length;
        return a = a === r ? s : a, !n && a >= s ? e : Bt(e, n, a);
      }
      var Es = Wp || function(e) {
        return ot.clearTimeout(e);
      };
      function Os(e, n) {
        if (n)
          return e.slice();
        var a = e.length, s = Zu ? Zu(a) : new e.constructor(a);
        return e.copy(s), s;
      }
      function Rl(e) {
        var n = new e.constructor(e.byteLength);
        return new Ii(n).set(new Ii(e)), n;
      }
      function r0(e, n) {
        var a = n ? Rl(e.buffer) : e.buffer;
        return new e.constructor(a, e.byteOffset, e.byteLength);
      }
      function i0(e) {
        var n = new e.constructor(e.source, du.exec(e));
        return n.lastIndex = e.lastIndex, n;
      }
      function a0(e) {
        return Vr ? Be(Vr.call(e)) : {};
      }
      function Is(e, n) {
        var a = n ? Rl(e.buffer) : e.buffer;
        return new e.constructor(a, e.byteOffset, e.length);
      }
      function Fs(e, n) {
        if (e !== n) {
          var a = e !== r, s = e === null, p = e === e, b = Ct(e), $ = n !== r, C = n === null, I = n === n, B = Ct(n);
          if (!C && !B && !b && e > n || b && $ && I && !C && !B || s && $ && I || !a && I || !p)
            return 1;
          if (!s && !b && !B && e < n || B && a && p && !s && !b || C && a && p || !$ && p || !I)
            return -1;
        }
        return 0;
      }
      function l0(e, n, a) {
        for (var s = -1, p = e.criteria, b = n.criteria, $ = p.length, C = a.length; ++s < $; ) {
          var I = Fs(p[s], b[s]);
          if (I) {
            if (s >= C)
              return I;
            var B = a[s];
            return I * (B == "desc" ? -1 : 1);
          }
        }
        return e.index - n.index;
      }
      function Ps(e, n, a, s) {
        for (var p = -1, b = e.length, $ = a.length, C = -1, I = n.length, B = nt(b - $, 0), N = L(I + B), G = !s; ++C < I; )
          N[C] = n[C];
        for (; ++p < $; )
          (G || p < b) && (N[a[p]] = e[p]);
        for (; B--; )
          N[C++] = e[p++];
        return N;
      }
      function Ls(e, n, a, s) {
        for (var p = -1, b = e.length, $ = -1, C = a.length, I = -1, B = n.length, N = nt(b - C, 0), G = L(N + B), Z = !s; ++p < N; )
          G[p] = e[p];
        for (var ie = p; ++I < B; )
          G[ie + I] = n[I];
        for (; ++$ < C; )
          (Z || p < b) && (G[ie + a[$]] = e[p++]);
        return G;
      }
      function wt(e, n) {
        var a = -1, s = e.length;
        for (n || (n = L(s)); ++a < s; )
          n[a] = e[a];
        return n;
      }
      function Xt(e, n, a, s) {
        var p = !a;
        a || (a = {});
        for (var b = -1, $ = n.length; ++b < $; ) {
          var C = n[b], I = s ? s(a[C], e[C], C, a, e) : r;
          I === r && (I = e[C]), p ? sn(a, C, I) : Nr(a, C, I);
        }
        return a;
      }
      function o0(e, n) {
        return Xt(e, Ul(e), n);
      }
      function u0(e, n) {
        return Xt(e, js(e), n);
      }
      function Gi(e, n) {
        return function(a, s) {
          var p = he(a) ? vp : Ih, b = n ? n() : {};
          return p(a, e, ue(s, 2), b);
        };
      }
      function sr(e) {
        return we(function(n, a) {
          var s = -1, p = a.length, b = p > 1 ? a[p - 1] : r, $ = p > 2 ? a[2] : r;
          for (b = e.length > 3 && typeof b == "function" ? (p--, b) : r, $ && gt(a[0], a[1], $) && (b = p < 3 ? r : b, p = 1), n = Be(n); ++s < p; ) {
            var C = a[s];
            C && e(n, C, s, b);
          }
          return n;
        });
      }
      function Rs(e, n) {
        return function(a, s) {
          if (a == null)
            return a;
          if (!xt(a))
            return e(a, s);
          for (var p = a.length, b = n ? p : -1, $ = Be(a); (n ? b-- : ++b < p) && s($[b], b, $) !== !1; )
            ;
          return a;
        };
      }
      function Ds(e) {
        return function(n, a, s) {
          for (var p = -1, b = Be(n), $ = s(n), C = $.length; C--; ) {
            var I = $[e ? C : ++p];
            if (a(b[I], I, b) === !1)
              break;
          }
          return n;
        };
      }
      function s0(e, n, a) {
        var s = n & _, p = Gr(e);
        function b() {
          var $ = this && this !== ot && this instanceof b ? p : e;
          return $.apply(s ? a : this, arguments);
        }
        return b;
      }
      function Ms(e) {
        return function(n) {
          n = Re(n);
          var a = nr(n) ? Ht(n) : r, s = a ? a[0] : n.charAt(0), p = a ? En(a, 1).join("") : n.slice(1);
          return s[e]() + p;
        };
      }
      function fr(e) {
        return function(n) {
          return al(Df(Rf(n).replace(Qv, "")), e, "");
        };
      }
      function Gr(e) {
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return new e();
            case 1:
              return new e(n[0]);
            case 2:
              return new e(n[0], n[1]);
            case 3:
              return new e(n[0], n[1], n[2]);
            case 4:
              return new e(n[0], n[1], n[2], n[3]);
            case 5:
              return new e(n[0], n[1], n[2], n[3], n[4]);
            case 6:
              return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
            case 7:
              return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
          }
          var a = ur(e.prototype), s = e.apply(a, n);
          return je(s) ? s : a;
        };
      }
      function f0(e, n, a) {
        var s = Gr(e);
        function p() {
          for (var b = arguments.length, $ = L(b), C = b, I = cr(p); C--; )
            $[C] = arguments[C];
          var B = b < 3 && $[0] !== I && $[b - 1] !== I ? [] : Sn($, I);
          if (b -= B.length, b < a)
            return Us(
              e,
              n,
              ji,
              p.placeholder,
              r,
              $,
              B,
              r,
              r,
              a - b
            );
          var N = this && this !== ot && this instanceof p ? s : e;
          return $t(N, this, $);
        }
        return p;
      }
      function Bs(e) {
        return function(n, a, s) {
          var p = Be(n);
          if (!xt(n)) {
            var b = ue(a, 3);
            n = it(n), a = function(C) {
              return b(p[C], C, p);
            };
          }
          var $ = e(n, a, s);
          return $ > -1 ? p[b ? n[$] : $] : r;
        };
      }
      function ks(e) {
        return cn(function(n) {
          var a = n.length, s = a, p = Dt.prototype.thru;
          for (e && n.reverse(); s--; ) {
            var b = n[s];
            if (typeof b != "function")
              throw new Rt(f);
            if (p && !$ && Zi(b) == "wrapper")
              var $ = new Dt([], !0);
          }
          for (s = $ ? s : a; ++s < a; ) {
            b = n[s];
            var C = Zi(b), I = C == "wrapper" ? Vl(b) : r;
            I && Wl(I[0]) && I[1] == (V | E | P | M) && !I[4].length && I[9] == 1 ? $ = $[Zi(I[0])].apply($, I[3]) : $ = b.length == 1 && Wl(b) ? $[C]() : $.thru(b);
          }
          return function() {
            var B = arguments, N = B[0];
            if ($ && B.length == 1 && he(N))
              return $.plant(N).value();
            for (var G = 0, Z = a ? n[G].apply(this, B) : N; ++G < a; )
              Z = n[G].call(this, Z);
            return Z;
          };
        });
      }
      function ji(e, n, a, s, p, b, $, C, I, B) {
        var N = n & V, G = n & _, Z = n & A, ie = n & (E | F), fe = n & H, be = Z ? r : Gr(e);
        function ce() {
          for (var _e = arguments.length, Ae = L(_e), Et = _e; Et--; )
            Ae[Et] = arguments[Et];
          if (ie)
            var yt = cr(ce), Ot = _p(Ae, yt);
          if (s && (Ae = Ps(Ae, s, p, ie)), b && (Ae = Ls(Ae, b, $, ie)), _e -= Ot, ie && _e < B) {
            var Ze = Sn(Ae, yt);
            return Us(
              e,
              n,
              ji,
              ce.placeholder,
              a,
              Ae,
              Ze,
              C,
              I,
              B - _e
            );
          }
          var Kt = G ? a : this, hn = Z ? Kt[e] : e;
          return _e = Ae.length, C ? Ae = I0(Ae, C) : fe && _e > 1 && Ae.reverse(), N && I < _e && (Ae.length = I), this && this !== ot && this instanceof ce && (hn = be || Gr(hn)), hn.apply(Kt, Ae);
        }
        return ce;
      }
      function Vs(e, n) {
        return function(a, s) {
          return kh(a, e, n(s), {});
        };
      }
      function Ki(e, n) {
        return function(a, s) {
          var p;
          if (a === r && s === r)
            return n;
          if (a !== r && (p = a), s !== r) {
            if (p === r)
              return s;
            typeof a == "string" || typeof s == "string" ? (a = Tt(a), s = Tt(s)) : (a = $s(a), s = $s(s)), p = e(a, s);
          }
          return p;
        };
      }
      function Dl(e) {
        return cn(function(n) {
          return n = He(n, At(ue())), we(function(a) {
            var s = this;
            return e(n, function(p) {
              return $t(p, s, a);
            });
          });
        });
      }
      function qi(e, n) {
        n = n === r ? " " : Tt(n);
        var a = n.length;
        if (a < 2)
          return a ? El(n, e) : n;
        var s = El(n, Ri(e / rr(n)));
        return nr(n) ? En(Ht(s), 0, e).join("") : s.slice(0, e);
      }
      function c0(e, n, a, s) {
        var p = n & _, b = Gr(e);
        function $() {
          for (var C = -1, I = arguments.length, B = -1, N = s.length, G = L(N + I), Z = this && this !== ot && this instanceof $ ? b : e; ++B < N; )
            G[B] = s[B];
          for (; I--; )
            G[B++] = arguments[++C];
          return $t(Z, p ? a : this, G);
        }
        return $;
      }
      function Ns(e) {
        return function(n, a, s) {
          return s && typeof s != "number" && gt(n, a, s) && (a = s = r), n = pn(n), a === r ? (a = n, n = 0) : a = pn(a), s = s === r ? n < a ? 1 : -1 : pn(s), Zh(n, a, s, e);
        };
      }
      function Yi(e) {
        return function(n, a) {
          return typeof n == "string" && typeof a == "string" || (n = Vt(n), a = Vt(a)), e(n, a);
        };
      }
      function Us(e, n, a, s, p, b, $, C, I, B) {
        var N = n & E, G = N ? $ : r, Z = N ? r : $, ie = N ? b : r, fe = N ? r : b;
        n |= N ? P : R, n &= ~(N ? R : P), n & T || (n &= ~(_ | A));
        var be = [
          e,
          n,
          p,
          ie,
          G,
          fe,
          Z,
          C,
          I,
          B
        ], ce = a.apply(r, be);
        return Wl(e) && Qs(ce, be), ce.placeholder = s, ef(ce, e, n);
      }
      function Ml(e) {
        var n = tt[e];
        return function(a, s) {
          if (a = Vt(a), s = s == null ? 0 : ft(ge(s), 292), s && es(a)) {
            var p = (Re(a) + "e").split("e"), b = n(p[0] + "e" + (+p[1] + s));
            return p = (Re(b) + "e").split("e"), +(p[0] + "e" + (+p[1] - s));
          }
          return n(a);
        };
      }
      var d0 = lr && 1 / $i(new lr([, -0]))[1] == ye ? function(e) {
        return new lr(e);
      } : io;
      function zs(e) {
        return function(n) {
          var a = ct(n);
          return a == zt ? dl(n) : a == Wt ? Op(n) : xp(n, e(n));
        };
      }
      function fn(e, n, a, s, p, b, $, C) {
        var I = n & A;
        if (!I && typeof e != "function")
          throw new Rt(f);
        var B = s ? s.length : 0;
        if (B || (n &= ~(P | R), s = p = r), $ = $ === r ? $ : nt(ge($), 0), C = C === r ? C : ge(C), B -= p ? p.length : 0, n & R) {
          var N = s, G = p;
          s = p = r;
        }
        var Z = I ? r : Vl(e), ie = [
          e,
          n,
          a,
          s,
          p,
          N,
          G,
          b,
          $,
          C
        ];
        if (Z && C0(ie, Z), e = ie[0], n = ie[1], a = ie[2], s = ie[3], p = ie[4], C = ie[9] = ie[9] === r ? I ? 0 : e.length : nt(ie[9] - B, 0), !C && n & (E | F) && (n &= ~(E | F)), !n || n == _)
          var fe = s0(e, n, a);
        else
          n == E || n == F ? fe = f0(e, n, C) : (n == P || n == (_ | P)) && !p.length ? fe = c0(e, n, a, s) : fe = ji.apply(r, ie);
        var be = Z ? _s : Qs;
        return ef(be(fe, ie), e, n);
      }
      function Ws(e, n, a, s) {
        return e === r || jt(e, ar[a]) && !Me.call(s, a) ? n : e;
      }
      function Hs(e, n, a, s, p, b) {
        return je(e) && je(n) && (b.set(n, e), zi(e, n, r, Hs, b), b.delete(n)), e;
      }
      function v0(e) {
        return qr(e) ? r : e;
      }
      function Gs(e, n, a, s, p, b) {
        var $ = a & x, C = e.length, I = n.length;
        if (C != I && !($ && I > C))
          return !1;
        var B = b.get(e), N = b.get(n);
        if (B && N)
          return B == n && N == e;
        var G = -1, Z = !0, ie = a & S ? new kn() : r;
        for (b.set(e, n), b.set(n, e); ++G < C; ) {
          var fe = e[G], be = n[G];
          if (s)
            var ce = $ ? s(be, fe, G, n, e, b) : s(fe, be, G, e, n, b);
          if (ce !== r) {
            if (ce)
              continue;
            Z = !1;
            break;
          }
          if (ie) {
            if (!ll(n, function(_e, Ae) {
              if (!Rr(ie, Ae) && (fe === _e || p(fe, _e, a, s, b)))
                return ie.push(Ae);
            })) {
              Z = !1;
              break;
            }
          } else if (!(fe === be || p(fe, be, a, s, b))) {
            Z = !1;
            break;
          }
        }
        return b.delete(e), b.delete(n), Z;
      }
      function p0(e, n, a, s, p, b, $) {
        switch (a) {
          case Qn:
            if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
              return !1;
            e = e.buffer, n = n.buffer;
          case Lr:
            return !(e.byteLength != n.byteLength || !b(new Ii(e), new Ii(n)));
          case Cr:
          case Er:
          case Or:
            return jt(+e, +n);
          case mi:
            return e.name == n.name && e.message == n.message;
          case Ir:
          case Fr:
            return e == n + "";
          case zt:
            var C = dl;
          case Wt:
            var I = s & x;
            if (C || (C = $i), e.size != n.size && !I)
              return !1;
            var B = $.get(e);
            if (B)
              return B == n;
            s |= S, $.set(e, n);
            var N = Gs(C(e), C(n), s, p, b, $);
            return $.delete(e), N;
          case yi:
            if (Vr)
              return Vr.call(e) == Vr.call(n);
        }
        return !1;
      }
      function h0(e, n, a, s, p, b) {
        var $ = a & x, C = Bl(e), I = C.length, B = Bl(n), N = B.length;
        if (I != N && !$)
          return !1;
        for (var G = I; G--; ) {
          var Z = C[G];
          if (!($ ? Z in n : Me.call(n, Z)))
            return !1;
        }
        var ie = b.get(e), fe = b.get(n);
        if (ie && fe)
          return ie == n && fe == e;
        var be = !0;
        b.set(e, n), b.set(n, e);
        for (var ce = $; ++G < I; ) {
          Z = C[G];
          var _e = e[Z], Ae = n[Z];
          if (s)
            var Et = $ ? s(Ae, _e, Z, n, e, b) : s(_e, Ae, Z, e, n, b);
          if (!(Et === r ? _e === Ae || p(_e, Ae, a, s, b) : Et)) {
            be = !1;
            break;
          }
          ce || (ce = Z == "constructor");
        }
        if (be && !ce) {
          var yt = e.constructor, Ot = n.constructor;
          yt != Ot && "constructor" in e && "constructor" in n && !(typeof yt == "function" && yt instanceof yt && typeof Ot == "function" && Ot instanceof Ot) && (be = !1);
        }
        return b.delete(e), b.delete(n), be;
      }
      function cn(e) {
        return Gl(Js(e, r, of), e + "");
      }
      function Bl(e) {
        return cs(e, it, Ul);
      }
      function kl(e) {
        return cs(e, _t, js);
      }
      var Vl = Mi ? function(e) {
        return Mi.get(e);
      } : io;
      function Zi(e) {
        for (var n = e.name + "", a = or[n], s = Me.call(or, n) ? a.length : 0; s--; ) {
          var p = a[s], b = p.func;
          if (b == null || b == e)
            return p.name;
        }
        return n;
      }
      function cr(e) {
        var n = Me.call(g, "placeholder") ? g : e;
        return n.placeholder;
      }
      function ue() {
        var e = g.iteratee || no;
        return e = e === no ? ps : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function Ji(e, n) {
        var a = e.__data__;
        return S0(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
      }
      function Nl(e) {
        for (var n = it(e), a = n.length; a--; ) {
          var s = n[a], p = e[s];
          n[a] = [s, p, Ys(p)];
        }
        return n;
      }
      function Un(e, n) {
        var a = Tp(e, n);
        return vs(a) ? a : r;
      }
      function m0(e) {
        var n = Me.call(e, Mn), a = e[Mn];
        try {
          e[Mn] = r;
          var s = !0;
        } catch {
        }
        var p = Ei.call(e);
        return s && (n ? e[Mn] = a : delete e[Mn]), p;
      }
      var Ul = pl ? function(e) {
        return e == null ? [] : (e = Be(e), xn(pl(e), function(n) {
          return Xu.call(e, n);
        }));
      } : ao, js = pl ? function(e) {
        for (var n = []; e; )
          _n(n, Ul(e)), e = Fi(e);
        return n;
      } : ao, ct = mt;
      (hl && ct(new hl(new ArrayBuffer(1))) != Qn || Mr && ct(new Mr()) != zt || ml && ct(ml.resolve()) != uu || lr && ct(new lr()) != Wt || Br && ct(new Br()) != Pr) && (ct = function(e) {
        var n = mt(e), a = n == ln ? e.constructor : r, s = a ? zn(a) : "";
        if (s)
          switch (s) {
            case Xp:
              return Qn;
            case Qp:
              return zt;
            case eh:
              return uu;
            case th:
              return Wt;
            case nh:
              return Pr;
          }
        return n;
      });
      function g0(e, n, a) {
        for (var s = -1, p = a.length; ++s < p; ) {
          var b = a[s], $ = b.size;
          switch (b.type) {
            case "drop":
              e += $;
              break;
            case "dropRight":
              n -= $;
              break;
            case "take":
              n = ft(n, e + $);
              break;
            case "takeRight":
              e = nt(e, n - $);
              break;
          }
        }
        return { start: e, end: n };
      }
      function y0(e) {
        var n = e.match($v);
        return n ? n[1].split(Av) : [];
      }
      function Ks(e, n, a) {
        n = Cn(n, e);
        for (var s = -1, p = n.length, b = !1; ++s < p; ) {
          var $ = Qt(n[s]);
          if (!(b = e != null && a(e, $)))
            break;
          e = e[$];
        }
        return b || ++s != p ? b : (p = e == null ? 0 : e.length, !!p && ia(p) && dn($, p) && (he(e) || Wn(e)));
      }
      function b0(e) {
        var n = e.length, a = new e.constructor(n);
        return n && typeof e[0] == "string" && Me.call(e, "index") && (a.index = e.index, a.input = e.input), a;
      }
      function qs(e) {
        return typeof e.constructor == "function" && !jr(e) ? ur(Fi(e)) : {};
      }
      function w0(e, n, a) {
        var s = e.constructor;
        switch (n) {
          case Lr:
            return Rl(e);
          case Cr:
          case Er:
            return new s(+e);
          case Qn:
            return r0(e, a);
          case Na:
          case Ua:
          case za:
          case Wa:
          case Ha:
          case Ga:
          case ja:
          case Ka:
          case qa:
            return Is(e, a);
          case zt:
            return new s();
          case Or:
          case Fr:
            return new s(e);
          case Ir:
            return i0(e);
          case Wt:
            return new s();
          case yi:
            return a0(e);
        }
      }
      function x0(e, n) {
        var a = n.length;
        if (!a)
          return e;
        var s = a - 1;
        return n[s] = (a > 1 ? "& " : "") + n[s], n = n.join(a > 2 ? ", " : " "), e.replace(Sv, `{
/* [wrapped with ` + n + `] */
`);
      }
      function _0(e) {
        return he(e) || Wn(e) || !!(Qu && e && e[Qu]);
      }
      function dn(e, n) {
        var a = typeof e;
        return n = n ?? We, !!n && (a == "number" || a != "symbol" && Rv.test(e)) && e > -1 && e % 1 == 0 && e < n;
      }
      function gt(e, n, a) {
        if (!je(a))
          return !1;
        var s = typeof n;
        return (s == "number" ? xt(a) && dn(n, a.length) : s == "string" && n in a) ? jt(a[n], e) : !1;
      }
      function zl(e, n) {
        if (he(e))
          return !1;
        var a = typeof e;
        return a == "number" || a == "symbol" || a == "boolean" || e == null || Ct(e) ? !0 : bv.test(e) || !yv.test(e) || n != null && e in Be(n);
      }
      function S0(e) {
        var n = typeof e;
        return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
      }
      function Wl(e) {
        var n = Zi(e), a = g[n];
        if (typeof a != "function" || !(n in Se.prototype))
          return !1;
        if (e === a)
          return !0;
        var s = Vl(a);
        return !!s && e === s[0];
      }
      function $0(e) {
        return !!Yu && Yu in e;
      }
      var A0 = Ti ? vn : lo;
      function jr(e) {
        var n = e && e.constructor, a = typeof n == "function" && n.prototype || ar;
        return e === a;
      }
      function Ys(e) {
        return e === e && !je(e);
      }
      function Zs(e, n) {
        return function(a) {
          return a == null ? !1 : a[e] === n && (n !== r || e in Be(a));
        };
      }
      function T0(e) {
        var n = na(e, function(s) {
          return a.size === d && a.clear(), s;
        }), a = n.cache;
        return n;
      }
      function C0(e, n) {
        var a = e[1], s = n[1], p = a | s, b = p < (_ | A | V), $ = s == V && a == E || s == V && a == M && e[7].length <= n[8] || s == (V | M) && n[7].length <= n[8] && a == E;
        if (!(b || $))
          return e;
        s & _ && (e[2] = n[2], p |= a & _ ? 0 : T);
        var C = n[3];
        if (C) {
          var I = e[3];
          e[3] = I ? Ps(I, C, n[4]) : C, e[4] = I ? Sn(e[3], h) : n[4];
        }
        return C = n[5], C && (I = e[5], e[5] = I ? Ls(I, C, n[6]) : C, e[6] = I ? Sn(e[5], h) : n[6]), C = n[7], C && (e[7] = C), s & V && (e[8] = e[8] == null ? n[8] : ft(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = p, e;
      }
      function E0(e) {
        var n = [];
        if (e != null)
          for (var a in Be(e))
            n.push(a);
        return n;
      }
      function O0(e) {
        return Ei.call(e);
      }
      function Js(e, n, a) {
        return n = nt(n === r ? e.length - 1 : n, 0), function() {
          for (var s = arguments, p = -1, b = nt(s.length - n, 0), $ = L(b); ++p < b; )
            $[p] = s[n + p];
          p = -1;
          for (var C = L(n + 1); ++p < n; )
            C[p] = s[p];
          return C[n] = a($), $t(e, this, C);
        };
      }
      function Xs(e, n) {
        return n.length < 2 ? e : Nn(e, Bt(n, 0, -1));
      }
      function I0(e, n) {
        for (var a = e.length, s = ft(n.length, a), p = wt(e); s--; ) {
          var b = n[s];
          e[s] = dn(b, a) ? p[b] : r;
        }
        return e;
      }
      function Hl(e, n) {
        if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
          return e[n];
      }
      var Qs = tf(_s), Kr = Gp || function(e, n) {
        return ot.setTimeout(e, n);
      }, Gl = tf(Qh);
      function ef(e, n, a) {
        var s = n + "";
        return Gl(e, x0(s, F0(y0(s), a)));
      }
      function tf(e) {
        var n = 0, a = 0;
        return function() {
          var s = Yp(), p = ne - (s - a);
          if (a = s, p > 0) {
            if (++n >= ee)
              return arguments[0];
          } else
            n = 0;
          return e.apply(r, arguments);
        };
      }
      function Xi(e, n) {
        var a = -1, s = e.length, p = s - 1;
        for (n = n === r ? s : n; ++a < n; ) {
          var b = Cl(a, p), $ = e[b];
          e[b] = e[a], e[a] = $;
        }
        return e.length = n, e;
      }
      var nf = T0(function(e) {
        var n = [];
        return e.charCodeAt(0) === 46 && n.push(""), e.replace(wv, function(a, s, p, b) {
          n.push(p ? b.replace(Ev, "$1") : s || a);
        }), n;
      });
      function Qt(e) {
        if (typeof e == "string" || Ct(e))
          return e;
        var n = e + "";
        return n == "0" && 1 / e == -ye ? "-0" : n;
      }
      function zn(e) {
        if (e != null) {
          try {
            return Ci.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function F0(e, n) {
        return Lt(Va, function(a) {
          var s = "_." + a[0];
          n & a[1] && !_i(e, s) && e.push(s);
        }), e.sort();
      }
      function rf(e) {
        if (e instanceof Se)
          return e.clone();
        var n = new Dt(e.__wrapped__, e.__chain__);
        return n.__actions__ = wt(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
      }
      function P0(e, n, a) {
        (a ? gt(e, n, a) : n === r) ? n = 1 : n = nt(ge(n), 0);
        var s = e == null ? 0 : e.length;
        if (!s || n < 1)
          return [];
        for (var p = 0, b = 0, $ = L(Ri(s / n)); p < s; )
          $[b++] = Bt(e, p, p += n);
        return $;
      }
      function L0(e) {
        for (var n = -1, a = e == null ? 0 : e.length, s = 0, p = []; ++n < a; ) {
          var b = e[n];
          b && (p[s++] = b);
        }
        return p;
      }
      function R0() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var n = L(e - 1), a = arguments[0], s = e; s--; )
          n[s - 1] = arguments[s];
        return _n(he(a) ? wt(a) : [a], ut(n, 1));
      }
      var D0 = we(function(e, n) {
        return Ye(e) ? Ur(e, ut(n, 1, Ye, !0)) : [];
      }), M0 = we(function(e, n) {
        var a = kt(n);
        return Ye(a) && (a = r), Ye(e) ? Ur(e, ut(n, 1, Ye, !0), ue(a, 2)) : [];
      }), B0 = we(function(e, n) {
        var a = kt(n);
        return Ye(a) && (a = r), Ye(e) ? Ur(e, ut(n, 1, Ye, !0), r, a) : [];
      });
      function k0(e, n, a) {
        var s = e == null ? 0 : e.length;
        return s ? (n = a || n === r ? 1 : ge(n), Bt(e, n < 0 ? 0 : n, s)) : [];
      }
      function V0(e, n, a) {
        var s = e == null ? 0 : e.length;
        return s ? (n = a || n === r ? 1 : ge(n), n = s - n, Bt(e, 0, n < 0 ? 0 : n)) : [];
      }
      function N0(e, n) {
        return e && e.length ? Hi(e, ue(n, 3), !0, !0) : [];
      }
      function U0(e, n) {
        return e && e.length ? Hi(e, ue(n, 3), !0) : [];
      }
      function z0(e, n, a, s) {
        var p = e == null ? 0 : e.length;
        return p ? (a && typeof a != "number" && gt(e, n, a) && (a = 0, s = p), Rh(e, n, a, s)) : [];
      }
      function af(e, n, a) {
        var s = e == null ? 0 : e.length;
        if (!s)
          return -1;
        var p = a == null ? 0 : ge(a);
        return p < 0 && (p = nt(s + p, 0)), Si(e, ue(n, 3), p);
      }
      function lf(e, n, a) {
        var s = e == null ? 0 : e.length;
        if (!s)
          return -1;
        var p = s - 1;
        return a !== r && (p = ge(a), p = a < 0 ? nt(s + p, 0) : ft(p, s - 1)), Si(e, ue(n, 3), p, !0);
      }
      function of(e) {
        var n = e == null ? 0 : e.length;
        return n ? ut(e, 1) : [];
      }
      function W0(e) {
        var n = e == null ? 0 : e.length;
        return n ? ut(e, ye) : [];
      }
      function H0(e, n) {
        var a = e == null ? 0 : e.length;
        return a ? (n = n === r ? 1 : ge(n), ut(e, n)) : [];
      }
      function G0(e) {
        for (var n = -1, a = e == null ? 0 : e.length, s = {}; ++n < a; ) {
          var p = e[n];
          s[p[0]] = p[1];
        }
        return s;
      }
      function uf(e) {
        return e && e.length ? e[0] : r;
      }
      function j0(e, n, a) {
        var s = e == null ? 0 : e.length;
        if (!s)
          return -1;
        var p = a == null ? 0 : ge(a);
        return p < 0 && (p = nt(s + p, 0)), tr(e, n, p);
      }
      function K0(e) {
        var n = e == null ? 0 : e.length;
        return n ? Bt(e, 0, -1) : [];
      }
      var q0 = we(function(e) {
        var n = He(e, Pl);
        return n.length && n[0] === e[0] ? _l(n) : [];
      }), Y0 = we(function(e) {
        var n = kt(e), a = He(e, Pl);
        return n === kt(a) ? n = r : a.pop(), a.length && a[0] === e[0] ? _l(a, ue(n, 2)) : [];
      }), Z0 = we(function(e) {
        var n = kt(e), a = He(e, Pl);
        return n = typeof n == "function" ? n : r, n && a.pop(), a.length && a[0] === e[0] ? _l(a, r, n) : [];
      });
      function J0(e, n) {
        return e == null ? "" : Kp.call(e, n);
      }
      function kt(e) {
        var n = e == null ? 0 : e.length;
        return n ? e[n - 1] : r;
      }
      function X0(e, n, a) {
        var s = e == null ? 0 : e.length;
        if (!s)
          return -1;
        var p = s;
        return a !== r && (p = ge(a), p = p < 0 ? nt(s + p, 0) : ft(p, s - 1)), n === n ? Fp(e, n, p) : Si(e, Uu, p, !0);
      }
      function Q0(e, n) {
        return e && e.length ? ys(e, ge(n)) : r;
      }
      var em = we(sf);
      function sf(e, n) {
        return e && e.length && n && n.length ? Tl(e, n) : e;
      }
      function tm(e, n, a) {
        return e && e.length && n && n.length ? Tl(e, n, ue(a, 2)) : e;
      }
      function nm(e, n, a) {
        return e && e.length && n && n.length ? Tl(e, n, r, a) : e;
      }
      var rm = cn(function(e, n) {
        var a = e == null ? 0 : e.length, s = yl(e, n);
        return xs(e, He(n, function(p) {
          return dn(p, a) ? +p : p;
        }).sort(Fs)), s;
      });
      function im(e, n) {
        var a = [];
        if (!(e && e.length))
          return a;
        var s = -1, p = [], b = e.length;
        for (n = ue(n, 3); ++s < b; ) {
          var $ = e[s];
          n($, s, e) && (a.push($), p.push(s));
        }
        return xs(e, p), a;
      }
      function jl(e) {
        return e == null ? e : Jp.call(e);
      }
      function am(e, n, a) {
        var s = e == null ? 0 : e.length;
        return s ? (a && typeof a != "number" && gt(e, n, a) ? (n = 0, a = s) : (n = n == null ? 0 : ge(n), a = a === r ? s : ge(a)), Bt(e, n, a)) : [];
      }
      function lm(e, n) {
        return Wi(e, n);
      }
      function om(e, n, a) {
        return Ol(e, n, ue(a, 2));
      }
      function um(e, n) {
        var a = e == null ? 0 : e.length;
        if (a) {
          var s = Wi(e, n);
          if (s < a && jt(e[s], n))
            return s;
        }
        return -1;
      }
      function sm(e, n) {
        return Wi(e, n, !0);
      }
      function fm(e, n, a) {
        return Ol(e, n, ue(a, 2), !0);
      }
      function cm(e, n) {
        var a = e == null ? 0 : e.length;
        if (a) {
          var s = Wi(e, n, !0) - 1;
          if (jt(e[s], n))
            return s;
        }
        return -1;
      }
      function dm(e) {
        return e && e.length ? Ss(e) : [];
      }
      function vm(e, n) {
        return e && e.length ? Ss(e, ue(n, 2)) : [];
      }
      function pm(e) {
        var n = e == null ? 0 : e.length;
        return n ? Bt(e, 1, n) : [];
      }
      function hm(e, n, a) {
        return e && e.length ? (n = a || n === r ? 1 : ge(n), Bt(e, 0, n < 0 ? 0 : n)) : [];
      }
      function mm(e, n, a) {
        var s = e == null ? 0 : e.length;
        return s ? (n = a || n === r ? 1 : ge(n), n = s - n, Bt(e, n < 0 ? 0 : n, s)) : [];
      }
      function gm(e, n) {
        return e && e.length ? Hi(e, ue(n, 3), !1, !0) : [];
      }
      function ym(e, n) {
        return e && e.length ? Hi(e, ue(n, 3)) : [];
      }
      var bm = we(function(e) {
        return Tn(ut(e, 1, Ye, !0));
      }), wm = we(function(e) {
        var n = kt(e);
        return Ye(n) && (n = r), Tn(ut(e, 1, Ye, !0), ue(n, 2));
      }), xm = we(function(e) {
        var n = kt(e);
        return n = typeof n == "function" ? n : r, Tn(ut(e, 1, Ye, !0), r, n);
      });
      function _m(e) {
        return e && e.length ? Tn(e) : [];
      }
      function Sm(e, n) {
        return e && e.length ? Tn(e, ue(n, 2)) : [];
      }
      function $m(e, n) {
        return n = typeof n == "function" ? n : r, e && e.length ? Tn(e, r, n) : [];
      }
      function Kl(e) {
        if (!(e && e.length))
          return [];
        var n = 0;
        return e = xn(e, function(a) {
          if (Ye(a))
            return n = nt(a.length, n), !0;
        }), fl(n, function(a) {
          return He(e, ol(a));
        });
      }
      function ff(e, n) {
        if (!(e && e.length))
          return [];
        var a = Kl(e);
        return n == null ? a : He(a, function(s) {
          return $t(n, r, s);
        });
      }
      var Am = we(function(e, n) {
        return Ye(e) ? Ur(e, n) : [];
      }), Tm = we(function(e) {
        return Fl(xn(e, Ye));
      }), Cm = we(function(e) {
        var n = kt(e);
        return Ye(n) && (n = r), Fl(xn(e, Ye), ue(n, 2));
      }), Em = we(function(e) {
        var n = kt(e);
        return n = typeof n == "function" ? n : r, Fl(xn(e, Ye), r, n);
      }), Om = we(Kl);
      function Im(e, n) {
        return Cs(e || [], n || [], Nr);
      }
      function Fm(e, n) {
        return Cs(e || [], n || [], Hr);
      }
      var Pm = we(function(e) {
        var n = e.length, a = n > 1 ? e[n - 1] : r;
        return a = typeof a == "function" ? (e.pop(), a) : r, ff(e, a);
      });
      function cf(e) {
        var n = g(e);
        return n.__chain__ = !0, n;
      }
      function Lm(e, n) {
        return n(e), e;
      }
      function Qi(e, n) {
        return n(e);
      }
      var Rm = cn(function(e) {
        var n = e.length, a = n ? e[0] : 0, s = this.__wrapped__, p = function(b) {
          return yl(b, e);
        };
        return n > 1 || this.__actions__.length || !(s instanceof Se) || !dn(a) ? this.thru(p) : (s = s.slice(a, +a + (n ? 1 : 0)), s.__actions__.push({
          func: Qi,
          args: [p],
          thisArg: r
        }), new Dt(s, this.__chain__).thru(function(b) {
          return n && !b.length && b.push(r), b;
        }));
      });
      function Dm() {
        return cf(this);
      }
      function Mm() {
        return new Dt(this.value(), this.__chain__);
      }
      function Bm() {
        this.__values__ === r && (this.__values__ = Af(this.value()));
        var e = this.__index__ >= this.__values__.length, n = e ? r : this.__values__[this.__index__++];
        return { done: e, value: n };
      }
      function km() {
        return this;
      }
      function Vm(e) {
        for (var n, a = this; a instanceof ki; ) {
          var s = rf(a);
          s.__index__ = 0, s.__values__ = r, n ? p.__wrapped__ = s : n = s;
          var p = s;
          a = a.__wrapped__;
        }
        return p.__wrapped__ = e, n;
      }
      function Nm() {
        var e = this.__wrapped__;
        if (e instanceof Se) {
          var n = e;
          return this.__actions__.length && (n = new Se(this)), n = n.reverse(), n.__actions__.push({
            func: Qi,
            args: [jl],
            thisArg: r
          }), new Dt(n, this.__chain__);
        }
        return this.thru(jl);
      }
      function Um() {
        return Ts(this.__wrapped__, this.__actions__);
      }
      var zm = Gi(function(e, n, a) {
        Me.call(e, a) ? ++e[a] : sn(e, a, 1);
      });
      function Wm(e, n, a) {
        var s = he(e) ? Vu : Lh;
        return a && gt(e, n, a) && (n = r), s(e, ue(n, 3));
      }
      function Hm(e, n) {
        var a = he(e) ? xn : ss;
        return a(e, ue(n, 3));
      }
      var Gm = Bs(af), jm = Bs(lf);
      function Km(e, n) {
        return ut(ea(e, n), 1);
      }
      function qm(e, n) {
        return ut(ea(e, n), ye);
      }
      function Ym(e, n, a) {
        return a = a === r ? 1 : ge(a), ut(ea(e, n), a);
      }
      function df(e, n) {
        var a = he(e) ? Lt : An;
        return a(e, ue(n, 3));
      }
      function vf(e, n) {
        var a = he(e) ? pp : us;
        return a(e, ue(n, 3));
      }
      var Zm = Gi(function(e, n, a) {
        Me.call(e, a) ? e[a].push(n) : sn(e, a, [n]);
      });
      function Jm(e, n, a, s) {
        e = xt(e) ? e : vr(e), a = a && !s ? ge(a) : 0;
        var p = e.length;
        return a < 0 && (a = nt(p + a, 0)), aa(e) ? a <= p && e.indexOf(n, a) > -1 : !!p && tr(e, n, a) > -1;
      }
      var Xm = we(function(e, n, a) {
        var s = -1, p = typeof n == "function", b = xt(e) ? L(e.length) : [];
        return An(e, function($) {
          b[++s] = p ? $t(n, $, a) : zr($, n, a);
        }), b;
      }), Qm = Gi(function(e, n, a) {
        sn(e, a, n);
      });
      function ea(e, n) {
        var a = he(e) ? He : hs;
        return a(e, ue(n, 3));
      }
      function eg(e, n, a, s) {
        return e == null ? [] : (he(n) || (n = n == null ? [] : [n]), a = s ? r : a, he(a) || (a = a == null ? [] : [a]), bs(e, n, a));
      }
      var tg = Gi(function(e, n, a) {
        e[a ? 0 : 1].push(n);
      }, function() {
        return [[], []];
      });
      function ng(e, n, a) {
        var s = he(e) ? al : Wu, p = arguments.length < 3;
        return s(e, ue(n, 4), a, p, An);
      }
      function rg(e, n, a) {
        var s = he(e) ? hp : Wu, p = arguments.length < 3;
        return s(e, ue(n, 4), a, p, us);
      }
      function ig(e, n) {
        var a = he(e) ? xn : ss;
        return a(e, ra(ue(n, 3)));
      }
      function ag(e) {
        var n = he(e) ? is : Jh;
        return n(e);
      }
      function lg(e, n, a) {
        (a ? gt(e, n, a) : n === r) ? n = 1 : n = ge(n);
        var s = he(e) ? Eh : Xh;
        return s(e, n);
      }
      function og(e) {
        var n = he(e) ? Oh : e0;
        return n(e);
      }
      function ug(e) {
        if (e == null)
          return 0;
        if (xt(e))
          return aa(e) ? rr(e) : e.length;
        var n = ct(e);
        return n == zt || n == Wt ? e.size : $l(e).length;
      }
      function sg(e, n, a) {
        var s = he(e) ? ll : t0;
        return a && gt(e, n, a) && (n = r), s(e, ue(n, 3));
      }
      var fg = we(function(e, n) {
        if (e == null)
          return [];
        var a = n.length;
        return a > 1 && gt(e, n[0], n[1]) ? n = [] : a > 2 && gt(n[0], n[1], n[2]) && (n = [n[0]]), bs(e, ut(n, 1), []);
      }), ta = Hp || function() {
        return ot.Date.now();
      };
      function cg(e, n) {
        if (typeof n != "function")
          throw new Rt(f);
        return e = ge(e), function() {
          if (--e < 1)
            return n.apply(this, arguments);
        };
      }
      function pf(e, n, a) {
        return n = a ? r : n, n = e && n == null ? e.length : n, fn(e, V, r, r, r, r, n);
      }
      function hf(e, n) {
        var a;
        if (typeof n != "function")
          throw new Rt(f);
        return e = ge(e), function() {
          return --e > 0 && (a = n.apply(this, arguments)), e <= 1 && (n = r), a;
        };
      }
      var ql = we(function(e, n, a) {
        var s = _;
        if (a.length) {
          var p = Sn(a, cr(ql));
          s |= P;
        }
        return fn(e, s, n, a, p);
      }), mf = we(function(e, n, a) {
        var s = _ | A;
        if (a.length) {
          var p = Sn(a, cr(mf));
          s |= P;
        }
        return fn(n, s, e, a, p);
      });
      function gf(e, n, a) {
        n = a ? r : n;
        var s = fn(e, E, r, r, r, r, r, n);
        return s.placeholder = gf.placeholder, s;
      }
      function yf(e, n, a) {
        n = a ? r : n;
        var s = fn(e, F, r, r, r, r, r, n);
        return s.placeholder = yf.placeholder, s;
      }
      function bf(e, n, a) {
        var s, p, b, $, C, I, B = 0, N = !1, G = !1, Z = !0;
        if (typeof e != "function")
          throw new Rt(f);
        n = Vt(n) || 0, je(a) && (N = !!a.leading, G = "maxWait" in a, b = G ? nt(Vt(a.maxWait) || 0, n) : b, Z = "trailing" in a ? !!a.trailing : Z);
        function ie(Ze) {
          var Kt = s, hn = p;
          return s = p = r, B = Ze, $ = e.apply(hn, Kt), $;
        }
        function fe(Ze) {
          return B = Ze, C = Kr(_e, n), N ? ie(Ze) : $;
        }
        function be(Ze) {
          var Kt = Ze - I, hn = Ze - B, kf = n - Kt;
          return G ? ft(kf, b - hn) : kf;
        }
        function ce(Ze) {
          var Kt = Ze - I, hn = Ze - B;
          return I === r || Kt >= n || Kt < 0 || G && hn >= b;
        }
        function _e() {
          var Ze = ta();
          if (ce(Ze))
            return Ae(Ze);
          C = Kr(_e, be(Ze));
        }
        function Ae(Ze) {
          return C = r, Z && s ? ie(Ze) : (s = p = r, $);
        }
        function Et() {
          C !== r && Es(C), B = 0, s = I = p = C = r;
        }
        function yt() {
          return C === r ? $ : Ae(ta());
        }
        function Ot() {
          var Ze = ta(), Kt = ce(Ze);
          if (s = arguments, p = this, I = Ze, Kt) {
            if (C === r)
              return fe(I);
            if (G)
              return Es(C), C = Kr(_e, n), ie(I);
          }
          return C === r && (C = Kr(_e, n)), $;
        }
        return Ot.cancel = Et, Ot.flush = yt, Ot;
      }
      var dg = we(function(e, n) {
        return os(e, 1, n);
      }), vg = we(function(e, n, a) {
        return os(e, Vt(n) || 0, a);
      });
      function pg(e) {
        return fn(e, H);
      }
      function na(e, n) {
        if (typeof e != "function" || n != null && typeof n != "function")
          throw new Rt(f);
        var a = function() {
          var s = arguments, p = n ? n.apply(this, s) : s[0], b = a.cache;
          if (b.has(p))
            return b.get(p);
          var $ = e.apply(this, s);
          return a.cache = b.set(p, $) || b, $;
        };
        return a.cache = new (na.Cache || un)(), a;
      }
      na.Cache = un;
      function ra(e) {
        if (typeof e != "function")
          throw new Rt(f);
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, n[0]);
            case 2:
              return !e.call(this, n[0], n[1]);
            case 3:
              return !e.call(this, n[0], n[1], n[2]);
          }
          return !e.apply(this, n);
        };
      }
      function hg(e) {
        return hf(2, e);
      }
      var mg = n0(function(e, n) {
        n = n.length == 1 && he(n[0]) ? He(n[0], At(ue())) : He(ut(n, 1), At(ue()));
        var a = n.length;
        return we(function(s) {
          for (var p = -1, b = ft(s.length, a); ++p < b; )
            s[p] = n[p].call(this, s[p]);
          return $t(e, this, s);
        });
      }), Yl = we(function(e, n) {
        var a = Sn(n, cr(Yl));
        return fn(e, P, r, n, a);
      }), wf = we(function(e, n) {
        var a = Sn(n, cr(wf));
        return fn(e, R, r, n, a);
      }), gg = cn(function(e, n) {
        return fn(e, M, r, r, r, n);
      });
      function yg(e, n) {
        if (typeof e != "function")
          throw new Rt(f);
        return n = n === r ? n : ge(n), we(e, n);
      }
      function bg(e, n) {
        if (typeof e != "function")
          throw new Rt(f);
        return n = n == null ? 0 : nt(ge(n), 0), we(function(a) {
          var s = a[n], p = En(a, 0, n);
          return s && _n(p, s), $t(e, this, p);
        });
      }
      function wg(e, n, a) {
        var s = !0, p = !0;
        if (typeof e != "function")
          throw new Rt(f);
        return je(a) && (s = "leading" in a ? !!a.leading : s, p = "trailing" in a ? !!a.trailing : p), bf(e, n, {
          leading: s,
          maxWait: n,
          trailing: p
        });
      }
      function xg(e) {
        return pf(e, 1);
      }
      function _g(e, n) {
        return Yl(Ll(n), e);
      }
      function Sg() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return he(e) ? e : [e];
      }
      function $g(e) {
        return Mt(e, w);
      }
      function Ag(e, n) {
        return n = typeof n == "function" ? n : r, Mt(e, w, n);
      }
      function Tg(e) {
        return Mt(e, m | w);
      }
      function Cg(e, n) {
        return n = typeof n == "function" ? n : r, Mt(e, m | w, n);
      }
      function Eg(e, n) {
        return n == null || ls(e, n, it(n));
      }
      function jt(e, n) {
        return e === n || e !== e && n !== n;
      }
      var Og = Yi(xl), Ig = Yi(function(e, n) {
        return e >= n;
      }), Wn = ds(function() {
        return arguments;
      }()) ? ds : function(e) {
        return Ke(e) && Me.call(e, "callee") && !Xu.call(e, "callee");
      }, he = L.isArray, Fg = Lu ? At(Lu) : Vh;
      function xt(e) {
        return e != null && ia(e.length) && !vn(e);
      }
      function Ye(e) {
        return Ke(e) && xt(e);
      }
      function Pg(e) {
        return e === !0 || e === !1 || Ke(e) && mt(e) == Cr;
      }
      var On = jp || lo, Lg = Ru ? At(Ru) : Nh;
      function Rg(e) {
        return Ke(e) && e.nodeType === 1 && !qr(e);
      }
      function Dg(e) {
        if (e == null)
          return !0;
        if (xt(e) && (he(e) || typeof e == "string" || typeof e.splice == "function" || On(e) || dr(e) || Wn(e)))
          return !e.length;
        var n = ct(e);
        if (n == zt || n == Wt)
          return !e.size;
        if (jr(e))
          return !$l(e).length;
        for (var a in e)
          if (Me.call(e, a))
            return !1;
        return !0;
      }
      function Mg(e, n) {
        return Wr(e, n);
      }
      function Bg(e, n, a) {
        a = typeof a == "function" ? a : r;
        var s = a ? a(e, n) : r;
        return s === r ? Wr(e, n, r, a) : !!s;
      }
      function Zl(e) {
        if (!Ke(e))
          return !1;
        var n = mt(e);
        return n == mi || n == lv || typeof e.message == "string" && typeof e.name == "string" && !qr(e);
      }
      function kg(e) {
        return typeof e == "number" && es(e);
      }
      function vn(e) {
        if (!je(e))
          return !1;
        var n = mt(e);
        return n == gi || n == ou || n == av || n == uv;
      }
      function xf(e) {
        return typeof e == "number" && e == ge(e);
      }
      function ia(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= We;
      }
      function je(e) {
        var n = typeof e;
        return e != null && (n == "object" || n == "function");
      }
      function Ke(e) {
        return e != null && typeof e == "object";
      }
      var _f = Du ? At(Du) : zh;
      function Vg(e, n) {
        return e === n || Sl(e, n, Nl(n));
      }
      function Ng(e, n, a) {
        return a = typeof a == "function" ? a : r, Sl(e, n, Nl(n), a);
      }
      function Ug(e) {
        return Sf(e) && e != +e;
      }
      function zg(e) {
        if (A0(e))
          throw new pe(o);
        return vs(e);
      }
      function Wg(e) {
        return e === null;
      }
      function Hg(e) {
        return e == null;
      }
      function Sf(e) {
        return typeof e == "number" || Ke(e) && mt(e) == Or;
      }
      function qr(e) {
        if (!Ke(e) || mt(e) != ln)
          return !1;
        var n = Fi(e);
        if (n === null)
          return !0;
        var a = Me.call(n, "constructor") && n.constructor;
        return typeof a == "function" && a instanceof a && Ci.call(a) == Np;
      }
      var Jl = Mu ? At(Mu) : Wh;
      function Gg(e) {
        return xf(e) && e >= -We && e <= We;
      }
      var $f = Bu ? At(Bu) : Hh;
      function aa(e) {
        return typeof e == "string" || !he(e) && Ke(e) && mt(e) == Fr;
      }
      function Ct(e) {
        return typeof e == "symbol" || Ke(e) && mt(e) == yi;
      }
      var dr = ku ? At(ku) : Gh;
      function jg(e) {
        return e === r;
      }
      function Kg(e) {
        return Ke(e) && ct(e) == Pr;
      }
      function qg(e) {
        return Ke(e) && mt(e) == fv;
      }
      var Yg = Yi(Al), Zg = Yi(function(e, n) {
        return e <= n;
      });
      function Af(e) {
        if (!e)
          return [];
        if (xt(e))
          return aa(e) ? Ht(e) : wt(e);
        if (Dr && e[Dr])
          return Ep(e[Dr]());
        var n = ct(e), a = n == zt ? dl : n == Wt ? $i : vr;
        return a(e);
      }
      function pn(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = Vt(e), e === ye || e === -ye) {
          var n = e < 0 ? -1 : 1;
          return n * qe;
        }
        return e === e ? e : 0;
      }
      function ge(e) {
        var n = pn(e), a = n % 1;
        return n === n ? a ? n - a : n : 0;
      }
      function Tf(e) {
        return e ? Vn(ge(e), 0, bt) : 0;
      }
      function Vt(e) {
        if (typeof e == "number")
          return e;
        if (Ct(e))
          return wn;
        if (je(e)) {
          var n = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = je(n) ? n + "" : n;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = Hu(e);
        var a = Fv.test(e);
        return a || Lv.test(e) ? cp(e.slice(2), a ? 2 : 8) : Iv.test(e) ? wn : +e;
      }
      function Cf(e) {
        return Xt(e, _t(e));
      }
      function Jg(e) {
        return e ? Vn(ge(e), -We, We) : e === 0 ? e : 0;
      }
      function Re(e) {
        return e == null ? "" : Tt(e);
      }
      var Xg = sr(function(e, n) {
        if (jr(n) || xt(n)) {
          Xt(n, it(n), e);
          return;
        }
        for (var a in n)
          Me.call(n, a) && Nr(e, a, n[a]);
      }), Ef = sr(function(e, n) {
        Xt(n, _t(n), e);
      }), la = sr(function(e, n, a, s) {
        Xt(n, _t(n), e, s);
      }), Qg = sr(function(e, n, a, s) {
        Xt(n, it(n), e, s);
      }), e1 = cn(yl);
      function t1(e, n) {
        var a = ur(e);
        return n == null ? a : as(a, n);
      }
      var n1 = we(function(e, n) {
        e = Be(e);
        var a = -1, s = n.length, p = s > 2 ? n[2] : r;
        for (p && gt(n[0], n[1], p) && (s = 1); ++a < s; )
          for (var b = n[a], $ = _t(b), C = -1, I = $.length; ++C < I; ) {
            var B = $[C], N = e[B];
            (N === r || jt(N, ar[B]) && !Me.call(e, B)) && (e[B] = b[B]);
          }
        return e;
      }), r1 = we(function(e) {
        return e.push(r, Hs), $t(Of, r, e);
      });
      function i1(e, n) {
        return Nu(e, ue(n, 3), Jt);
      }
      function a1(e, n) {
        return Nu(e, ue(n, 3), wl);
      }
      function l1(e, n) {
        return e == null ? e : bl(e, ue(n, 3), _t);
      }
      function o1(e, n) {
        return e == null ? e : fs(e, ue(n, 3), _t);
      }
      function u1(e, n) {
        return e && Jt(e, ue(n, 3));
      }
      function s1(e, n) {
        return e && wl(e, ue(n, 3));
      }
      function f1(e) {
        return e == null ? [] : Ui(e, it(e));
      }
      function c1(e) {
        return e == null ? [] : Ui(e, _t(e));
      }
      function Xl(e, n, a) {
        var s = e == null ? r : Nn(e, n);
        return s === r ? a : s;
      }
      function d1(e, n) {
        return e != null && Ks(e, n, Dh);
      }
      function Ql(e, n) {
        return e != null && Ks(e, n, Mh);
      }
      var v1 = Vs(function(e, n, a) {
        n != null && typeof n.toString != "function" && (n = Ei.call(n)), e[n] = a;
      }, to(St)), p1 = Vs(function(e, n, a) {
        n != null && typeof n.toString != "function" && (n = Ei.call(n)), Me.call(e, n) ? e[n].push(a) : e[n] = [a];
      }, ue), h1 = we(zr);
      function it(e) {
        return xt(e) ? rs(e) : $l(e);
      }
      function _t(e) {
        return xt(e) ? rs(e, !0) : jh(e);
      }
      function m1(e, n) {
        var a = {};
        return n = ue(n, 3), Jt(e, function(s, p, b) {
          sn(a, n(s, p, b), s);
        }), a;
      }
      function g1(e, n) {
        var a = {};
        return n = ue(n, 3), Jt(e, function(s, p, b) {
          sn(a, p, n(s, p, b));
        }), a;
      }
      var y1 = sr(function(e, n, a) {
        zi(e, n, a);
      }), Of = sr(function(e, n, a, s) {
        zi(e, n, a, s);
      }), b1 = cn(function(e, n) {
        var a = {};
        if (e == null)
          return a;
        var s = !1;
        n = He(n, function(b) {
          return b = Cn(b, e), s || (s = b.length > 1), b;
        }), Xt(e, kl(e), a), s && (a = Mt(a, m | y | w, v0));
        for (var p = n.length; p--; )
          Il(a, n[p]);
        return a;
      });
      function w1(e, n) {
        return If(e, ra(ue(n)));
      }
      var x1 = cn(function(e, n) {
        return e == null ? {} : qh(e, n);
      });
      function If(e, n) {
        if (e == null)
          return {};
        var a = He(kl(e), function(s) {
          return [s];
        });
        return n = ue(n), ws(e, a, function(s, p) {
          return n(s, p[0]);
        });
      }
      function _1(e, n, a) {
        n = Cn(n, e);
        var s = -1, p = n.length;
        for (p || (p = 1, e = r); ++s < p; ) {
          var b = e == null ? r : e[Qt(n[s])];
          b === r && (s = p, b = a), e = vn(b) ? b.call(e) : b;
        }
        return e;
      }
      function S1(e, n, a) {
        return e == null ? e : Hr(e, n, a);
      }
      function $1(e, n, a, s) {
        return s = typeof s == "function" ? s : r, e == null ? e : Hr(e, n, a, s);
      }
      var Ff = zs(it), Pf = zs(_t);
      function A1(e, n, a) {
        var s = he(e), p = s || On(e) || dr(e);
        if (n = ue(n, 4), a == null) {
          var b = e && e.constructor;
          p ? a = s ? new b() : [] : je(e) ? a = vn(b) ? ur(Fi(e)) : {} : a = {};
        }
        return (p ? Lt : Jt)(e, function($, C, I) {
          return n(a, $, C, I);
        }), a;
      }
      function T1(e, n) {
        return e == null ? !0 : Il(e, n);
      }
      function C1(e, n, a) {
        return e == null ? e : As(e, n, Ll(a));
      }
      function E1(e, n, a, s) {
        return s = typeof s == "function" ? s : r, e == null ? e : As(e, n, Ll(a), s);
      }
      function vr(e) {
        return e == null ? [] : cl(e, it(e));
      }
      function O1(e) {
        return e == null ? [] : cl(e, _t(e));
      }
      function I1(e, n, a) {
        return a === r && (a = n, n = r), a !== r && (a = Vt(a), a = a === a ? a : 0), n !== r && (n = Vt(n), n = n === n ? n : 0), Vn(Vt(e), n, a);
      }
      function F1(e, n, a) {
        return n = pn(n), a === r ? (a = n, n = 0) : a = pn(a), e = Vt(e), Bh(e, n, a);
      }
      function P1(e, n, a) {
        if (a && typeof a != "boolean" && gt(e, n, a) && (n = a = r), a === r && (typeof n == "boolean" ? (a = n, n = r) : typeof e == "boolean" && (a = e, e = r)), e === r && n === r ? (e = 0, n = 1) : (e = pn(e), n === r ? (n = e, e = 0) : n = pn(n)), e > n) {
          var s = e;
          e = n, n = s;
        }
        if (a || e % 1 || n % 1) {
          var p = ts();
          return ft(e + p * (n - e + fp("1e-" + ((p + "").length - 1))), n);
        }
        return Cl(e, n);
      }
      var L1 = fr(function(e, n, a) {
        return n = n.toLowerCase(), e + (a ? Lf(n) : n);
      });
      function Lf(e) {
        return eo(Re(e).toLowerCase());
      }
      function Rf(e) {
        return e = Re(e), e && e.replace(Dv, Sp).replace(ep, "");
      }
      function R1(e, n, a) {
        e = Re(e), n = Tt(n);
        var s = e.length;
        a = a === r ? s : Vn(ge(a), 0, s);
        var p = a;
        return a -= n.length, a >= 0 && e.slice(a, p) == n;
      }
      function D1(e) {
        return e = Re(e), e && hv.test(e) ? e.replace(fu, $p) : e;
      }
      function M1(e) {
        return e = Re(e), e && xv.test(e) ? e.replace(Ya, "\\$&") : e;
      }
      var B1 = fr(function(e, n, a) {
        return e + (a ? "-" : "") + n.toLowerCase();
      }), k1 = fr(function(e, n, a) {
        return e + (a ? " " : "") + n.toLowerCase();
      }), V1 = Ms("toLowerCase");
      function N1(e, n, a) {
        e = Re(e), n = ge(n);
        var s = n ? rr(e) : 0;
        if (!n || s >= n)
          return e;
        var p = (n - s) / 2;
        return qi(Di(p), a) + e + qi(Ri(p), a);
      }
      function U1(e, n, a) {
        e = Re(e), n = ge(n);
        var s = n ? rr(e) : 0;
        return n && s < n ? e + qi(n - s, a) : e;
      }
      function z1(e, n, a) {
        e = Re(e), n = ge(n);
        var s = n ? rr(e) : 0;
        return n && s < n ? qi(n - s, a) + e : e;
      }
      function W1(e, n, a) {
        return a || n == null ? n = 0 : n && (n = +n), Zp(Re(e).replace(Za, ""), n || 0);
      }
      function H1(e, n, a) {
        return (a ? gt(e, n, a) : n === r) ? n = 1 : n = ge(n), El(Re(e), n);
      }
      function G1() {
        var e = arguments, n = Re(e[0]);
        return e.length < 3 ? n : n.replace(e[1], e[2]);
      }
      var j1 = fr(function(e, n, a) {
        return e + (a ? "_" : "") + n.toLowerCase();
      });
      function K1(e, n, a) {
        return a && typeof a != "number" && gt(e, n, a) && (n = a = r), a = a === r ? bt : a >>> 0, a ? (e = Re(e), e && (typeof n == "string" || n != null && !Jl(n)) && (n = Tt(n), !n && nr(e)) ? En(Ht(e), 0, a) : e.split(n, a)) : [];
      }
      var q1 = fr(function(e, n, a) {
        return e + (a ? " " : "") + eo(n);
      });
      function Y1(e, n, a) {
        return e = Re(e), a = a == null ? 0 : Vn(ge(a), 0, e.length), n = Tt(n), e.slice(a, a + n.length) == n;
      }
      function Z1(e, n, a) {
        var s = g.templateSettings;
        a && gt(e, n, a) && (n = r), e = Re(e), n = la({}, n, s, Ws);
        var p = la({}, n.imports, s.imports, Ws), b = it(p), $ = cl(p, b), C, I, B = 0, N = n.interpolate || bi, G = "__p += '", Z = vl(
          (n.escape || bi).source + "|" + N.source + "|" + (N === cu ? Ov : bi).source + "|" + (n.evaluate || bi).source + "|$",
          "g"
        ), ie = "//# sourceURL=" + (Me.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ap + "]") + `
`;
        e.replace(Z, function(ce, _e, Ae, Et, yt, Ot) {
          return Ae || (Ae = Et), G += e.slice(B, Ot).replace(Mv, Ap), _e && (C = !0, G += `' +
__e(` + _e + `) +
'`), yt && (I = !0, G += `';
` + yt + `;
__p += '`), Ae && (G += `' +
((__t = (` + Ae + `)) == null ? '' : __t) +
'`), B = Ot + ce.length, ce;
        }), G += `';
`;
        var fe = Me.call(n, "variable") && n.variable;
        if (!fe)
          G = `with (obj) {
` + G + `
}
`;
        else if (Cv.test(fe))
          throw new pe(c);
        G = (I ? G.replace(cv, "") : G).replace(dv, "$1").replace(vv, "$1;"), G = "function(" + (fe || "obj") + `) {
` + (fe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (C ? ", __e = _.escape" : "") + (I ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + G + `return __p
}`;
        var be = Mf(function() {
          return Pe(b, ie + "return " + G).apply(r, $);
        });
        if (be.source = G, Zl(be))
          throw be;
        return be;
      }
      function J1(e) {
        return Re(e).toLowerCase();
      }
      function X1(e) {
        return Re(e).toUpperCase();
      }
      function Q1(e, n, a) {
        if (e = Re(e), e && (a || n === r))
          return Hu(e);
        if (!e || !(n = Tt(n)))
          return e;
        var s = Ht(e), p = Ht(n), b = Gu(s, p), $ = ju(s, p) + 1;
        return En(s, b, $).join("");
      }
      function ey(e, n, a) {
        if (e = Re(e), e && (a || n === r))
          return e.slice(0, qu(e) + 1);
        if (!e || !(n = Tt(n)))
          return e;
        var s = Ht(e), p = ju(s, Ht(n)) + 1;
        return En(s, 0, p).join("");
      }
      function ty(e, n, a) {
        if (e = Re(e), e && (a || n === r))
          return e.replace(Za, "");
        if (!e || !(n = Tt(n)))
          return e;
        var s = Ht(e), p = Gu(s, Ht(n));
        return En(s, p).join("");
      }
      function ny(e, n) {
        var a = K, s = Y;
        if (je(n)) {
          var p = "separator" in n ? n.separator : p;
          a = "length" in n ? ge(n.length) : a, s = "omission" in n ? Tt(n.omission) : s;
        }
        e = Re(e);
        var b = e.length;
        if (nr(e)) {
          var $ = Ht(e);
          b = $.length;
        }
        if (a >= b)
          return e;
        var C = a - rr(s);
        if (C < 1)
          return s;
        var I = $ ? En($, 0, C).join("") : e.slice(0, C);
        if (p === r)
          return I + s;
        if ($ && (C += I.length - C), Jl(p)) {
          if (e.slice(C).search(p)) {
            var B, N = I;
            for (p.global || (p = vl(p.source, Re(du.exec(p)) + "g")), p.lastIndex = 0; B = p.exec(N); )
              var G = B.index;
            I = I.slice(0, G === r ? C : G);
          }
        } else if (e.indexOf(Tt(p), C) != C) {
          var Z = I.lastIndexOf(p);
          Z > -1 && (I = I.slice(0, Z));
        }
        return I + s;
      }
      function ry(e) {
        return e = Re(e), e && pv.test(e) ? e.replace(su, Pp) : e;
      }
      var iy = fr(function(e, n, a) {
        return e + (a ? " " : "") + n.toUpperCase();
      }), eo = Ms("toUpperCase");
      function Df(e, n, a) {
        return e = Re(e), n = a ? r : n, n === r ? Cp(e) ? Dp(e) : yp(e) : e.match(n) || [];
      }
      var Mf = we(function(e, n) {
        try {
          return $t(e, r, n);
        } catch (a) {
          return Zl(a) ? a : new pe(a);
        }
      }), ay = cn(function(e, n) {
        return Lt(n, function(a) {
          a = Qt(a), sn(e, a, ql(e[a], e));
        }), e;
      });
      function ly(e) {
        var n = e == null ? 0 : e.length, a = ue();
        return e = n ? He(e, function(s) {
          if (typeof s[1] != "function")
            throw new Rt(f);
          return [a(s[0]), s[1]];
        }) : [], we(function(s) {
          for (var p = -1; ++p < n; ) {
            var b = e[p];
            if ($t(b[0], this, s))
              return $t(b[1], this, s);
          }
        });
      }
      function oy(e) {
        return Ph(Mt(e, m));
      }
      function to(e) {
        return function() {
          return e;
        };
      }
      function uy(e, n) {
        return e == null || e !== e ? n : e;
      }
      var sy = ks(), fy = ks(!0);
      function St(e) {
        return e;
      }
      function no(e) {
        return ps(typeof e == "function" ? e : Mt(e, m));
      }
      function cy(e) {
        return ms(Mt(e, m));
      }
      function dy(e, n) {
        return gs(e, Mt(n, m));
      }
      var vy = we(function(e, n) {
        return function(a) {
          return zr(a, e, n);
        };
      }), py = we(function(e, n) {
        return function(a) {
          return zr(e, a, n);
        };
      });
      function ro(e, n, a) {
        var s = it(n), p = Ui(n, s);
        a == null && !(je(n) && (p.length || !s.length)) && (a = n, n = e, e = this, p = Ui(n, it(n)));
        var b = !(je(a) && "chain" in a) || !!a.chain, $ = vn(e);
        return Lt(p, function(C) {
          var I = n[C];
          e[C] = I, $ && (e.prototype[C] = function() {
            var B = this.__chain__;
            if (b || B) {
              var N = e(this.__wrapped__), G = N.__actions__ = wt(this.__actions__);
              return G.push({ func: I, args: arguments, thisArg: e }), N.__chain__ = B, N;
            }
            return I.apply(e, _n([this.value()], arguments));
          });
        }), e;
      }
      function hy() {
        return ot._ === this && (ot._ = Up), this;
      }
      function io() {
      }
      function my(e) {
        return e = ge(e), we(function(n) {
          return ys(n, e);
        });
      }
      var gy = Dl(He), yy = Dl(Vu), by = Dl(ll);
      function Bf(e) {
        return zl(e) ? ol(Qt(e)) : Yh(e);
      }
      function wy(e) {
        return function(n) {
          return e == null ? r : Nn(e, n);
        };
      }
      var xy = Ns(), _y = Ns(!0);
      function ao() {
        return [];
      }
      function lo() {
        return !1;
      }
      function Sy() {
        return {};
      }
      function $y() {
        return "";
      }
      function Ay() {
        return !0;
      }
      function Ty(e, n) {
        if (e = ge(e), e < 1 || e > We)
          return [];
        var a = bt, s = ft(e, bt);
        n = ue(n), e -= bt;
        for (var p = fl(s, n); ++a < e; )
          n(a);
        return p;
      }
      function Cy(e) {
        return he(e) ? He(e, Qt) : Ct(e) ? [e] : wt(nf(Re(e)));
      }
      function Ey(e) {
        var n = ++Vp;
        return Re(e) + n;
      }
      var Oy = Ki(function(e, n) {
        return e + n;
      }, 0), Iy = Ml("ceil"), Fy = Ki(function(e, n) {
        return e / n;
      }, 1), Py = Ml("floor");
      function Ly(e) {
        return e && e.length ? Ni(e, St, xl) : r;
      }
      function Ry(e, n) {
        return e && e.length ? Ni(e, ue(n, 2), xl) : r;
      }
      function Dy(e) {
        return zu(e, St);
      }
      function My(e, n) {
        return zu(e, ue(n, 2));
      }
      function By(e) {
        return e && e.length ? Ni(e, St, Al) : r;
      }
      function ky(e, n) {
        return e && e.length ? Ni(e, ue(n, 2), Al) : r;
      }
      var Vy = Ki(function(e, n) {
        return e * n;
      }, 1), Ny = Ml("round"), Uy = Ki(function(e, n) {
        return e - n;
      }, 0);
      function zy(e) {
        return e && e.length ? sl(e, St) : 0;
      }
      function Wy(e, n) {
        return e && e.length ? sl(e, ue(n, 2)) : 0;
      }
      return g.after = cg, g.ary = pf, g.assign = Xg, g.assignIn = Ef, g.assignInWith = la, g.assignWith = Qg, g.at = e1, g.before = hf, g.bind = ql, g.bindAll = ay, g.bindKey = mf, g.castArray = Sg, g.chain = cf, g.chunk = P0, g.compact = L0, g.concat = R0, g.cond = ly, g.conforms = oy, g.constant = to, g.countBy = zm, g.create = t1, g.curry = gf, g.curryRight = yf, g.debounce = bf, g.defaults = n1, g.defaultsDeep = r1, g.defer = dg, g.delay = vg, g.difference = D0, g.differenceBy = M0, g.differenceWith = B0, g.drop = k0, g.dropRight = V0, g.dropRightWhile = N0, g.dropWhile = U0, g.fill = z0, g.filter = Hm, g.flatMap = Km, g.flatMapDeep = qm, g.flatMapDepth = Ym, g.flatten = of, g.flattenDeep = W0, g.flattenDepth = H0, g.flip = pg, g.flow = sy, g.flowRight = fy, g.fromPairs = G0, g.functions = f1, g.functionsIn = c1, g.groupBy = Zm, g.initial = K0, g.intersection = q0, g.intersectionBy = Y0, g.intersectionWith = Z0, g.invert = v1, g.invertBy = p1, g.invokeMap = Xm, g.iteratee = no, g.keyBy = Qm, g.keys = it, g.keysIn = _t, g.map = ea, g.mapKeys = m1, g.mapValues = g1, g.matches = cy, g.matchesProperty = dy, g.memoize = na, g.merge = y1, g.mergeWith = Of, g.method = vy, g.methodOf = py, g.mixin = ro, g.negate = ra, g.nthArg = my, g.omit = b1, g.omitBy = w1, g.once = hg, g.orderBy = eg, g.over = gy, g.overArgs = mg, g.overEvery = yy, g.overSome = by, g.partial = Yl, g.partialRight = wf, g.partition = tg, g.pick = x1, g.pickBy = If, g.property = Bf, g.propertyOf = wy, g.pull = em, g.pullAll = sf, g.pullAllBy = tm, g.pullAllWith = nm, g.pullAt = rm, g.range = xy, g.rangeRight = _y, g.rearg = gg, g.reject = ig, g.remove = im, g.rest = yg, g.reverse = jl, g.sampleSize = lg, g.set = S1, g.setWith = $1, g.shuffle = og, g.slice = am, g.sortBy = fg, g.sortedUniq = dm, g.sortedUniqBy = vm, g.split = K1, g.spread = bg, g.tail = pm, g.take = hm, g.takeRight = mm, g.takeRightWhile = gm, g.takeWhile = ym, g.tap = Lm, g.throttle = wg, g.thru = Qi, g.toArray = Af, g.toPairs = Ff, g.toPairsIn = Pf, g.toPath = Cy, g.toPlainObject = Cf, g.transform = A1, g.unary = xg, g.union = bm, g.unionBy = wm, g.unionWith = xm, g.uniq = _m, g.uniqBy = Sm, g.uniqWith = $m, g.unset = T1, g.unzip = Kl, g.unzipWith = ff, g.update = C1, g.updateWith = E1, g.values = vr, g.valuesIn = O1, g.without = Am, g.words = Df, g.wrap = _g, g.xor = Tm, g.xorBy = Cm, g.xorWith = Em, g.zip = Om, g.zipObject = Im, g.zipObjectDeep = Fm, g.zipWith = Pm, g.entries = Ff, g.entriesIn = Pf, g.extend = Ef, g.extendWith = la, ro(g, g), g.add = Oy, g.attempt = Mf, g.camelCase = L1, g.capitalize = Lf, g.ceil = Iy, g.clamp = I1, g.clone = $g, g.cloneDeep = Tg, g.cloneDeepWith = Cg, g.cloneWith = Ag, g.conformsTo = Eg, g.deburr = Rf, g.defaultTo = uy, g.divide = Fy, g.endsWith = R1, g.eq = jt, g.escape = D1, g.escapeRegExp = M1, g.every = Wm, g.find = Gm, g.findIndex = af, g.findKey = i1, g.findLast = jm, g.findLastIndex = lf, g.findLastKey = a1, g.floor = Py, g.forEach = df, g.forEachRight = vf, g.forIn = l1, g.forInRight = o1, g.forOwn = u1, g.forOwnRight = s1, g.get = Xl, g.gt = Og, g.gte = Ig, g.has = d1, g.hasIn = Ql, g.head = uf, g.identity = St, g.includes = Jm, g.indexOf = j0, g.inRange = F1, g.invoke = h1, g.isArguments = Wn, g.isArray = he, g.isArrayBuffer = Fg, g.isArrayLike = xt, g.isArrayLikeObject = Ye, g.isBoolean = Pg, g.isBuffer = On, g.isDate = Lg, g.isElement = Rg, g.isEmpty = Dg, g.isEqual = Mg, g.isEqualWith = Bg, g.isError = Zl, g.isFinite = kg, g.isFunction = vn, g.isInteger = xf, g.isLength = ia, g.isMap = _f, g.isMatch = Vg, g.isMatchWith = Ng, g.isNaN = Ug, g.isNative = zg, g.isNil = Hg, g.isNull = Wg, g.isNumber = Sf, g.isObject = je, g.isObjectLike = Ke, g.isPlainObject = qr, g.isRegExp = Jl, g.isSafeInteger = Gg, g.isSet = $f, g.isString = aa, g.isSymbol = Ct, g.isTypedArray = dr, g.isUndefined = jg, g.isWeakMap = Kg, g.isWeakSet = qg, g.join = J0, g.kebabCase = B1, g.last = kt, g.lastIndexOf = X0, g.lowerCase = k1, g.lowerFirst = V1, g.lt = Yg, g.lte = Zg, g.max = Ly, g.maxBy = Ry, g.mean = Dy, g.meanBy = My, g.min = By, g.minBy = ky, g.stubArray = ao, g.stubFalse = lo, g.stubObject = Sy, g.stubString = $y, g.stubTrue = Ay, g.multiply = Vy, g.nth = Q0, g.noConflict = hy, g.noop = io, g.now = ta, g.pad = N1, g.padEnd = U1, g.padStart = z1, g.parseInt = W1, g.random = P1, g.reduce = ng, g.reduceRight = rg, g.repeat = H1, g.replace = G1, g.result = _1, g.round = Ny, g.runInContext = O, g.sample = ag, g.size = ug, g.snakeCase = j1, g.some = sg, g.sortedIndex = lm, g.sortedIndexBy = om, g.sortedIndexOf = um, g.sortedLastIndex = sm, g.sortedLastIndexBy = fm, g.sortedLastIndexOf = cm, g.startCase = q1, g.startsWith = Y1, g.subtract = Uy, g.sum = zy, g.sumBy = Wy, g.template = Z1, g.times = Ty, g.toFinite = pn, g.toInteger = ge, g.toLength = Tf, g.toLower = J1, g.toNumber = Vt, g.toSafeInteger = Jg, g.toString = Re, g.toUpper = X1, g.trim = Q1, g.trimEnd = ey, g.trimStart = ty, g.truncate = ny, g.unescape = ry, g.uniqueId = Ey, g.upperCase = iy, g.upperFirst = eo, g.each = df, g.eachRight = vf, g.first = uf, ro(g, function() {
        var e = {};
        return Jt(g, function(n, a) {
          Me.call(g.prototype, a) || (e[a] = n);
        }), e;
      }(), { chain: !1 }), g.VERSION = u, Lt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        g[e].placeholder = g;
      }), Lt(["drop", "take"], function(e, n) {
        Se.prototype[e] = function(a) {
          a = a === r ? 1 : nt(ge(a), 0);
          var s = this.__filtered__ && !n ? new Se(this) : this.clone();
          return s.__filtered__ ? s.__takeCount__ = ft(a, s.__takeCount__) : s.__views__.push({
            size: ft(a, bt),
            type: e + (s.__dir__ < 0 ? "Right" : "")
          }), s;
        }, Se.prototype[e + "Right"] = function(a) {
          return this.reverse()[e](a).reverse();
        };
      }), Lt(["filter", "map", "takeWhile"], function(e, n) {
        var a = n + 1, s = a == J || a == de;
        Se.prototype[e] = function(p) {
          var b = this.clone();
          return b.__iteratees__.push({
            iteratee: ue(p, 3),
            type: a
          }), b.__filtered__ = b.__filtered__ || s, b;
        };
      }), Lt(["head", "last"], function(e, n) {
        var a = "take" + (n ? "Right" : "");
        Se.prototype[e] = function() {
          return this[a](1).value()[0];
        };
      }), Lt(["initial", "tail"], function(e, n) {
        var a = "drop" + (n ? "" : "Right");
        Se.prototype[e] = function() {
          return this.__filtered__ ? new Se(this) : this[a](1);
        };
      }), Se.prototype.compact = function() {
        return this.filter(St);
      }, Se.prototype.find = function(e) {
        return this.filter(e).head();
      }, Se.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, Se.prototype.invokeMap = we(function(e, n) {
        return typeof e == "function" ? new Se(this) : this.map(function(a) {
          return zr(a, e, n);
        });
      }), Se.prototype.reject = function(e) {
        return this.filter(ra(ue(e)));
      }, Se.prototype.slice = function(e, n) {
        e = ge(e);
        var a = this;
        return a.__filtered__ && (e > 0 || n < 0) ? new Se(a) : (e < 0 ? a = a.takeRight(-e) : e && (a = a.drop(e)), n !== r && (n = ge(n), a = n < 0 ? a.dropRight(-n) : a.take(n - e)), a);
      }, Se.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, Se.prototype.toArray = function() {
        return this.take(bt);
      }, Jt(Se.prototype, function(e, n) {
        var a = /^(?:filter|find|map|reject)|While$/.test(n), s = /^(?:head|last)$/.test(n), p = g[s ? "take" + (n == "last" ? "Right" : "") : n], b = s || /^find/.test(n);
        p && (g.prototype[n] = function() {
          var $ = this.__wrapped__, C = s ? [1] : arguments, I = $ instanceof Se, B = C[0], N = I || he($), G = function(_e) {
            var Ae = p.apply(g, _n([_e], C));
            return s && Z ? Ae[0] : Ae;
          };
          N && a && typeof B == "function" && B.length != 1 && (I = N = !1);
          var Z = this.__chain__, ie = !!this.__actions__.length, fe = b && !Z, be = I && !ie;
          if (!b && N) {
            $ = be ? $ : new Se(this);
            var ce = e.apply($, C);
            return ce.__actions__.push({ func: Qi, args: [G], thisArg: r }), new Dt(ce, Z);
          }
          return fe && be ? e.apply(this, C) : (ce = this.thru(G), fe ? s ? ce.value()[0] : ce.value() : ce);
        });
      }), Lt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var n = Ai[e], a = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(e);
        g.prototype[e] = function() {
          var p = arguments;
          if (s && !this.__chain__) {
            var b = this.value();
            return n.apply(he(b) ? b : [], p);
          }
          return this[a](function($) {
            return n.apply(he($) ? $ : [], p);
          });
        };
      }), Jt(Se.prototype, function(e, n) {
        var a = g[n];
        if (a) {
          var s = a.name + "";
          Me.call(or, s) || (or[s] = []), or[s].push({ name: n, func: a });
        }
      }), or[ji(r, A).name] = [{
        name: "wrapper",
        func: r
      }], Se.prototype.clone = rh, Se.prototype.reverse = ih, Se.prototype.value = ah, g.prototype.at = Rm, g.prototype.chain = Dm, g.prototype.commit = Mm, g.prototype.next = Bm, g.prototype.plant = Vm, g.prototype.reverse = Nm, g.prototype.toJSON = g.prototype.valueOf = g.prototype.value = Um, g.prototype.first = g.prototype.head, Dr && (g.prototype[Dr] = km), g;
    }, ir = Mp();
    Dn ? ((Dn.exports = ir)._ = ir, nl._ = ir) : ot._ = ir;
  }).call(mn);
})(Q3, mr);
const eT = /* @__PURE__ */ Q({
  __name: "TuneTextareaArray",
  props: {
    modelValue: null,
    definition: null,
    label: null,
    placeholder: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    function u(f) {
      const c = f.replace(/\n/g, " ").replace(/,/g, " ").replace(/;/g, " ").split(" ").map((v) => v.trim()).filter((v) => !!v).filter((v, d, h) => h.indexOf(v) === d);
      r("update:modelValue", c);
    }
    const l = z();
    function o() {
      var f;
      (f = l == null ? void 0 : l.value) == null || f.forceShowError();
    }
    return i({
      forceShowError: o
    }), (f, c) => {
      var v, d, h;
      return W(), ve(tu, {
        ref_key: "textareaRef",
        ref: l,
        "model-value": (v = t.modelValue) == null ? void 0 : v.join(`
`),
        definition: t.definition,
        label: t.label,
        placeholder: t.placeholder || ((h = (d = t.definition) == null ? void 0 : d.examples) == null ? void 0 : h.join(`
`)) || "",
        error: t.error,
        "onUpdate:modelValue": c[0] || (c[0] = (m) => u(m))
      }, null, 8, ["model-value", "definition", "label", "placeholder", "error"]);
    };
  }
}), tT = { class: "relative" }, nT = {
  key: 0,
  class: "tune-listbox-multiple-placeholder"
}, rT = { key: 2 }, iT = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-[12px]" }, aT = { class: "max-h-[180px] overflow-y-auto" }, lT = { key: 1 }, oT = {
  key: 0,
  class: /* @__PURE__ */ Ee(["absolute inset-y-0 right-0 flex items-center pr-3"])
}, uT = /* @__PURE__ */ Q({
  __name: "TuneListboxMultiple",
  props: {
    modelValue: null,
    items: null,
    definition: null,
    label: null,
    placeholder: null,
    limit: null,
    disabled: { type: Boolean },
    hint: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = t, l = k({
      get: () => u.items.filter((v) => {
        var d;
        return (d = u.modelValue) == null ? void 0 : d.includes(v.value);
      }) || [],
      set: (v) => r(
        "update:modelValue",
        v.map((d) => d.value)
      )
    });
    function o(v) {
      return !u.limit || l.value.length < u.limit ? !1 : !l.value.some((d) => d.value === v);
    }
    const f = z(!1);
    function c() {
      f.value = !0;
    }
    return i({
      forceShowError: c
    }), (v, d) => {
      const h = No("tippy");
      return W(), re("div", null, [
        se(j(id), {
          modelValue: j(l),
          "onUpdate:modelValue": d[0] || (d[0] = (m) => qn(l) ? l.value = m : null),
          as: "div",
          disabled: t.disabled,
          multiple: ""
        }, {
          default: le(() => [
            se(j(ad), null, {
              default: le(() => {
                var m;
                return [
                  se(Ut, {
                    hint: t.hint || ((m = t.definition) == null ? void 0 : m.description)
                  }, {
                    default: le(() => {
                      var y;
                      return [
                        vt(De(t.label || ((y = t.definition) == null ? void 0 : y.title)), 1)
                      ];
                    }),
                    _: 1
                  }, 8, ["hint"])
                ];
              }),
              _: 1
            }),
            te("div", tT, [
              _a((W(), ve(j(ld), {
                class: Ee([
                  "tune-listbox-button relative h-[42px] w-full truncate pl-3 pr-[40px] text-left",
                  { "disabled cursor-not-allowed": t.disabled },
                  {
                    error: f.value && t.error
                  }
                ])
              }, {
                default: le(() => {
                  var m, y;
                  return [
                    j(l).length < 1 ? (W(), re("span", nT, De(t.placeholder || ((y = (m = t.definition) == null ? void 0 : m.examples) == null ? void 0 : y[0])), 1)) : v.$slots.selected ? dt(v.$slots, "selected", {
                      key: 1,
                      selectedItems: j(l)
                    }) : (W(), re("span", rT, De(j(l).map((w) => (w == null ? void 0 : w.name) || w.value).join(", ")), 1)),
                    te("span", iT, [
                      se(j(Zn), { class: "text-sm" })
                    ])
                  ];
                }),
                _: 3
              }, 8, ["class"])), [
                [h, {
                  content: j(l).map((m) => (m == null ? void 0 : m.name) || m.value).join(", ")
                }]
              ]),
              se(Uo, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "transform -translate-y-2 scale-95 opacity-0",
                "enter-to-class": "transform scale-100 opacity-100",
                "leave-active-class": "transition duration-75 ease-out",
                "leave-from-class": "transform scale-100 opacity-100",
                "leave-to-class": "transform scale-95 opacity-0"
              }, {
                default: le(() => [
                  se(j(od), { class: "tune-listbox-options absolute z-40 mt-1 w-full overflow-hidden focus:outline-none" }, {
                    default: le(() => [
                      te("div", aT, [
                        (W(!0), re(rt, null, rn(t.items, (m, y) => (W(), ve(j(ud), {
                          key: y,
                          as: "template",
                          value: m,
                          disabled: o(m.value)
                        }, {
                          default: le(({ active: w, selected: x, disabled: S }) => [
                            te("li", {
                              class: Ee([
                                { active: w },
                                "tune-listbox-item relative cursor-default select-none py-2 pl-3 pr-[50px]"
                              ])
                            }, [
                              te("span", {
                                class: Ee([
                                  x ? "selected" : "font-normal",
                                  { disabled: S },
                                  "tune-listbox-item block truncate"
                                ])
                              }, [
                                v.$slots.item ? dt(v.$slots, "item", {
                                  key: 0,
                                  item: m
                                }) : (W(), re("span", lT, De((m == null ? void 0 : m.name) || m.value), 1))
                              ], 2),
                              x ? (W(), re("span", oT, [
                                se(j(Oa), { class: "text-sm" })
                              ])) : Oe("", !0)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))), 128))
                      ])
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ])
          ]),
          _: 3
        }, 8, ["modelValue", "disabled"]),
        t.error && f.value ? (W(), ve(eu, {
          key: 0,
          error: t.error
        }, null, 8, ["error"])) : Oe("", !0)
      ]);
    };
  }
}), sT = { key: 0 }, fT = {
  key: 3,
  class: "space-y-2"
}, cT = { class: "mb-2" }, dT = /* @__PURE__ */ Q({
  __name: "FormArray",
  props: {
    modelValue: null,
    definition: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = t, l = k({
      get: () => u.modelValue,
      set: (d) => r("update:modelValue", d)
    }), o = (d) => {
      switch (d) {
        case "object":
          return Gd;
        case "string":
          return zd;
        case "number":
          return Wd;
        case "boolean":
          return Hd;
        default:
          return null;
      }
    };
    function f() {
      var h, m;
      const d = mr.cloneDeep(l.value);
      d.push(mr.cloneDeep((m = (h = u.definition) == null ? void 0 : h.items) == null ? void 0 : m.default) || ""), l.value = d;
    }
    const c = z();
    function v() {
      var d, h, m;
      (d = c == null ? void 0 : c.value) != null && d.forceShowError ? (h = c == null ? void 0 : c.value) == null || h.forceShowError() : (m = c == null ? void 0 : c.value) == null || m.forEach((y) => {
        y != null && y.forceShowError && (y == null || y.forceShowError());
      });
    }
    return i({
      forceShowError: v
    }), Ie(() => {
      var d, h, m;
      ((d = u.definition) == null ? void 0 : d.title) !== "Strategies" && (u.modelValue || (l.value = mr.cloneDeep([(m = (h = u.definition) == null ? void 0 : h.items) == null ? void 0 : m.default])));
    }), (d, h) => {
      var m, y, w, x, S, _, A, T, E;
      return ((m = t.definition) == null ? void 0 : m.title) === "Strategies" ? (W(), re("div", sT)) : (w = (y = t.definition) == null ? void 0 : y.items) != null && w.anyOf && ((S = (x = t.definition) == null ? void 0 : x.items) == null ? void 0 : S.type) === "string" ? (W(), ve(uT, {
        key: 1,
        ref_key: "componentRefs",
        ref: c,
        modelValue: j(l),
        "onUpdate:modelValue": h[0] || (h[0] = (F) => qn(l) ? l.value = F : null),
        items: t.definition.items.anyOf.map((F) => ({
          value: F.const,
          name: F.title
        })),
        definition: t.definition,
        error: t.error
      }, null, 8, ["modelValue", "items", "definition", "error"])) : ((_ = t.definition) == null ? void 0 : _.items.type) === "string" ? (W(), ve(eT, {
        key: 2,
        modelValue: j(l),
        "onUpdate:modelValue": h[1] || (h[1] = (F) => qn(l) ? l.value = F : null),
        definition: t.definition,
        error: t.error
      }, null, 8, ["modelValue", "definition", "error"])) : (A = t.definition) != null && A.items ? (W(), re("div", fT, [
        (T = t.definition) != null && T.title ? (W(), ve(Ut, {
          key: 0,
          hint: (E = t.definition) == null ? void 0 : E.description
        }, {
          default: le(() => {
            var F;
            return [
              vt(De((F = t.definition) == null ? void 0 : F.title), 1)
            ];
          }),
          _: 1
        }, 8, ["hint"])) : Oe("", !0),
        (W(!0), re(rt, null, rn(j(l), (F, P) => {
          var R, V;
          return W(), re("div", {
            key: P,
            class: Ee({
              "tune-form-array-objects": ((V = (R = t.definition) == null ? void 0 : R.items) == null ? void 0 : V.type) === "object"
            })
          }, [
            te("div", cT, [
              se(Ed, {
                label: P + 1
              }, null, 8, ["label"])
            ]),
            (W(), ve(Pc(o(t.definition.items.type)), {
              ref_for: !0,
              ref_key: "componentRefs",
              ref: c,
              modelValue: j(l)[P],
              "onUpdate:modelValue": (M) => j(l)[P] = M,
              definition: t.definition.items,
              error: t.error
            }, null, 8, ["modelValue", "onUpdate:modelValue", "definition", "error"]))
          ], 2);
        }), 128)),
        se(Sa, {
          class: "w-full",
          onClick: f
        }, {
          default: le(() => [
            vt(" Add ")
          ]),
          _: 1
        })
      ])) : Oe("", !0);
    };
  }
}), vT = { class: "space-y-2" }, Gd = /* @__PURE__ */ Q({
  __name: "TuneForm",
  props: {
    modelValue: null,
    definition: null,
    error: null
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = t, l = k({
      get: () => {
        var v;
        return u.modelValue || ((v = u.definition) == null ? void 0 : v.default) || {};
      },
      set: (v) => r("update:modelValue", v)
    }), o = (v) => {
      switch (v) {
        case "object":
          return Gd;
        case "string":
          return zd;
        case "number":
          return Wd;
        case "boolean":
          return Hd;
        case "array":
          return dT;
        default:
          return null;
      }
    }, f = z();
    function c() {
      var v;
      (v = f == null ? void 0 : f.value) == null || v.forEach((d) => {
        d != null && d.forceShowError && (d == null || d.forceShowError());
      });
    }
    return i({
      forceShowError: c
    }), (v, d) => (W(), re("div", vT, [
      (W(!0), re(rt, null, rn(t.definition.properties, (h, m) => (W(), ve(Pc(o(h.type)), {
        ref_for: !0,
        ref_key: "componentRefs",
        ref: f,
        key: m,
        modelValue: j(l)[m],
        "onUpdate:modelValue": (y) => j(l)[m] = y,
        definition: h,
        error: t.error[m] || ""
      }, null, 8, ["modelValue", "onUpdate:modelValue", "definition", "error"]))), 128))
    ]));
  }
}), XC = /* @__PURE__ */ Q({
  __name: "TuneTextareaJson",
  props: {
    modelValue: null,
    definition: null,
    label: null,
    placeholder: null,
    error: null
  },
  emits: ["update:modelValue", "update:isValid"],
  setup(t, { expose: i, emit: r }) {
    const u = t, l = z(""), o = z("");
    function f() {
      try {
        r("update:modelValue", JSON.parse(l.value)), r("update:isValid", !0), o.value = "";
      } catch (d) {
        r("update:isValid", !1), o.value = d == null ? void 0 : d.message;
      }
    }
    Je(l, () => f()), u.modelValue && (l.value = JSON.stringify(u.modelValue, null, 2));
    const c = z();
    function v() {
      var d;
      (d = c == null ? void 0 : c.value) == null || d.forceShowError();
    }
    return i({
      forceShowError: v
    }), (d, h) => (W(), ve(tu, {
      ref_key: "textareaRef",
      ref: c,
      modelValue: l.value,
      "onUpdate:modelValue": h[0] || (h[0] = (m) => l.value = m),
      definition: t.definition,
      label: t.label,
      placeholder: t.placeholder,
      error: o.value || t.error,
      class: "tune-textarea-json font-mono"
    }, null, 8, ["modelValue", "definition", "label", "placeholder", "error"]));
  }
});
function en(t) {
  return t.split("-")[1];
}
function au(t) {
  return t === "y" ? "height" : "width";
}
function gn(t) {
  return t.split("-")[0];
}
function pi(t) {
  return ["top", "bottom"].includes(gn(t)) ? "x" : "y";
}
function xc(t, i, r) {
  let { reference: u, floating: l } = t;
  const o = u.x + u.width / 2 - l.width / 2, f = u.y + u.height / 2 - l.height / 2, c = pi(i), v = au(c), d = u[v] / 2 - l[v] / 2, h = c === "x";
  let m;
  switch (gn(i)) {
    case "top":
      m = { x: o, y: u.y - l.height };
      break;
    case "bottom":
      m = { x: o, y: u.y + u.height };
      break;
    case "right":
      m = { x: u.x + u.width, y: f };
      break;
    case "left":
      m = { x: u.x - l.width, y: f };
      break;
    default:
      m = { x: u.x, y: u.y };
  }
  switch (en(i)) {
    case "start":
      m[c] -= d * (r && h ? -1 : 1);
      break;
    case "end":
      m[c] += d * (r && h ? -1 : 1);
  }
  return m;
}
const pT = async (t, i, r) => {
  const { placement: u = "bottom", strategy: l = "absolute", middleware: o = [], platform: f } = r, c = o.filter(Boolean), v = await (f.isRTL == null ? void 0 : f.isRTL(i));
  let d = await f.getElementRects({ reference: t, floating: i, strategy: l }), { x: h, y: m } = xc(d, u, v), y = u, w = {}, x = 0;
  for (let S = 0; S < c.length; S++) {
    const { name: _, fn: A } = c[S], { x: T, y: E, data: F, reset: P } = await A({ x: h, y: m, initialPlacement: u, placement: y, strategy: l, middlewareData: w, rects: d, platform: f, elements: { reference: t, floating: i } });
    h = T ?? h, m = E ?? m, w = { ...w, [_]: { ...w[_], ...F } }, P && x <= 50 && (x++, typeof P == "object" && (P.placement && (y = P.placement), P.rects && (d = P.rects === !0 ? await f.getElementRects({ reference: t, floating: i, strategy: l }) : P.rects), { x: h, y: m } = xc(d, y, v)), S = -1);
  }
  return { x: h, y: m, placement: y, strategy: l, middlewareData: w };
};
function jd(t) {
  return typeof t != "number" ? function(i) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...i };
  }(t) : { top: t, right: t, bottom: t, left: t };
}
function ya(t) {
  return { ...t, top: t.y, left: t.x, right: t.x + t.width, bottom: t.y + t.height };
}
async function ri(t, i) {
  var r;
  i === void 0 && (i = {});
  const { x: u, y: l, platform: o, rects: f, elements: c, strategy: v } = t, { boundary: d = "clippingAncestors", rootBoundary: h = "viewport", elementContext: m = "floating", altBoundary: y = !1, padding: w = 0 } = i, x = jd(w), S = c[y ? m === "floating" ? "reference" : "floating" : m], _ = ya(await o.getClippingRect({ element: (r = await (o.isElement == null ? void 0 : o.isElement(S))) == null || r ? S : S.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(c.floating)), boundary: d, rootBoundary: h, strategy: v })), A = m === "floating" ? { ...f.floating, x: u, y: l } : f.reference, T = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c.floating)), E = await (o.isElement == null ? void 0 : o.isElement(T)) && await (o.getScale == null ? void 0 : o.getScale(T)) || { x: 1, y: 1 }, F = ya(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: A, offsetParent: T, strategy: v }) : A);
  return { top: (_.top - F.top + x.top) / E.y, bottom: (F.bottom - _.bottom + x.bottom) / E.y, left: (_.left - F.left + x.left) / E.x, right: (F.right - _.right + x.right) / E.x };
}
const hT = Math.min, mT = Math.max;
function Ro(t, i, r) {
  return mT(t, hT(i, r));
}
const gT = (t) => ({ name: "arrow", options: t, async fn(i) {
  const { element: r, padding: u = 0 } = t || {}, { x: l, y: o, placement: f, rects: c, platform: v, elements: d } = i;
  if (r == null)
    return {};
  const h = jd(u), m = { x: l, y: o }, y = pi(f), w = au(y), x = await v.getDimensions(r), S = y === "y", _ = S ? "top" : "left", A = S ? "bottom" : "right", T = S ? "clientHeight" : "clientWidth", E = c.reference[w] + c.reference[y] - m[y] - c.floating[w], F = m[y] - c.reference[y], P = await (v.getOffsetParent == null ? void 0 : v.getOffsetParent(r));
  let R = P ? P[T] : 0;
  R && await (v.isElement == null ? void 0 : v.isElement(P)) || (R = d.floating[T] || c.floating[w]);
  const V = E / 2 - F / 2, M = h[_], H = R - x[w] - h[A], K = R / 2 - x[w] / 2 + V, Y = Ro(M, K, H), ee = en(f) != null && K != Y && c.reference[w] / 2 - (K < M ? h[_] : h[A]) - x[w] / 2 < 0;
  return { [y]: m[y] - (ee ? K < M ? M - K : H - K : 0), data: { [y]: Y, centerOffset: K - Y } };
} }), Kd = ["top", "right", "bottom", "left"], _c = Kd.reduce((t, i) => t.concat(i, i + "-start", i + "-end"), []), yT = { left: "right", right: "left", bottom: "top", top: "bottom" };
function ba(t) {
  return t.replace(/left|right|bottom|top/g, (i) => yT[i]);
}
function qd(t, i, r) {
  r === void 0 && (r = !1);
  const u = en(t), l = pi(t), o = au(l);
  let f = l === "x" ? u === (r ? "end" : "start") ? "right" : "left" : u === "start" ? "bottom" : "top";
  return i.reference[o] > i.floating[o] && (f = ba(f)), { main: f, cross: ba(f) };
}
const bT = { start: "end", end: "start" };
function da(t) {
  return t.replace(/start|end/g, (i) => bT[i]);
}
const wT = function(t) {
  return t === void 0 && (t = {}), { name: "autoPlacement", options: t, async fn(i) {
    var r, u, l;
    const { rects: o, middlewareData: f, placement: c, platform: v, elements: d } = i, { crossAxis: h = !1, alignment: m, allowedPlacements: y = _c, autoAlignment: w = !0, ...x } = t, S = m !== void 0 || y === _c ? function(K, Y, ee) {
      return (K ? [...ee.filter((ne) => en(ne) === K), ...ee.filter((ne) => en(ne) !== K)] : ee.filter((ne) => gn(ne) === ne)).filter((ne) => !K || en(ne) === K || !!Y && da(ne) !== ne);
    }(m || null, w, y) : y, _ = await ri(i, x), A = ((r = f.autoPlacement) == null ? void 0 : r.index) || 0, T = S[A];
    if (T == null)
      return {};
    const { main: E, cross: F } = qd(T, o, await (v.isRTL == null ? void 0 : v.isRTL(d.floating)));
    if (c !== T)
      return { reset: { placement: S[0] } };
    const P = [_[gn(T)], _[E], _[F]], R = [...((u = f.autoPlacement) == null ? void 0 : u.overflows) || [], { placement: T, overflows: P }], V = S[A + 1];
    if (V)
      return { data: { index: A + 1, overflows: R }, reset: { placement: V } };
    const M = R.map((K) => {
      const Y = en(K.placement);
      return [K.placement, Y && h ? K.overflows.slice(0, 2).reduce((ee, ne) => ee + ne, 0) : K.overflows[0], K.overflows];
    }).sort((K, Y) => K[1] - Y[1]), H = ((l = M.filter((K) => K[2].slice(0, en(K[0]) ? 2 : 3).every((Y) => Y <= 0))[0]) == null ? void 0 : l[0]) || M[0][0];
    return H !== c ? { data: { index: A + 1, overflows: R }, reset: { placement: H } } : {};
  } };
}, xT = function(t) {
  return t === void 0 && (t = {}), { name: "flip", options: t, async fn(i) {
    var r;
    const { placement: u, middlewareData: l, rects: o, initialPlacement: f, platform: c, elements: v } = i, { mainAxis: d = !0, crossAxis: h = !0, fallbackPlacements: m, fallbackStrategy: y = "bestFit", fallbackAxisSideDirection: w = "none", flipAlignment: x = !0, ...S } = t, _ = gn(u), A = gn(f) === f, T = await (c.isRTL == null ? void 0 : c.isRTL(v.floating)), E = m || (A || !x ? [ba(f)] : function(Y) {
      const ee = ba(Y);
      return [da(Y), ee, da(ee)];
    }(f));
    m || w === "none" || E.push(...function(Y, ee, ne, J) {
      const oe = en(Y);
      let de = function(ye, We, qe) {
        const wn = ["left", "right"], bt = ["right", "left"], Jn = ["top", "bottom"], Tr = ["bottom", "top"];
        switch (ye) {
          case "top":
          case "bottom":
            return qe ? We ? bt : wn : We ? wn : bt;
          case "left":
          case "right":
            return We ? Jn : Tr;
          default:
            return [];
        }
      }(gn(Y), ne === "start", J);
      return oe && (de = de.map((ye) => ye + "-" + oe), ee && (de = de.concat(de.map(da)))), de;
    }(f, x, w, T));
    const F = [f, ...E], P = await ri(i, S), R = [];
    let V = ((r = l.flip) == null ? void 0 : r.overflows) || [];
    if (d && R.push(P[_]), h) {
      const { main: Y, cross: ee } = qd(u, o, T);
      R.push(P[Y], P[ee]);
    }
    if (V = [...V, { placement: u, overflows: R }], !R.every((Y) => Y <= 0)) {
      var M, H;
      const Y = (((M = l.flip) == null ? void 0 : M.index) || 0) + 1, ee = F[Y];
      if (ee)
        return { data: { index: Y, overflows: V }, reset: { placement: ee } };
      let ne = (H = V.filter((J) => J.overflows[0] <= 0).sort((J, oe) => J.overflows[1] - oe.overflows[1])[0]) == null ? void 0 : H.placement;
      if (!ne)
        switch (y) {
          case "bestFit": {
            var K;
            const J = (K = V.map((oe) => [oe.placement, oe.overflows.filter((de) => de > 0).reduce((de, ye) => de + ye, 0)]).sort((oe, de) => oe[1] - de[1])[0]) == null ? void 0 : K[0];
            J && (ne = J);
            break;
          }
          case "initialPlacement":
            ne = f;
        }
      if (u !== ne)
        return { reset: { placement: ne } };
    }
    return {};
  } };
};
function Sc(t, i) {
  return { top: t.top - i.height, right: t.right - i.width, bottom: t.bottom - i.height, left: t.left - i.width };
}
function $c(t) {
  return Kd.some((i) => t[i] >= 0);
}
const _T = function(t) {
  return t === void 0 && (t = {}), { name: "hide", options: t, async fn(i) {
    const { strategy: r = "referenceHidden", ...u } = t, { rects: l } = i;
    switch (r) {
      case "referenceHidden": {
        const o = Sc(await ri(i, { ...u, elementContext: "reference" }), l.reference);
        return { data: { referenceHiddenOffsets: o, referenceHidden: $c(o) } };
      }
      case "escaped": {
        const o = Sc(await ri(i, { ...u, altBoundary: !0 }), l.floating);
        return { data: { escapedOffsets: o, escaped: $c(o) } };
      }
      default:
        return {};
    }
  } };
}, ST = function(t) {
  return t === void 0 && (t = 0), { name: "offset", options: t, async fn(i) {
    const { x: r, y: u } = i, l = await async function(o, f) {
      const { placement: c, platform: v, elements: d } = o, h = await (v.isRTL == null ? void 0 : v.isRTL(d.floating)), m = gn(c), y = en(c), w = pi(c) === "x", x = ["left", "top"].includes(m) ? -1 : 1, S = h && w ? -1 : 1, _ = typeof f == "function" ? f(o) : f;
      let { mainAxis: A, crossAxis: T, alignmentAxis: E } = typeof _ == "number" ? { mainAxis: _, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ..._ };
      return y && typeof E == "number" && (T = y === "end" ? -1 * E : E), w ? { x: T * S, y: A * x } : { x: A * x, y: T * S };
    }(i, t);
    return { x: r + l.x, y: u + l.y, data: l };
  } };
};
function $T(t) {
  return t === "x" ? "y" : "x";
}
const AT = function(t) {
  return t === void 0 && (t = {}), { name: "shift", options: t, async fn(i) {
    const { x: r, y: u, placement: l } = i, { mainAxis: o = !0, crossAxis: f = !1, limiter: c = { fn: (_) => {
      let { x: A, y: T } = _;
      return { x: A, y: T };
    } }, ...v } = t, d = { x: r, y: u }, h = await ri(i, v), m = pi(gn(l)), y = $T(m);
    let w = d[m], x = d[y];
    if (o) {
      const _ = m === "y" ? "bottom" : "right";
      w = Ro(w + h[m === "y" ? "top" : "left"], w, w - h[_]);
    }
    if (f) {
      const _ = y === "y" ? "bottom" : "right";
      x = Ro(x + h[y === "y" ? "top" : "left"], x, x - h[_]);
    }
    const S = c.fn({ ...i, [m]: w, [y]: x });
    return { ...S, data: { x: S.x - r, y: S.y - u } };
  } };
};
function Ft(t) {
  var i;
  return ((i = t.ownerDocument) == null ? void 0 : i.defaultView) || window;
}
function nn(t) {
  return Ft(t).getComputedStyle(t);
}
function Yd(t) {
  return t instanceof Ft(t).Node;
}
function Ln(t) {
  return Yd(t) ? (t.nodeName || "").toLowerCase() : "";
}
let ca;
function Zd() {
  if (ca)
    return ca;
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? (ca = t.brands.map((i) => i.brand + "/" + i.version).join(" "), ca) : navigator.userAgent;
}
function Yt(t) {
  return t instanceof Ft(t).HTMLElement;
}
function qt(t) {
  return t instanceof Ft(t).Element;
}
function Ac(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof Ft(t).ShadowRoot || t instanceof ShadowRoot;
}
function Ba(t) {
  const { overflow: i, overflowX: r, overflowY: u, display: l } = nn(t);
  return /auto|scroll|overlay|hidden|clip/.test(i + u + r) && !["inline", "contents"].includes(l);
}
function TT(t) {
  return ["table", "td", "th"].includes(Ln(t));
}
function Do(t) {
  const i = /firefox/i.test(Zd()), r = nn(t), u = r.backdropFilter || r.WebkitBackdropFilter;
  return r.transform !== "none" || r.perspective !== "none" || !!u && u !== "none" || i && r.willChange === "filter" || i && !!r.filter && r.filter !== "none" || ["transform", "perspective"].some((l) => r.willChange.includes(l)) || ["paint", "layout", "strict", "content"].some((l) => {
    const o = r.contain;
    return o != null && o.includes(l);
  });
}
function Mo() {
  return /^((?!chrome|android).)*safari/i.test(Zd());
}
function lu(t) {
  return ["html", "body", "#document"].includes(Ln(t));
}
const Tc = Math.min, Qr = Math.max, wa = Math.round;
function Jd(t) {
  const i = nn(t);
  let r = parseFloat(i.width), u = parseFloat(i.height);
  const l = Yt(t), o = l ? t.offsetWidth : r, f = l ? t.offsetHeight : u, c = wa(r) !== o || wa(u) !== f;
  return c && (r = o, u = f), { width: r, height: u, fallback: c };
}
function Xd(t) {
  return qt(t) ? t : t.contextElement;
}
const Qd = { x: 1, y: 1 };
function gr(t) {
  const i = Xd(t);
  if (!Yt(i))
    return Qd;
  const r = i.getBoundingClientRect(), { width: u, height: l, fallback: o } = Jd(i);
  let f = (o ? wa(r.width) : r.width) / u, c = (o ? wa(r.height) : r.height) / l;
  return f && Number.isFinite(f) || (f = 1), c && Number.isFinite(c) || (c = 1), { x: f, y: c };
}
function Yn(t, i, r, u) {
  var l, o;
  i === void 0 && (i = !1), r === void 0 && (r = !1);
  const f = t.getBoundingClientRect(), c = Xd(t);
  let v = Qd;
  i && (u ? qt(u) && (v = gr(u)) : v = gr(t));
  const d = c ? Ft(c) : window, h = Mo() && r;
  let m = (f.left + (h && ((l = d.visualViewport) == null ? void 0 : l.offsetLeft) || 0)) / v.x, y = (f.top + (h && ((o = d.visualViewport) == null ? void 0 : o.offsetTop) || 0)) / v.y, w = f.width / v.x, x = f.height / v.y;
  if (c) {
    const S = Ft(c), _ = u && qt(u) ? Ft(u) : u;
    let A = S.frameElement;
    for (; A && u && _ !== S; ) {
      const T = gr(A), E = A.getBoundingClientRect(), F = getComputedStyle(A);
      E.x += (A.clientLeft + parseFloat(F.paddingLeft)) * T.x, E.y += (A.clientTop + parseFloat(F.paddingTop)) * T.y, m *= T.x, y *= T.y, w *= T.x, x *= T.y, m += E.x, y += E.y, A = Ft(A).frameElement;
    }
  }
  return ya({ width: w, height: x, x: m, y });
}
function Pn(t) {
  return ((Yd(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function ka(t) {
  return qt(t) ? { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop } : { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
}
function ev(t) {
  return Yn(Pn(t)).left + ka(t).scrollLeft;
}
function ii(t) {
  if (Ln(t) === "html")
    return t;
  const i = t.assignedSlot || t.parentNode || Ac(t) && t.host || Pn(t);
  return Ac(i) ? i.host : i;
}
function tv(t) {
  const i = ii(t);
  return lu(i) ? i.ownerDocument.body : Yt(i) && Ba(i) ? i : tv(i);
}
function ei(t, i) {
  var r;
  i === void 0 && (i = []);
  const u = tv(t), l = u === ((r = t.ownerDocument) == null ? void 0 : r.body), o = Ft(u);
  return l ? i.concat(o, o.visualViewport || [], Ba(u) ? u : []) : i.concat(u, ei(u));
}
function Cc(t, i, r) {
  let u;
  if (i === "viewport")
    u = function(f, c) {
      const v = Ft(f), d = Pn(f), h = v.visualViewport;
      let m = d.clientWidth, y = d.clientHeight, w = 0, x = 0;
      if (h) {
        m = h.width, y = h.height;
        const S = Mo();
        (!S || S && c === "fixed") && (w = h.offsetLeft, x = h.offsetTop);
      }
      return { width: m, height: y, x: w, y: x };
    }(t, r);
  else if (i === "document")
    u = function(f) {
      const c = Pn(f), v = ka(f), d = f.ownerDocument.body, h = Qr(c.scrollWidth, c.clientWidth, d.scrollWidth, d.clientWidth), m = Qr(c.scrollHeight, c.clientHeight, d.scrollHeight, d.clientHeight);
      let y = -v.scrollLeft + ev(f);
      const w = -v.scrollTop;
      return nn(d).direction === "rtl" && (y += Qr(c.clientWidth, d.clientWidth) - h), { width: h, height: m, x: y, y: w };
    }(Pn(t));
  else if (qt(i))
    u = function(f, c) {
      const v = Yn(f, !0, c === "fixed"), d = v.top + f.clientTop, h = v.left + f.clientLeft, m = Yt(f) ? gr(f) : { x: 1, y: 1 };
      return { width: f.clientWidth * m.x, height: f.clientHeight * m.y, x: h * m.x, y: d * m.y };
    }(i, r);
  else {
    const f = { ...i };
    if (Mo()) {
      var l, o;
      const c = Ft(t);
      f.x -= ((l = c.visualViewport) == null ? void 0 : l.offsetLeft) || 0, f.y -= ((o = c.visualViewport) == null ? void 0 : o.offsetTop) || 0;
    }
    u = f;
  }
  return ya(u);
}
function Ec(t, i) {
  return Yt(t) && nn(t).position !== "fixed" ? i ? i(t) : t.offsetParent : null;
}
function Oc(t, i) {
  const r = Ft(t);
  if (!Yt(t))
    return r;
  let u = Ec(t, i);
  for (; u && TT(u) && nn(u).position === "static"; )
    u = Ec(u, i);
  return u && (Ln(u) === "html" || Ln(u) === "body" && nn(u).position === "static" && !Do(u)) ? r : u || function(l) {
    let o = ii(l);
    for (; Yt(o) && !lu(o); ) {
      if (Do(o))
        return o;
      o = ii(o);
    }
    return null;
  }(t) || r;
}
function CT(t, i, r) {
  const u = Yt(i), l = Pn(i), o = Yn(t, !0, r === "fixed", i);
  let f = { scrollLeft: 0, scrollTop: 0 };
  const c = { x: 0, y: 0 };
  if (u || !u && r !== "fixed")
    if ((Ln(i) !== "body" || Ba(l)) && (f = ka(i)), Yt(i)) {
      const v = Yn(i, !0);
      c.x = v.x + i.clientLeft, c.y = v.y + i.clientTop;
    } else
      l && (c.x = ev(l));
  return { x: o.left + f.scrollLeft - c.x, y: o.top + f.scrollTop - c.y, width: o.width, height: o.height };
}
const ET = { getClippingRect: function(t) {
  let { element: i, boundary: r, rootBoundary: u, strategy: l } = t;
  const o = r === "clippingAncestors" ? function(d, h) {
    const m = h.get(d);
    if (m)
      return m;
    let y = ei(d).filter((_) => qt(_) && Ln(_) !== "body"), w = null;
    const x = nn(d).position === "fixed";
    let S = x ? ii(d) : d;
    for (; qt(S) && !lu(S); ) {
      const _ = nn(S), A = Do(S);
      _.position === "fixed" ? w = null : (x ? A || w : A || _.position !== "static" || !w || !["absolute", "fixed"].includes(w.position)) ? w = _ : y = y.filter((T) => T !== S), S = ii(S);
    }
    return h.set(d, y), y;
  }(i, this._c) : [].concat(r), f = [...o, u], c = f[0], v = f.reduce((d, h) => {
    const m = Cc(i, h, l);
    return d.top = Qr(m.top, d.top), d.right = Tc(m.right, d.right), d.bottom = Tc(m.bottom, d.bottom), d.left = Qr(m.left, d.left), d;
  }, Cc(i, c, l));
  return { width: v.right - v.left, height: v.bottom - v.top, x: v.left, y: v.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
  let { rect: i, offsetParent: r, strategy: u } = t;
  const l = Yt(r), o = Pn(r);
  if (r === o)
    return i;
  let f = { scrollLeft: 0, scrollTop: 0 }, c = { x: 1, y: 1 };
  const v = { x: 0, y: 0 };
  if ((l || !l && u !== "fixed") && ((Ln(r) !== "body" || Ba(o)) && (f = ka(r)), Yt(r))) {
    const d = Yn(r);
    c = gr(r), v.x = d.x + r.clientLeft, v.y = d.y + r.clientTop;
  }
  return { width: i.width * c.x, height: i.height * c.y, x: i.x * c.x - f.scrollLeft * c.x + v.x, y: i.y * c.y - f.scrollTop * c.y + v.y };
}, isElement: qt, getDimensions: function(t) {
  return Jd(t);
}, getOffsetParent: Oc, getDocumentElement: Pn, getScale: gr, async getElementRects(t) {
  let { reference: i, floating: r, strategy: u } = t;
  const l = this.getOffsetParent || Oc, o = this.getDimensions;
  return { reference: CT(i, await l(r), u), floating: { x: 0, y: 0, ...await o(r) } };
}, getClientRects: (t) => Array.from(t.getClientRects()), isRTL: (t) => nn(t).direction === "rtl" };
function OT(t, i, r, u) {
  u === void 0 && (u = {});
  const { ancestorScroll: l = !0, ancestorResize: o = !0, elementResize: f = !0, animationFrame: c = !1 } = u, v = l && !c, d = v || o ? [...qt(t) ? ei(t) : t.contextElement ? ei(t.contextElement) : [], ...ei(i)] : [];
  d.forEach((w) => {
    v && w.addEventListener("scroll", r, { passive: !0 }), o && w.addEventListener("resize", r);
  });
  let h, m = null;
  f && (m = new ResizeObserver(() => {
    r();
  }), qt(t) && !c && m.observe(t), qt(t) || !t.contextElement || c || m.observe(t.contextElement), m.observe(i));
  let y = c ? Yn(t) : null;
  return c && function w() {
    const x = Yn(t);
    !y || x.x === y.x && x.y === y.y && x.width === y.width && x.height === y.height || r(), y = x, h = requestAnimationFrame(w);
  }(), r(), () => {
    var w;
    d.forEach((x) => {
      v && x.removeEventListener("scroll", r), o && x.removeEventListener("resize", r);
    }), (w = m) == null || w.disconnect(), m = null, c && cancelAnimationFrame(h);
  };
}
const IT = (t, i, r) => {
  const u = /* @__PURE__ */ new Map(), l = { platform: ET, ...r }, o = { ...l.platform, _c: u };
  return pT(t, i, { ...l, platform: o });
};
function Bo(t) {
  var i;
  return (i = t == null ? void 0 : t.$el) != null ? i : t;
}
function FT(t) {
  return {
    name: "arrow",
    options: t,
    fn(i) {
      const r = Bo(j(t.element));
      return r == null ? {} : gT({
        element: r,
        padding: t.padding
      }).fn(i);
    }
  };
}
function PT(t, i, r) {
  r === void 0 && (r = {});
  const u = r.whileElementsMounted, l = k(() => {
    var P;
    return (P = j(r.open)) != null ? P : !0;
  }), o = k(() => j(r.middleware)), f = k(() => {
    var P;
    return (P = j(r.placement)) != null ? P : "bottom";
  }), c = k(() => {
    var P;
    return (P = j(r.strategy)) != null ? P : "absolute";
  }), v = k(() => Bo(t.value)), d = k(() => Bo(i.value)), h = z(null), m = z(null), y = z(c.value), w = z(f.value), x = xa({}), S = z(!1);
  let _;
  function A() {
    v.value == null || d.value == null || IT(v.value, d.value, {
      middleware: o.value,
      placement: f.value,
      strategy: c.value
    }).then((P) => {
      h.value = P.x, m.value = P.y, y.value = P.strategy, w.value = P.placement, x.value = P.middlewareData, S.value = !0;
    });
  }
  function T() {
    typeof _ == "function" && (_(), _ = void 0);
  }
  function E() {
    if (T(), u === void 0) {
      A();
      return;
    }
    if (v.value != null && d.value != null) {
      _ = u(v.value, d.value, A);
      return;
    }
  }
  function F() {
    l.value || (S.value = !1);
  }
  return Je([o, f, c], A, {
    flush: "sync"
  }), Je([v, d], E, {
    flush: "sync"
  }), Je(l, F, {
    flush: "sync"
  }), Ky() && qy(T), {
    x: pr(h),
    y: pr(m),
    strategy: pr(y),
    placement: pr(w),
    middlewareData: pr(x),
    isPositioned: pr(S),
    update: A
  };
}
var LT = Object.defineProperty, RT = (t, i, r) => i in t ? LT(t, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[i] = r, DT = (t, i, r) => (RT(t, typeof i != "symbol" ? i + "" : i, r), r);
function ko(t) {
  if (t == null || t.value == null)
    return null;
  const i = t.value.$el ?? t.value;
  return i.$el ? ko(z(i)) : i;
}
class MT {
  constructor() {
    DT(this, "current", this.detect());
  }
  set(i) {
    this.current !== i && (this.current = i);
  }
  reset() {
    this.set(this.detect());
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
const nv = new MT();
function rv(t) {
  return t.reduce((i, r) => r.type === rt ? i.concat(rv(r.children)) : i.concat(r), []);
}
function Ic(t) {
  return t == null ? !1 : typeof t.type == "string" || typeof t.type == "object" || typeof t.type == "function";
}
function Fc(t) {
  return t = j(t), t && (t == null ? void 0 : t.nodeType) !== Node.COMMENT_NODE;
}
function BT(t, i, r, u, l) {
  Je([
    () => l.offset,
    () => l.flip,
    () => l.shift,
    () => l.autoPlacement,
    () => l.arrow,
    () => l.hide,
    () => l.middleware
  ], () => {
    const o = [];
    (typeof l.offset == "number" || typeof l.offset == "object" || typeof l.offset == "function") && o.push(ST(l.offset)), (l.flip === !0 || typeof l.flip == "number" || typeof l.flip == "object") && o.push(xT({
      padding: typeof l.flip == "number" ? l.flip : void 0,
      ...typeof l.flip == "object" ? l.flip : {}
    })), (l.shift === !0 || typeof l.shift == "number" || typeof l.shift == "object") && o.push(AT({
      padding: typeof l.shift == "number" ? l.shift : void 0,
      ...typeof l.shift == "object" ? l.shift : {}
    })), (l.autoPlacement === !0 || typeof l.autoPlacement == "object") && o.push(wT(
      typeof l.autoPlacement == "object" ? l.autoPlacement : void 0
    )), (l.arrow === !0 || typeof l.arrow == "number") && o.push(FT({
      element: u,
      padding: l.arrow === !0 ? 0 : l.arrow
    })), o.push(...typeof l.middleware == "function" ? l.middleware({
      referenceEl: i,
      floatingEl: r
    }) : l.middleware || []), (l.hide === !0 || typeof l.hide == "object") && o.push(_T(
      typeof l.hide == "object" ? l.hide : void 0
    )), t.value = o;
  }, { immediate: !0 });
}
function kT(t, i, r) {
  let u = () => {
  };
  Ie(() => {
    if (t && nv.isClient && typeof ResizeObserver < "u" && i.value && i.value instanceof Element) {
      const l = new ResizeObserver(([o]) => {
        r.value = o.borderBoxSize.reduce((f, { inlineSize: c }) => f + c, 0);
      });
      l.observe(i.value), u = () => {
        l.disconnect(), r.value = null;
      };
    }
  }), Yy(() => {
    u();
  });
}
const VT = (t) => {
  switch (t) {
    case "top":
      return "origin-bottom";
    case "bottom":
      return "origin-top";
    case "left":
      return "origin-right";
    case "right":
      return "origin-left";
    case "top-start":
    case "right-end":
      return "origin-bottom-left";
    case "top-end":
    case "left-end":
      return "origin-bottom-right";
    case "right-start":
    case "bottom-start":
      return "origin-top-left";
    case "left-start":
    case "bottom-end":
      return "origin-top-right";
    default:
      return "";
  }
};
function NT(t, i) {
  const r = k(() => {
    if (typeof t.originClass == "function")
      return t.originClass(i.value);
    if (typeof t.originClass == "string")
      return t.originClass;
    if (t.tailwindcssOriginClass)
      return VT(i.value);
  }), u = k(
    () => t.enter || r.value ? `${t.enter || ""} ${r.value || ""}` : void 0
  ), l = k(
    () => t.leave || r.value ? `${t.leave || ""} ${r.value || ""}` : void 0
  );
  return { originClassRef: r, enterActiveClassRef: u, leaveActiveClassRef: l };
}
[
  "[contentEditable=true]",
  "[tabindex]",
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "iframe",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])"
].map(
  // TODO: Remove this once JSDOM fixes the issue where an element that is
  // "hidden" can be the document.activeElement, because this is not possible
  // in real browsers.
  process.env.NODE_ENV === "test" ? (t) => `${t}:not([tabindex='-1']):not([style*='display: none'])` : (t) => `${t}:not([tabindex='-1'])`
).join(",");
const UT = Symbol("ReferenceContext"), zT = Symbol("FloatingContext"), WT = Symbol("ArrowContext"), q = {
  as: {
    type: [String, Function],
    default: "template"
  },
  floatingAs: {
    type: [String, Function],
    default: "div"
  },
  show: {
    type: Boolean,
    default: null
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  strategy: {
    type: String,
    default: "absolute"
  },
  offset: [Number, Function, Object],
  shift: {
    type: [Boolean, Number, Object],
    default: !1
  },
  flip: {
    type: [Boolean, Number, Object],
    default: !1
  },
  arrow: {
    type: [Boolean, Number],
    default: !1
  },
  autoPlacement: {
    type: [Boolean, Object],
    default: !1
  },
  hide: {
    type: [Boolean, Object],
    default: !1
  },
  autoUpdate: {
    type: [Boolean, Object],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 9999
  },
  transitionName: String,
  transitionType: String,
  enter: String,
  enterFrom: String,
  enterTo: String,
  leave: String,
  leaveFrom: String,
  leaveTo: String,
  originClass: [String, Function],
  tailwindcssOriginClass: {
    type: Boolean,
    default: !1
  },
  portal: {
    type: Boolean,
    default: !1
  },
  transform: {
    type: Boolean,
    default: !0
  },
  adaptiveWidth: {
    type: Boolean,
    default: !1
  },
  composable: {
    type: Boolean,
    default: !1
  },
  dialog: {
    type: Boolean,
    default: !1
  },
  middleware: {
    type: [Array, Function],
    default: () => []
  }
};
function HT(t, i, r, u) {
  const { referenceRef: l } = u, o = i, f = tn(r, {
    ref: l
  }), c = Vo(
    t,
    o.as === "template" ? f : {}
  );
  return o.as === "template" ? c : typeof o.as == "string" ? Te(o.as, f, [c]) : Te(o.as, f, () => [c]);
}
function GT(t, i, r, u) {
  const { floatingRef: l, props: o, mounted: f, show: c, x: v, y: d, placement: h, strategy: m, referenceElWidth: y, updateFloating: w } = u, x = tn(
    o,
    i
  ), { enterActiveClassRef: S, leaveActiveClassRef: _ } = i, A = {
    enterActiveClass: S.value,
    enterFromClass: x.enterFrom,
    enterToClass: x.enterTo,
    leaveActiveClass: _.value,
    leaveFromClass: x.leaveFrom,
    leaveToClass: x.leaveTo
  }, T = {
    name: x.transitionName,
    type: x.transitionType,
    appear: !0,
    ...x.transitionName ? {} : A,
    onBeforeEnter() {
      c.value = !0;
    },
    onAfterLeave() {
      c.value = !1;
    }
  }, E = {
    enter: S.value,
    enterFrom: x.enterFrom,
    enterTo: x.enterTo,
    leave: _.value,
    leaveFrom: x.leaveFrom,
    leaveTo: x.leaveTo,
    onBeforeEnter: T.onBeforeEnter,
    onAfterLeave: T.onAfterLeave
  }, F = {
    style: {
      // If enable dialog mode, then set `transform` to false.
      ...!x.dialog && x.transform ? {
        position: m.value,
        zIndex: x.zIndex,
        top: "0px",
        left: "0px",
        right: "auto",
        bottom: "auto",
        transform: `translate(${Math.round(v.value || 0)}px,${Math.round(d.value || 0)}px)`
      } : {
        position: m.value,
        zIndex: x.zIndex,
        top: `${d.value || 0}px`,
        left: `${v.value || 0}px`
      },
      width: x.adaptiveWidth && typeof y.value == "number" ? `${y.value}px` : void 0
    }
  };
  function P(M) {
    return x.portal ? Te(Yo, () => M) : M;
  }
  function R(M) {
    const H = tn(
      F,
      r,
      x.dialog ? {} : { ref: l }
    );
    return x.as === "template" ? M : typeof x.as == "string" ? Te(x.as, H, M) : Te(x.as, H, () => M);
  }
  function V() {
    function M() {
      var H;
      const K = x.as === "template" ? tn(
        F,
        r,
        x.dialog ? {} : { ref: l }
      ) : null, Y = Vo(t, K);
      return ((H = Y.props) == null ? void 0 : H.unmount) === !1 ? (w(), Y) : typeof x.show != "boolean" || x.show ? Y : Oe();
    }
    return nv.isServer ? f.value && x.show ? M() : Oe() : x.transitionChild ? Te(pa, {
      key: `placement-${h.value}`,
      ...x.dialog ? { ref: l } : {},
      as: "template",
      ...E
    }, M) : Te(Uo, {
      ...x.dialog ? { ref: l } : {},
      ...T
    }, M);
  }
  return P(
    R(
      V()
    )
  );
}
function jT(t, i, r, u, l) {
  const o = z(!1), f = Vf(u, "placement"), c = Vf(u, "strategy"), v = xa({}), d = z(null), h = z(void 0), m = z(void 0), y = k(() => ko(i)), w = k(() => ko(r)), x = k(
    () => Fc(y) && Fc(w)
  ), { x: S, y: _, placement: A, strategy: T, middlewareData: E, update: F } = PT(y, w, {
    placement: f,
    strategy: c,
    middleware: v,
    whileElementsMounted: () => {
    }
  }), P = z(null), { enterActiveClassRef: R, leaveActiveClassRef: V } = NT(u, A);
  Ie(() => {
    o.value = !0;
  });
  function M() {
    x.value && (F(), l("update"));
  }
  Je([f, c, v], M, { flush: "sync" }), BT(
    v,
    y,
    w,
    d,
    u
  ), Je(E, () => {
    const ne = E.value.arrow;
    h.value = ne == null ? void 0 : ne.x, m.value = ne == null ? void 0 : ne.y;
  }), kT(u.adaptiveWidth, y, P), Je(t, async (ne, J, oe) => {
    if (await ze(), t.value && x.value && u.autoUpdate) {
      const de = OT(
        y.value,
        w.value,
        M,
        typeof u.autoUpdate == "object" ? u.autoUpdate : void 0
      );
      l("show"), oe(() => {
        de(), l("hide");
      });
    }
  }, { flush: "post", immediate: !0 });
  const H = z(!0);
  Je(y, () => {
    !(y.value instanceof Element) && x.value && H.value && (H.value = !1, window.requestAnimationFrame(() => {
      H.value = !0, M();
    }));
  }, { flush: "sync" });
  const K = {
    referenceRef: i,
    placement: A
  }, Y = {
    floatingRef: r,
    props: u,
    mounted: o,
    show: t,
    x: S,
    y: _,
    placement: A,
    strategy: T,
    referenceElWidth: P,
    updateFloating: M
  }, ee = {
    ref: d,
    placement: A,
    x: h,
    y: m
  };
  return et(WT, ee), { referenceApi: K, floatingApi: Y, arrowApi: ee, x: S, y: _, placement: A, strategy: T, referenceEl: y, floatingEl: w, middlewareData: E, update: M, enterActiveClassRef: R, leaveActiveClassRef: V };
}
const iv = {
  name: "Float",
  inheritAttrs: !1,
  props: q,
  emits: ["show", "hide", "update"],
  setup(t, { emit: i, slots: r, attrs: u }) {
    const l = z(t.show ?? !1), o = z(null), f = z(null), {
      referenceApi: c,
      floatingApi: v,
      placement: d,
      enterActiveClassRef: h,
      leaveActiveClassRef: m
    } = jT(l, o, f, t, i);
    function y(x) {
      return t.as === "template" ? x : typeof t.as == "string" ? Te(t.as, u, x) : Te(t.as, u, () => x);
    }
    const w = {
      placement: d.value
    };
    return t.composable || t.dialog ? (et(UT, c), et(zT, v), () => {
      if (r.default)
        return y(r.default(w));
    }) : () => {
      if (!r.default)
        return;
      const [x, S] = rv(r.default(w)).filter(Ic);
      if (!Ic(x))
        return;
      const _ = HT(
        x,
        { as: "template" },
        {},
        c
      ), A = GT(
        S,
        {
          as: t.floatingAs,
          enterActiveClassRef: h,
          leaveActiveClassRef: m
        },
        {},
        v
      );
      return y([
        _,
        A
      ]);
    };
  }
};
q.as;
q.as, q.transitionName, q.transitionType, q.enter, q.enterFrom, q.enterTo, q.leave, q.leaveFrom, q.leaveTo, q.originClass, q.tailwindcssOriginClass;
({
  ...q.as
});
q.as, q.show, q.placement, q.strategy, q.offset, q.shift, q.flip, q.arrow, q.autoPlacement, q.hide, q.autoUpdate, q.zIndex, q.transitionName, q.transitionType, q.enter, q.enterFrom, q.enterTo, q.leave, q.leaveFrom, q.leaveTo, q.originClass, q.tailwindcssOriginClass, q.portal, q.transform, q.middleware;
q.as, q.placement, q.strategy, q.offset, q.shift, {
  ...q.flip
}, q.arrow, q.autoPlacement, q.hide, q.autoUpdate, q.zIndex, q.transitionName, q.transitionType, q.enter, q.enterFrom, q.enterTo, q.leave, q.leaveFrom, q.leaveTo, q.originClass, q.tailwindcssOriginClass, q.transform, q.middleware;
q.as, q.placement, q.strategy, q.offset, q.shift, q.flip, q.arrow, q.autoPlacement, q.hide, q.autoUpdate, q.zIndex, q.transitionName, q.transitionType, q.enter, q.enterFrom, q.enterTo, q.leave, q.leaveFrom, q.leaveTo, q.originClass, q.tailwindcssOriginClass, q.transform, q.middleware;
const KT = { class: "no-scrollbar max-h-[300px] overflow-auto" }, qT = ["onClick"], QC = /* @__PURE__ */ Q({
  __name: "TuneMenu",
  props: {
    items: null,
    selected: { default: "" },
    placement: { default: "bottom-start" }
  },
  emits: ["select"],
  setup(t, { emit: i }) {
    return (r, u) => (W(), ve(j(Qb), {
      as: "div",
      class: "inline-block h-full text-left"
    }, {
      default: le(() => [
        se(j(iv), {
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95",
          placement: t.placement,
          offset: 8,
          shift: 16,
          flip: 16,
          "z-index": 50
        }, {
          default: le(() => [
            se(j(ew), { class: "h-full" }, {
              default: le(() => [
                r.$slots.button ? dt(r.$slots, "button", { key: 0 }) : (W(), ve(Sa, {
                  key: 1,
                  class: "flex items-center"
                }, {
                  default: le(() => [
                    vt(De(t.selected) + " ", 1),
                    se(j(Zn), {
                      class: "-mr-1 ml-1 text-sm",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }))
              ]),
              _: 3
            }),
            se(j(tw), { class: "tune-menu-list overflow-hidden outline-none" }, {
              default: le(() => [
                te("div", KT, [
                  (W(!0), re(rt, null, rn(t.items, (l) => (W(), ve(j(nw), {
                    key: l.text
                  }, {
                    default: le(({ active: o }) => [
                      te("div", {
                        class: Ee([
                          { active: o },
                          "tune-menu-list-item cursor-pointer whitespace-nowrap px-3 py-2"
                        ]),
                        onClick: (f) => i("select", l.action)
                      }, [
                        dt(r.$slots, "item", {
                          key: l,
                          item: l
                        }, () => [
                          vt(De(l.text), 1)
                        ])
                      ], 10, qT)
                    ]),
                    _: 2
                  }, 1024))), 128))
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["placement"])
      ]),
      _: 3
    }));
  }
}), YT = { class: "tune-popover overflow-hidden" }, ZT = { class: "no-scrollbar max-h-[85vh] overflow-y-auto overscroll-contain" }, eE = /* @__PURE__ */ Q({
  __name: "TunePopover",
  props: {
    label: { default: "" },
    placement: { default: "bottom-end" }
  },
  setup(t) {
    return (i, r) => (W(), ve(j(pd), null, {
      default: le(() => [
        se(j(iv), {
          enter: "transition ease-out duration-100",
          "enter-from": "transform opacity-0 scale-95",
          "enter-to": "transform opacity-100 scale-100",
          leave: "transition ease-in duration-75",
          "leave-from": "transform opacity-100 scale-100",
          "leave-to": "transform opacity-0 scale-95",
          placement: t.placement,
          offset: 4,
          shift: 16,
          flip: 16,
          "z-index": 50,
          portal: ""
        }, {
          default: le(() => [
            se(j(aw), { class: "outline-none" }, {
              default: le(() => [
                i.$slots.button ? dt(i.$slots, "button", { key: 0 }) : (W(), ve(Sa, {
                  key: 1,
                  class: "flex items-center gap-1"
                }, {
                  default: le(() => [
                    te("span", null, De(t.label), 1),
                    se(j(Zn), {
                      class: "text-sm",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }))
              ]),
              _: 3
            }),
            se(j(lw), { class: "w-screen max-w-xs outline-none sm:max-w-sm" }, {
              default: le(({ close: u }) => [
                te("div", YT, [
                  te("div", ZT, [
                    dt(i.$slots, "content", { close: u })
                  ])
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["placement"])
      ]),
      _: 3
    }));
  }
}), JT = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, XT = /* @__PURE__ */ te("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1), QT = [
  XT
];
function eC(t, i) {
  return W(), re("svg", JT, QT);
}
const tC = { name: "heroicons-x-mark", render: eC }, nC = /* @__PURE__ */ te("div", { class: "tune-modal-backdrop fixed inset-0" }, null, -1), rC = { class: "fixed inset-0 overflow-y-auto" }, iC = { class: "flex min-h-full items-center justify-center p-4 text-center" }, aC = { class: "absolute right-4 top-4" }, lC = /* @__PURE__ */ te("span", { class: "sr-only" }, "Close", -1), oC = { class: "mt-4" }, uC = {
  key: 0,
  class: "mt-4"
}, tE = /* @__PURE__ */ Q({
  __name: "TuneModal",
  props: {
    open: { type: Boolean },
    title: null
  },
  emits: ["close"],
  setup(t) {
    return (i, r) => (W(), ve(j(wd), {
      appear: "",
      show: t.open,
      as: "template"
    }, {
      default: le(() => [
        se(j(zb), {
          as: "div",
          class: "relative z-10",
          onClose: r[1] || (r[1] = (u) => i.$emit("close"))
        }, {
          default: le(() => [
            se(j(pa), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: le(() => [
                nC
              ]),
              _: 1
            }),
            te("div", rC, [
              te("div", iC, [
                se(j(pa), {
                  as: "template",
                  enter: "duration-300 ease-out",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: le(() => [
                    se(j(Wb), { class: "tune-modal-panel w-full transform overflow-hidden align-middle transition-all" }, {
                      default: le(() => [
                        te("div", aC, [
                          te("button", {
                            onClick: r[0] || (r[0] = (u) => i.$emit("close"))
                          }, [
                            lC,
                            se(j(tC), {
                              class: "text-md",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        se(j(Hb), {
                          as: "h3",
                          class: "tune-modal-title"
                        }, {
                          default: le(() => [
                            vt(De(t.title), 1)
                          ]),
                          _: 1
                        }),
                        te("div", oC, [
                          dt(i.$slots, "default")
                        ]),
                        i.$slots.footer ? (W(), re("div", uC, [
                          dt(i.$slots, "footer")
                        ])) : Oe("", !0)
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), sC = ["for"], fC = { class: "flex items-center gap-[10px]" }, cC = ["id", "checked", "name"], nE = /* @__PURE__ */ Q({
  __name: "TuneCheckbox",
  props: {
    modelValue: { type: Boolean },
    id: null,
    label: null,
    hint: null,
    definition: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    return (r, u) => {
      var l, o;
      return W(), re("div", null, [
        te("label", { for: t.id }, [
          te("div", fC, [
            te("input", {
              id: t.id,
              checked: t.modelValue,
              name: t.label || ((l = t.definition) == null ? void 0 : l.title),
              type: "checkbox",
              class: "tune-input-checkbox",
              onInput: u[0] || (u[0] = (f) => i("update:modelValue", f.target.checked))
            }, null, 40, cC),
            t.hint || (o = t.definition) != null && o.description ? (W(), ve(Ut, {
              key: 0,
              class: "!mb-0"
            }, {
              default: le(() => [
                vt(De(t.hint || t.definition.description), 1)
              ]),
              _: 1
            })) : Oe("", !0)
          ])
        ], 8, sC)
      ]);
    };
  }
}), dC = ["for"], vC = { class: "flex items-center gap-[10px]" }, pC = ["id", "name", "checked", "value"], rE = /* @__PURE__ */ Q({
  __name: "TuneRadio",
  props: {
    modelValue: null,
    value: null,
    id: null,
    label: null,
    hint: null,
    definition: null
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t, u = (l) => {
      l.target && l.target.checked && i("update:modelValue", r.value);
    };
    return (l, o) => {
      var f, c;
      return W(), re("div", null, [
        te("label", {
          for: t.id || t.value
        }, [
          te("div", vC, [
            te("input", {
              id: t.id || t.value,
              type: "radio",
              name: t.label || ((f = t.definition) == null ? void 0 : f.title),
              checked: t.modelValue === t.value,
              value: t.value,
              class: "tune-input-radio",
              onInput: u
            }, null, 40, pC),
            t.hint || (c = t.definition) != null && c.description ? (W(), ve(Ut, {
              key: 0,
              class: "!mb-0"
            }, {
              default: le(() => [
                vt(De(t.hint || t.definition.description), 1)
              ]),
              _: 1
            })) : Oe("", !0)
          ])
        ], 8, dC)
      ]);
    };
  }
}), hC = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, mC = /* @__PURE__ */ te("path", {
  fill: "currentColor",
  d: "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003a12.754 12.754 0 0 1-4.339 2.708a18.991 18.991 0 0 1-.214 4.772a17.165 17.165 0 0 0 5.498-2.477Zm-7.087 2.798a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347c-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647a17.385 17.385 0 0 0 5.268 0Zm-4.862 1.569a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774a12.753 12.753 0 0 1-4.34-2.708a9.711 9.711 0 0 0-.944 5.004a17.165 17.165 0 0 0 5.498 2.477Zm13.579-.478a9.765 9.765 0 0 1-7.478 6.817a18.64 18.64 0 0 0 1.988-4.718a18.627 18.627 0 0 0 5.49-2.098Zm-18.712 0a18.619 18.619 0 0 0 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718a9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986a11.267 11.267 0 0 1-3.746 2.504a18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121a11.281 11.281 0 0 1-5.61 0A17.151 17.151 0 0 1 12 2.276Zm-1.878.154a18.629 18.629 0 0 0-2.37 6.49a11.266 11.266 0 0 1-3.746-2.504a9.754 9.754 0 0 1 6.116-3.985Z"
}, null, -1), gC = [
  mC
];
function yC(t, i) {
  return W(), re("svg", hC, gC);
}
const bC = { name: "heroicons-globe-alt-solid", render: yC }, iE = /* @__PURE__ */ Q({
  __name: "TuneInputUrl",
  props: {
    modelValue: null,
    placeholder: null,
    label: null,
    error: null,
    hint: null,
    disabled: { type: Boolean },
    maxLength: null
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = z();
    function l() {
      var o;
      (o = u == null ? void 0 : u.value) == null || o.forceShowError();
    }
    return i({
      forceShowError: l
    }), (o, f) => (W(), ve(Ia, {
      ref_key: "inputRef",
      ref: u,
      label: t.label,
      "model-value": t.modelValue,
      error: t.error,
      hint: t.hint,
      disabled: t.disabled,
      placeholder: t.placeholder,
      "max-length": t.maxLength,
      class: "!pl-[40px]",
      "onUpdate:modelValue": f[0] || (f[0] = (c) => r("update:modelValue", c))
    }, {
      before: le(() => [
        se(j(bC), { class: "text-sm" })
      ]),
      _: 1
    }, 8, ["label", "model-value", "error", "hint", "disabled", "placeholder", "max-length"]));
  }
}), wC = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
}, xC = /* @__PURE__ */ te("path", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5a17.92 17.92 0 0 1-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
}, null, -1), _C = [
  xC
];
function SC(t, i) {
  return W(), re("svg", wC, _C);
}
const $C = { name: "heroicons-globe-alt", render: SC }, AC = {
  width: "1.2em",
  height: "1.2em",
  fill: "currentColor",
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, TC = /* @__PURE__ */ te("path", { d: "M25.2688 9.53141C25.2846 9.76543 25.2846 9.99945 25.2846 10.2356C25.2846 17.432 19.9588 25.7316 10.2203 25.7316V25.7273C7.34353 25.7316 4.52651 24.884 2.10474 23.2857C2.52304 23.3375 2.94345 23.3634 3.3649 23.3645C5.74893 23.3666 8.06482 22.5438 9.94038 21.0286C7.67482 20.9844 5.68812 19.4648 4.99409 17.2465C5.78772 17.404 6.60546 17.3716 7.38441 17.1527C4.91441 16.6394 3.1374 14.407 3.1374 11.8145C3.1374 11.7907 3.1374 11.7681 3.1374 11.7454C3.87337 12.1671 4.6974 12.4011 5.5403 12.427C3.21393 10.8277 2.49683 7.64416 3.90167 5.15514C6.58974 8.55759 10.5558 10.626 14.8133 10.8449C14.3866 8.95337 14.9695 6.97122 16.345 5.64151C18.4774 3.57955 21.8312 3.68524 23.8357 5.87769C25.0214 5.6372 26.1579 5.18965 27.1979 4.55553C26.8026 5.81622 25.9755 6.8871 24.8705 7.56759C25.9199 7.44034 26.9452 7.15132 27.9108 6.71024C27.2 7.80592 26.3047 8.76034 25.2688 9.53141Z" }, null, -1), CC = [
  TC
];
function EC(t, i) {
  return W(), re("svg", AC, CC);
}
const OC = { name: "tune-twitter", render: EC }, IC = {
  width: "1.2em",
  height: "1.2em",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, FC = /* @__PURE__ */ te("path", {
  "fill-rule": "evenodd",
  d: "M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385c.6.105.825-.255.825-.57c0-.285-.015-1.23-.015-2.235c-3.015.555-3.795-.735-4.035-1.41c-.135-.345-.72-1.41-1.23-1.695c-.42-.225-1.02-.78-.015-.795c.945-.015 1.62.87 1.845 1.23c1.08 1.815 2.805 1.305 3.495.99c.105-.78.42-1.305.765-1.605c-2.67-.3-5.46-1.335-5.46-5.925c0-1.305.465-2.385 1.23-3.225c-.12-.3-.54-1.53.12-3.18c0 0 1.005-.315 3.3 1.23c.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23c.66 1.65.24 2.88.12 3.18c.765.84 1.23 1.905 1.23 3.225c0 4.605-2.805 5.625-5.475 5.925c.435.375.81 1.095.81 2.22c0 1.605-.015 2.895-.015 3.3c0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12Z",
  "clip-rule": "evenodd"
}, null, -1), PC = [
  FC
];
function LC(t, i) {
  return W(), re("svg", IC, PC);
}
const RC = { name: "tune-github", render: LC }, DC = {
  width: "1.2em",
  height: "1.2em",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1080 1080"
}, MC = /* @__PURE__ */ te("path", {
  class: "st0",
  d: `M536.6-1C238.3,0.4-2.3,243.2-1,541.4c1.4,298.2,244.2,538.9,542.4,537.6c298.2-1.4,538.9-244.2,537.6-542.4
				C1077.6,238.3,834.8-2.3,536.6-1z M468.2,512.5c-53.3,0-96.6-43.2-96.6-96.5c0-53.3,43.2-96.5,96.6-96.5
				c53.3,0,96.5,43.2,96.5,96.5C564.7,469.3,521.5,512.5,468.2,512.5z M545.2,616.9l0.5-0.6l0.5-0.6c27.6,17.8,59,24,90.4,25
				c31.5,0.8,63.5-1.5,95.1-7.9c31.5-6.5,62.5-16.2,92.4-28.6c16.8-6.9,33.5-14.5,49.4-23.4c0.1-0.1,0.2-0.1,0.3-0.2
				c9.9-6,19.6-12.2,29.1-18.7c2.1-1.5,4.1-3,6-4.6l0.2,0.3l0.8,1c-24.3,22.1-53.2,38.5-82.6,53c-29.7,14-60.7,25.5-92.7,33.8
				c-31.9,8.2-65.2,14.5-98.9,11.4C602.5,653.7,567.5,642.1,545.2,616.9z M793,512.5c0-11.6,9.3-20.9,20.8-21
				c11.6,0,20.9,9.3,21,20.8c0,11.5-9.3,21-20.8,21C802.5,533.4,793,524.1,793,512.5z M627.6,1030.5
				C606.7,884.3,734.3,741.2,806.3,668c16.3-16.6,41.6-39.5,65.1-63.8c93.4-87.3,112-191.7-79.2-243.9
				c-36.2-10.5-73.8-25.4-111.8-40.4c-1.2-3.5-2.6-6.8-4.1-9.9c-4.4-7.5-12-16.2-23.6-26c-24.9-21.6-71.5-21-111.8-11.5
				c-44.6-10.5-88.5-14.2-130.8-4.1c-184.9,50.9-214.6,141.1-221.8,249.8c-9.8,117.4-15.5,204.9-60,304.9
				C72.8,743,40.1,646,39.7,541.2C38.5,265.5,261,40.9,536.8,39.7c275.8-1.2,500.3,221.3,501.6,497.1
				C1039.4,783.1,862,988.6,627.6,1030.5z`
}, null, -1), BC = [
  MC
];
function kC(t, i) {
  return W(), re("svg", DC, BC);
}
const VC = { name: "tune-coingecko", render: kC }, aE = /* @__PURE__ */ Q({
  __name: "TuneInputSocial",
  props: {
    modelValue: null,
    error: null,
    placeholder: null,
    maxLength: null,
    label: null,
    disabled: { type: Boolean },
    icon: null
  },
  emits: ["update:modelValue"],
  setup(t, { expose: i, emit: r }) {
    const u = z();
    function l() {
      var o;
      (o = u == null ? void 0 : u.value) == null || o.forceShowError();
    }
    return i({
      forceShowError: l
    }), (o, f) => (W(), ve(Ia, {
      ref_key: "inputRef",
      ref: u,
      label: t.label,
      "model-value": t.modelValue,
      error: t.error,
      placeholder: t.placeholder,
      "max-length": t.maxLength,
      disabled: t.disabled,
      class: "!pl-[40px]",
      "onUpdate:modelValue": f[0] || (f[0] = (c) => r("update:modelValue", c))
    }, {
      before: le(() => [
        t.icon === "twitter" ? (W(), ve(j(OC), {
          key: 0,
          class: "text-[16px]"
        })) : Oe("", !0),
        t.icon === "github" ? (W(), ve(j(RC), {
          key: 1,
          class: "text-[16px]"
        })) : Oe("", !0),
        t.icon === "earth" ? (W(), ve(j($C), {
          key: 2,
          class: "text-[16px]"
        })) : Oe("", !0),
        t.icon === "coingecko" ? (W(), ve(j(VC), {
          key: 3,
          class: "text-[16px]"
        })) : Oe("", !0)
      ]),
      _: 1
    }, 8, ["label", "model-value", "error", "placeholder", "max-length", "disabled"]));
  }
}), NC = { class: "w-full" }, lE = /* @__PURE__ */ Q({
  __name: "TuneButtonSelect",
  props: {
    modelValue: null,
    label: null,
    hint: null,
    disabled: { type: Boolean },
    tooltip: null,
    definition: null
  },
  emits: ["select"],
  setup(t, { emit: i }) {
    return (r, u) => {
      var o, f;
      const l = No("tippy");
      return W(), re("div", NC, [
        t.label || (o = t.definition) != null && o.title ? (W(), ve(Ut, {
          key: 0,
          hint: t.hint || ((f = t.definition) == null ? void 0 : f.description)
        }, {
          default: le(() => [
            vt(De(t.label || t.definition.title), 1)
          ]),
          _: 1
        }, 8, ["hint"])) : Oe("", !0),
        _a((W(), ve(Sa, {
          class: Ee([[r.$attrs.class, { disabled: t.disabled }], "tune-button-select"]),
          disabled: t.disabled,
          onClick: u[0] || (u[0] = (c) => t.disabled ? null : i("select"))
        }, {
          default: le(() => [
            te("span", null, De(t.modelValue), 1),
            se(j(Zn), { class: "absolute inset-y-[12px] right-[14px] text-xs" })
          ]),
          _: 1
        }, 8, ["class", "disabled"])), [
          [l, { content: t.tooltip }]
        ])
      ]);
    };
  }
}), UC = ["disabled", "value"], zC = ["value"], oE = /* @__PURE__ */ Q({
  __name: "TuneSelect",
  props: {
    items: null,
    modelValue: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    function r(u) {
      i("update:modelValue", u.target.value);
    }
    return (u, l) => (W(), re("select", {
      disabled: t.disabled,
      value: t.modelValue,
      class: Ee(["tune-select form-select", { disabled: t.disabled }]),
      onChange: l[0] || (l[0] = (o) => r(o))
    }, [
      (W(!0), re(rt, null, rn(t.items, (o, f) => (W(), re("option", {
        key: f,
        value: o.value
      }, De(o.label), 9, zC))), 128))
    ], 42, UC));
  }
}), WC = {
  key: 0,
  class: "flex items-center first:-ml-3"
}, HC = ["value", "max", "disabled", "onInput"], GC = { class: "tune-input-duration-label" }, jC = /* @__PURE__ */ Q({
  __name: "TuneInputDuration",
  props: {
    modelValue: null,
    label: null,
    hint: null,
    definition: null,
    hideDay: { type: Boolean },
    hideMinutes: { type: Boolean },
    disabled: { type: Boolean },
    block: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: i }) {
    const r = t, u = k({
      get() {
        return r.hideDay ? {
          hours: Math.floor(r.modelValue / 3600),
          minutes: Math.floor(r.modelValue % 3600 / 60)
        } : r.hideMinutes ? {
          days: Math.floor(r.modelValue / 86400),
          hours: Math.floor(r.modelValue % 86400 / 3600)
        } : {
          days: Math.floor(r.modelValue / 86400),
          hours: Math.floor(r.modelValue % 86400 / 3600),
          minutes: Math.floor(r.modelValue % 3600 / 60)
        };
      },
      set(v) {
        const d = v.minutes || 0, h = v.hours || 0, y = (v.days || 0) * 86400 + h * 3600 + d * 60;
        i("update:modelValue", y);
      }
    }), l = k(() => [
      {
        key: "days",
        label: "Days",
        hidden: r.hideDay || !1,
        max: 365
      },
      {
        key: "hours",
        label: "Hours",
        hidden: !1,
        max: 24
      },
      {
        key: "minutes",
        label: "Minutes",
        hidden: r.hideMinutes || !1,
        max: 60
      }
    ]), o = (v, d) => {
      isNaN(d) || d === void 0 || (u.value = { ...u.value, [v]: d });
    }, f = z([]);
    function c(v) {
      f.value.push(v);
    }
    return (v, d) => {
      var h;
      return W(), re("div", null, [
        se(j(Ut), {
          hint: t.hint || ((h = t.definition) == null ? void 0 : h.description)
        }, {
          default: le(() => {
            var m;
            return [
              vt(De(t.label || ((m = t.definition) == null ? void 0 : m.title)), 1)
            ];
          }),
          _: 1
        }, 8, ["hint"]),
        te("div", {
          class: Ee([
            "tune-input-duration inline-flex overflow-hidden",
            { "w-full": t.block },
            { disabled: t.disabled }
          ]),
          onClick: d[1] || (d[1] = (m) => {
            var y;
            return (y = f.value) == null ? void 0 : y[0].focus();
          })
        }, [
          (W(!0), re(rt, null, rn(j(l), (m) => (W(), re(rt, {
            key: m.label
          }, [
            m.hidden ? Oe("", !0) : (W(), re("div", WC, [
              te("input", {
                ref_for: !0,
                ref: c,
                value: j(u)[m.key],
                type: "number",
                min: "0",
                max: m.max,
                placeholder: "0",
                disabled: t.disabled,
                class: Ee([
                  "bg-transparent py-2 pl-4 pr-1 outline-none",
                  { "cursor-not-allowed bg-transparent": t.disabled }
                ]),
                onClick: d[0] || (d[0] = Zy(() => {
                }, ["stop"])),
                onInput: (y) => {
                  var w;
                  return o(m.key, (w = y.target) == null ? void 0 : w.valueAsNumber);
                }
              }, null, 42, HC),
              te("span", GC, De(m.label), 1)
            ]))
          ], 64))), 128))
        ], 2)
      ]);
    };
  }
});
const KC = (t, i) => {
  const r = t.__vccOpts || t;
  for (const [u, l] of i)
    r[u] = l;
  return r;
}, uE = /* @__PURE__ */ KC(jC, [["__scopeId", "data-v-39c73d23"]]);
export {
  Sa as TuneButton,
  lE as TuneButtonSelect,
  nE as TuneCheckbox,
  ZC as TuneCombobox,
  JC as TuneComboboxMultiple,
  eu as TuneErrorInput,
  Gd as TuneForm,
  Dw as TuneIconHint,
  Ia as TuneInput,
  uE as TuneInputDuration,
  aE as TuneInputSocial,
  iE as TuneInputUrl,
  Ut as TuneLabelInput,
  j3 as TuneListbox,
  uT as TuneListboxMultiple,
  Lc as TuneLoadingSpinner,
  QC as TuneMenu,
  tE as TuneModal,
  eE as TunePopover,
  rE as TuneRadio,
  oE as TuneSelect,
  X3 as TuneSwitch,
  Ed as TuneTag,
  tu as TuneTextarea,
  eT as TuneTextareaArray,
  XC as TuneTextareaJson
};
